var Ru = Object.defineProperty;
var ku = (e, t, n) => t in e ? Ru(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ve = (e, t, n) => (ku(e, typeof t != "symbol" ? t + "" : t, n), n), Au = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var Fr = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
};
var Qn = (e, t, n) => (Au(e, t, "access private method"), n);
import { jsx as h, Fragment as Rr, jsxs as V } from "react/jsx-runtime";
import { motion as Be, AnimatePresence as It, useReducedMotion as Lu, useScroll as bs, useTransform as hn, useIsPresent as Ou, useIsomorphicLayoutEffect as Ur } from "framer-motion";
import { useAssertCookbookDomain as Mu, useDirection as kr } from "@creditornot/cbc-provider";
import * as q from "react";
import mt, { createContext as vs, useRef as ae, useCallback as ne, useEffect as de, useMemo as xt, useLayoutEffect as Pu, useState as Ae, forwardRef as Qe, createElement as ys, isValidElement as _s, useId as Ar, useReducer as Nu } from "react";
import { memoize as xu, isFunction as Es, debounce as Fa, isObject as Ua, throttle as Bu, isUndefined as Ut, isString as ot, omit as Hu, isNumber as xi, isNull as Du, noop as Ss, has as $u, sum as Fu } from "lodash-es";
import Uu, { isAxiosError as Bi } from "axios";
import { formatValidationErrors as zu } from "io-ts-reporters";
import { useQuery as za, QueryClient as Wu, QueryClientProvider as ju, useMutation as qu, useQueryClient as Ts } from "@tanstack/react-query";
import * as E from "io-ts";
import "react-dom";
import { createContext as Wa, useContextSelector as kt } from "use-context-selector";
import { styled as M } from "@linaria/react";
import { usePrevious as Fn, useFirstMountState as Vu, useEffectOnce as Gu, useUnmount as Yu } from "react-use";
import { createCssVars as Xu, clsx as re, assignInlineCssVars as ja, headingFonts as pn, pxToRem as z } from "@creditornot/cb-utils";
import { TextButton as Un, IconButton as sa, Button as la } from "@creditornot/cbc-button";
import Ku from "lottie-web";
import { Cross as Zu, ArrowLeft as ws, CaretRight as Qu, ArrowRight as Ju } from "@creditornot/cb-icons";
import ec from "axios-case-converter";
import { Alert as tc } from "@creditornot/cb-alert";
import { ModalBase as nc } from "@creditornot/cb-modal";
import { ErrorBoundary as rc } from "react-error-boundary";
vs(void 0);
const ac = (e) => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ h(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5313 17.2724L16.1601 13.9012C18.5886 10.3132 17.8931 5.46723 14.5533 2.70717C11.2136 -0.0528816 6.32336 0.176791 3.25702 3.23771C0.190683 6.29862 -0.0476432 11.1885 2.7065 14.5331C5.46064 17.8777 10.3054 18.5818 13.8977 16.1596L17.2689 19.5308C17.8985 20.1438 18.9017 20.1438 19.5313 19.5308C20.1532 18.9065 20.1532 17.8968 19.5313 17.2724ZM9.20008 2.40362C12.9556 2.40362 16.0001 5.44808 16.0001 9.20362C16.0001 12.9592 12.9556 16.0036 9.20008 16.0036C5.44455 16.0036 2.40008 12.9592 2.40008 9.20362C2.40449 5.44991 5.44638 2.40803 9.20008 2.40362ZM8.40008 10.0036H6.40008C5.95826 10.0036 5.60008 9.64545 5.60008 9.20362C5.60008 8.76179 5.95826 8.40362 6.40008 8.40362H8.40008V6.40362C8.40008 5.96179 8.75826 5.60362 9.20008 5.60362C9.64191 5.60362 10.0001 5.96179 10.0001 6.40362V8.40362H12.0001C12.4419 8.40362 12.8001 8.76179 12.8001 9.20362C12.8001 9.64545 12.4419 10.0036 12.0001 10.0036H10.0001V12.0036C10.0001 12.4454 9.64191 12.8036 9.20008 12.8036C8.75826 12.8036 8.40008 12.4454 8.40008 12.0036V10.0036Z"
  }
) }), Wt = (e) => e != null, Hi = "data-force-focus-visible";
function ic() {
  if (!document)
    return;
  const e = document.createElement("b");
  let t = !1;
  const n = Object.defineProperty({}, "focusVisible", {
    get: function() {
      return t = !0, !0;
    }
  });
  try {
    e.focus(n);
  } catch {
  }
  return t;
}
const oc = xu(ic);
function vt(e, { focusVisible: t = "always", ...n } = {}) {
  if (e) {
    if (t === "always") {
      if (oc()) {
        e.focus({ ...n, focusVisible: !0 });
        return;
      }
      try {
        document.addEventListener(
          "focusin",
          (r) => {
            r.target === e && (e.setAttribute(Hi, "true"), e.addEventListener(
              "blur",
              () => {
                e.removeAttribute(Hi);
              },
              { once: !0 }
            ));
          },
          { once: !0 }
        ), e.focus({ ...n, focusVisible: !0 });
      } catch {
      }
      return;
    }
    try {
      e.focus(n);
    } catch {
    }
  }
}
const sc = () => {
  const e = process.env.NODE_ENV ?? "development";
  return e === "production" ? "production" : e === "test" ? "test" : "development";
}, lc = {
  development: {
    API_URL: "https://support-funnel.development.dev.woltapi.com",
    CDN_URL: "https://consumer-static-assets.development.dev.woltapi.com",
    NODE_ENV: "development"
  },
  production: {
    API_URL: "https://support-funnel.wolt.com",
    CDN_URL: "https://consumer-static-assets.wolt.com",
    NODE_ENV: "production"
  },
  test: {
    API_URL: "https://consumer-api.development.dev.woltapi.com",
    CDN_URL: "https://consumer-static-assets.development.dev.woltapi.com",
    NODE_ENV: "test"
  }
}, sn = lc[sc()], uc = (e) => {
  switch (e) {
    case "wide":
      return "_3-2.json";
    default:
      return "_1-1.json";
  }
}, cc = (e, t) => `${sn.CDN_URL}/lottie/assets/${e}${uc(t)}`, Di = {
  bagEmpty: "bag_empty",
  bagNameChange: "bag_name_change",
  bigJumpWithHearts: "big_jump_with_hearts",
  blowingKisses: "blowing_kisses",
  burgerFries: "burger_fries",
  calendar: "calendar",
  cityBubbles: "city",
  courierGasp: "courier_gasp",
  courierMap: "courier_map",
  courierNotFound: "courier_not_found",
  courierWaving: "courier_waving",
  existingAccount: "existing_account",
  girlGasp: "girl_gasp",
  girlInvitePlanes: "girl_invite_planes",
  girlShoppingTokensAnimation: "girl_shopping_tokens",
  girlShrugging: "girl_shrugging",
  girlSofaCode: "girl_sofa_code",
  girlVerifyEmail: "girl_verify_email",
  girlWires: "girl_wires",
  groupReady: "group_ready",
  guyDrink: "guy_drink",
  guyMap: "guy_map",
  guyWithLoyaltyCards: "guy-with-loyalty-cards",
  highFiveHands: "high_five_hands",
  howToUseVoucher: "how_to_use_voucher",
  mail: "mail",
  noInternet: "no_internet",
  phoneButtons: "phone_buttons",
  postboxAllScenes: "postbox_all_scenes_web",
  scientistError: "scientist_error",
  smallJumpWithHearts: "small_jump_with_hearts",
  suitcase: "suitcase",
  token: "token",
  verifyEmail: "verify_email",
  waiterOrder: "waiter_order",
  womanShopping: "woman_shopping",
  yuhoSwaying: "yuho_swaying"
}, $i = (e) => Object.entries(Di).reduce(
  (t, [n, r]) => ({
    ...t,
    [n]: cc(r, e)
  }),
  {
    ...Di
  }
), ua = {
  square: $i("square"),
  wide: $i("wide")
};
function Cs(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const Fi = /* @__PURE__ */ new Set();
function Ui(e) {
  Fi.has(e) || (Fi.add(e), console.warn(e));
}
const vn = (e, ...t) => e.reduce((n, r, a) => {
  const i = t[a] ?? "", o = Es(i) ? i() : i;
  return n + r + o;
}, "");
vn`
  height: 1px;
  margin: -1px;
  width: 1px;
  position: absolute;
  border: 0;
  padding: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  white-space: nowrap;
  overflow: hidden;
`;
var $t = function() {
  return $t = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, $t.apply(this, arguments);
}, zr = Symbol("axiosBetterStacktrace.patched"), ca = function(e) {
  return e instanceof Error || Object.prototype.toString.call(e) === "[object Error]";
}, dc = function(e) {
  return ca(e) && e.isAxiosError;
}, zi = [
  "request",
  "get",
  "delete",
  "head",
  "options",
  "post",
  "put",
  "patch"
], fc = function(e, t) {
  t === void 0 && (t = {});
  var n = t.errorMsg, r = n === void 0 ? "Axios Better Stacktrace" : n;
  if (!(!e || !zi.some(function(o) {
    return e.hasOwnProperty(o);
  })) && !e[zr]) {
    var a = {
      request: e.request,
      get: e.get,
      delete: e.delete,
      head: e.head,
      options: e.options,
      post: e.post,
      put: e.put,
      patch: e.patch
    }, i = e.interceptors.response.use(function(o) {
      return o && o.config && ca(o.config.topmostError) && delete o.config.topmostError, o;
    }, function(o) {
      throw dc(o) && o.config && ca(o.config.topmostError) && (o.originalStack = o.stack, o.stack = "".concat(o.stack, `
`).concat(o.config.topmostError.stack), delete o.config.topmostError), o;
    });
    return zi.forEach(function(o) {
      if (o in e) {
        switch (o) {
          case "request": {
            var s = e[o];
            e[o] = function(d) {
              return s($t($t({}, d || {}), { topmostError: new Error(r) }));
            };
            break;
          }
          case "get":
          case "delete":
          case "head":
          case "options": {
            var l = e[o];
            e[o] = function(d, f) {
              return l(d, $t($t({}, f || {}), { topmostError: new Error(r) }));
            };
            break;
          }
          case "post":
          case "put":
          case "patch": {
            var u = e[o];
            e[o] = function(d, f, g) {
              return u(d, f, $t($t({}, g || {}), { topmostError: new Error(r) }));
            };
            break;
          }
        }
        e[zr] || (e[zr] = !0);
      }
    }), function() {
      e.interceptors.response.eject(i), Object.assign(e, a);
    };
  }
};
const Is = (e) => {
  const t = Uu.create(e);
  return fc(t, { errorMsg: "Thrown at:" }), t;
};
var fe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Rs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ks = {}, _n = {}, Oe = {}, jt = {};
(function(e) {
  var t = fe && fe.__spreadArray || function(b, S, O) {
    if (O || arguments.length === 2)
      for (var I = 0, P = S.length, $; I < P; I++)
        ($ || !(I in S)) && ($ || ($ = Array.prototype.slice.call(S, 0, I)), $[I] = S[I]);
    return b.concat($ || Array.prototype.slice.call(S));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.dual = e.getEndomorphismMonoid = e.not = e.SK = e.hole = e.pipe = e.untupled = e.tupled = e.absurd = e.decrement = e.increment = e.tuple = e.flow = e.flip = e.constVoid = e.constUndefined = e.constNull = e.constFalse = e.constTrue = e.constant = e.unsafeCoerce = e.identity = e.apply = e.getRing = e.getSemiring = e.getMonoid = e.getSemigroup = e.getBooleanAlgebra = void 0;
  var n = function(b) {
    return function() {
      return {
        meet: function(S, O) {
          return function(I) {
            return b.meet(S(I), O(I));
          };
        },
        join: function(S, O) {
          return function(I) {
            return b.join(S(I), O(I));
          };
        },
        zero: function() {
          return b.zero;
        },
        one: function() {
          return b.one;
        },
        implies: function(S, O) {
          return function(I) {
            return b.implies(S(I), O(I));
          };
        },
        not: function(S) {
          return function(O) {
            return b.not(S(O));
          };
        }
      };
    };
  };
  e.getBooleanAlgebra = n;
  var r = function(b) {
    return function() {
      return {
        concat: function(S, O) {
          return function(I) {
            return b.concat(S(I), O(I));
          };
        }
      };
    };
  };
  e.getSemigroup = r;
  var a = function(b) {
    var S = (0, e.getSemigroup)(b);
    return function() {
      return {
        concat: S().concat,
        empty: function() {
          return b.empty;
        }
      };
    };
  };
  e.getMonoid = a;
  var i = function(b) {
    return {
      add: function(S, O) {
        return function(I) {
          return b.add(S(I), O(I));
        };
      },
      zero: function() {
        return b.zero;
      },
      mul: function(S, O) {
        return function(I) {
          return b.mul(S(I), O(I));
        };
      },
      one: function() {
        return b.one;
      }
    };
  };
  e.getSemiring = i;
  var o = function(b) {
    var S = (0, e.getSemiring)(b);
    return {
      add: S.add,
      mul: S.mul,
      one: S.one,
      zero: S.zero,
      sub: function(O, I) {
        return function(P) {
          return b.sub(O(P), I(P));
        };
      }
    };
  };
  e.getRing = o;
  var s = function(b) {
    return function(S) {
      return S(b);
    };
  };
  e.apply = s;
  function l(b) {
    return b;
  }
  e.identity = l, e.unsafeCoerce = l;
  function u(b) {
    return function() {
      return b;
    };
  }
  e.constant = u, e.constTrue = u(!0), e.constFalse = u(!1), e.constNull = u(null), e.constUndefined = u(void 0), e.constVoid = e.constUndefined;
  function c(b) {
    return function() {
      for (var S = [], O = 0; O < arguments.length; O++)
        S[O] = arguments[O];
      return S.length > 1 ? b(S[1], S[0]) : function(I) {
        return b(I)(S[0]);
      };
    };
  }
  e.flip = c;
  function d(b, S, O, I, P, $, Q, Y, he) {
    switch (arguments.length) {
      case 1:
        return b;
      case 2:
        return function() {
          return S(b.apply(this, arguments));
        };
      case 3:
        return function() {
          return O(S(b.apply(this, arguments)));
        };
      case 4:
        return function() {
          return I(O(S(b.apply(this, arguments))));
        };
      case 5:
        return function() {
          return P(I(O(S(b.apply(this, arguments)))));
        };
      case 6:
        return function() {
          return $(P(I(O(S(b.apply(this, arguments))))));
        };
      case 7:
        return function() {
          return Q($(P(I(O(S(b.apply(this, arguments)))))));
        };
      case 8:
        return function() {
          return Y(Q($(P(I(O(S(b.apply(this, arguments))))))));
        };
      case 9:
        return function() {
          return he(Y(Q($(P(I(O(S(b.apply(this, arguments)))))))));
        };
    }
  }
  e.flow = d;
  function f() {
    for (var b = [], S = 0; S < arguments.length; S++)
      b[S] = arguments[S];
    return b;
  }
  e.tuple = f;
  function g(b) {
    return b + 1;
  }
  e.increment = g;
  function v(b) {
    return b - 1;
  }
  e.decrement = v;
  function C(b) {
    throw new Error("Called `absurd` function which should be uncallable");
  }
  e.absurd = C;
  function A(b) {
    return function(S) {
      return b.apply(void 0, S);
    };
  }
  e.tupled = A;
  function k(b) {
    return function() {
      for (var S = [], O = 0; O < arguments.length; O++)
        S[O] = arguments[O];
      return b(S);
    };
  }
  e.untupled = k;
  function R(b, S, O, I, P, $, Q, Y, he) {
    switch (arguments.length) {
      case 1:
        return b;
      case 2:
        return S(b);
      case 3:
        return O(S(b));
      case 4:
        return I(O(S(b)));
      case 5:
        return P(I(O(S(b))));
      case 6:
        return $(P(I(O(S(b)))));
      case 7:
        return Q($(P(I(O(S(b))))));
      case 8:
        return Y(Q($(P(I(O(S(b)))))));
      case 9:
        return he(Y(Q($(P(I(O(S(b))))))));
      default: {
        for (var G = arguments[0], we = 1; we < arguments.length; we++)
          G = arguments[we](G);
        return G;
      }
    }
  }
  e.pipe = R, e.hole = C;
  var y = function(b, S) {
    return S;
  };
  e.SK = y;
  function w(b) {
    return function(S) {
      return !b(S);
    };
  }
  e.not = w;
  var p = function() {
    return {
      concat: function(b, S) {
        return d(b, S);
      },
      empty: l
    };
  };
  e.getEndomorphismMonoid = p;
  var B = function(b, S) {
    var O = typeof b == "number" ? function(I) {
      return I.length >= b;
    } : b;
    return function() {
      var I = Array.from(arguments);
      return O(arguments) ? S.apply(this, I) : function(P) {
        return S.apply(void 0, t([P], I, !1));
      };
    };
  };
  e.dual = B;
})(jt);
var zn = {};
(function(e) {
  var t = fe && fe.__spreadArray || function(b, S, O) {
    if (O || arguments.length === 2)
      for (var I = 0, P = S.length, $; I < P; I++)
        ($ || !(I in S)) && ($ || ($ = Array.prototype.slice.call(S, 0, I)), $[I] = S[I]);
    return b.concat($ || Array.prototype.slice.call(S));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.flatMapReader = e.flatMapTask = e.flatMapIO = e.flatMapEither = e.flatMapOption = e.flatMapNullable = e.liftOption = e.liftNullable = e.fromReadonlyNonEmptyArray = e.has = e.emptyRecord = e.emptyReadonlyArray = e.tail = e.head = e.isNonEmpty = e.singleton = e.right = e.left = e.isRight = e.isLeft = e.some = e.none = e.isSome = e.isNone = void 0;
  var n = jt, r = function(b) {
    return b._tag === "None";
  };
  e.isNone = r;
  var a = function(b) {
    return b._tag === "Some";
  };
  e.isSome = a, e.none = { _tag: "None" };
  var i = function(b) {
    return { _tag: "Some", value: b };
  };
  e.some = i;
  var o = function(b) {
    return b._tag === "Left";
  };
  e.isLeft = o;
  var s = function(b) {
    return b._tag === "Right";
  };
  e.isRight = s;
  var l = function(b) {
    return { _tag: "Left", left: b };
  };
  e.left = l;
  var u = function(b) {
    return { _tag: "Right", right: b };
  };
  e.right = u;
  var c = function(b) {
    return [b];
  };
  e.singleton = c;
  var d = function(b) {
    return b.length > 0;
  };
  e.isNonEmpty = d;
  var f = function(b) {
    return b[0];
  };
  e.head = f;
  var g = function(b) {
    return b.slice(1);
  };
  e.tail = g, e.emptyReadonlyArray = [], e.emptyRecord = {}, e.has = Object.prototype.hasOwnProperty;
  var v = function(b) {
    return t([b[0]], b.slice(1), !0);
  };
  e.fromReadonlyNonEmptyArray = v;
  var C = function(b) {
    return function(S, O) {
      return function() {
        for (var I = [], P = 0; P < arguments.length; P++)
          I[P] = arguments[P];
        var $ = S.apply(void 0, I);
        return b.fromEither($ == null ? (0, e.left)(O.apply(void 0, I)) : (0, e.right)($));
      };
    };
  };
  e.liftNullable = C;
  var A = function(b) {
    return function(S, O) {
      return function() {
        for (var I = [], P = 0; P < arguments.length; P++)
          I[P] = arguments[P];
        var $ = S.apply(void 0, I);
        return b.fromEither((0, e.isNone)($) ? (0, e.left)(O.apply(void 0, I)) : (0, e.right)($.value));
      };
    };
  };
  e.liftOption = A;
  var k = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(3, function(O, I, P) {
      return S.flatMap(O, (0, e.liftNullable)(b)(I, P));
    });
  };
  e.flatMapNullable = k;
  var R = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(3, function(O, I, P) {
      return S.flatMap(O, (0, e.liftOption)(b)(I, P));
    });
  };
  e.flatMapOption = R;
  var y = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(2, function(O, I) {
      return S.flatMap(O, function(P) {
        return b.fromEither(I(P));
      });
    });
  };
  e.flatMapEither = y;
  var w = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(2, function(O, I) {
      return S.flatMap(O, function(P) {
        return b.fromIO(I(P));
      });
    });
  };
  e.flatMapIO = w;
  var p = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(2, function(O, I) {
      return S.flatMap(O, function(P) {
        return b.fromTask(I(P));
      });
    });
  };
  e.flatMapTask = p;
  var B = function(b, S) {
    return /* @__PURE__ */ (0, n.dual)(2, function(O, I) {
      return S.flatMap(O, function(P) {
        return b.fromReader(I(P));
      });
    });
  };
  e.flatMapReader = B;
})(zn);
var hc = fe && fe.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), pc = fe && fe.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), mc = fe && fe.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && hc(t, e, n);
  return pc(t, e), t;
};
Object.defineProperty(Oe, "__esModule", { value: !0 });
Oe.sequenceS = Oe.sequenceT = Oe.getApplySemigroup = Oe.apS = Oe.apSecond = Oe.apFirst = Oe.ap = void 0;
var gc = jt, bc = mc(zn);
function vc(e, t) {
  return function(n) {
    return function(r) {
      return e.ap(e.map(r, function(a) {
        return function(i) {
          return t.ap(a, i);
        };
      }), n);
    };
  };
}
Oe.ap = vc;
function yc(e) {
  return function(t) {
    return function(n) {
      return e.ap(e.map(n, function(r) {
        return function() {
          return r;
        };
      }), t);
    };
  };
}
Oe.apFirst = yc;
function _c(e) {
  return function(t) {
    return function(n) {
      return e.ap(e.map(n, function() {
        return function(r) {
          return r;
        };
      }), t);
    };
  };
}
Oe.apSecond = _c;
function Ec(e) {
  return function(t, n) {
    return function(r) {
      return e.ap(e.map(r, function(a) {
        return function(i) {
          var o;
          return Object.assign({}, a, (o = {}, o[t] = i, o));
        };
      }), n);
    };
  };
}
Oe.apS = Ec;
function Sc(e) {
  return function(t) {
    return {
      concat: function(n, r) {
        return e.ap(e.map(n, function(a) {
          return function(i) {
            return t.concat(a, i);
          };
        }), r);
      }
    };
  };
}
Oe.getApplySemigroup = Sc;
function qa(e, t, n) {
  return function(r) {
    for (var a = Array(n.length + 1), i = 0; i < n.length; i++)
      a[i] = n[i];
    return a[n.length] = r, t === 0 ? e.apply(null, a) : qa(e, t - 1, a);
  };
}
var Wr = {
  1: function(e) {
    return [e];
  },
  2: function(e) {
    return function(t) {
      return [e, t];
    };
  },
  3: function(e) {
    return function(t) {
      return function(n) {
        return [e, t, n];
      };
    };
  },
  4: function(e) {
    return function(t) {
      return function(n) {
        return function(r) {
          return [e, t, n, r];
        };
      };
    };
  },
  5: function(e) {
    return function(t) {
      return function(n) {
        return function(r) {
          return function(a) {
            return [e, t, n, r, a];
          };
        };
      };
    };
  }
};
function Tc(e) {
  return bc.has.call(Wr, e) || (Wr[e] = qa(gc.tuple, e - 1, [])), Wr[e];
}
function wc(e) {
  return function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = t.length, a = Tc(r), i = e.map(t[0], a), o = 1; o < r; o++)
      i = e.ap(i, t[o]);
    return i;
  };
}
Oe.sequenceT = wc;
function Cc(e) {
  var t = e.length;
  switch (t) {
    case 1:
      return function(n) {
        var r;
        return r = {}, r[e[0]] = n, r;
      };
    case 2:
      return function(n) {
        return function(r) {
          var a;
          return a = {}, a[e[0]] = n, a[e[1]] = r, a;
        };
      };
    case 3:
      return function(n) {
        return function(r) {
          return function(a) {
            var i;
            return i = {}, i[e[0]] = n, i[e[1]] = r, i[e[2]] = a, i;
          };
        };
      };
    case 4:
      return function(n) {
        return function(r) {
          return function(a) {
            return function(i) {
              var o;
              return o = {}, o[e[0]] = n, o[e[1]] = r, o[e[2]] = a, o[e[3]] = i, o;
            };
          };
        };
      };
    case 5:
      return function(n) {
        return function(r) {
          return function(a) {
            return function(i) {
              return function(o) {
                var s;
                return s = {}, s[e[0]] = n, s[e[1]] = r, s[e[2]] = a, s[e[3]] = i, s[e[4]] = o, s;
              };
            };
          };
        };
      };
    default:
      return qa(function() {
        for (var n = [], r = 0; r < arguments.length; r++)
          n[r] = arguments[r];
        for (var a = {}, i = 0; i < t; i++)
          a[e[i]] = n[i];
        return a;
      }, t - 1, []);
  }
}
function Ic(e) {
  return function(t) {
    for (var n = Object.keys(t), r = n.length, a = Cc(n), i = e.map(t[n[0]], a), o = 1; o < r; o++)
      i = e.ap(i, t[n[o]]);
    return i;
  };
}
Oe.sequenceS = Ic;
var ke = {};
Object.defineProperty(ke, "__esModule", { value: !0 });
ke.asUnit = ke.as = ke.getFunctorComposition = ke.let = ke.bindTo = ke.flap = ke.map = void 0;
var Rc = jt;
function As(e, t) {
  return function(n) {
    return function(r) {
      return e.map(r, function(a) {
        return t.map(a, n);
      });
    };
  };
}
ke.map = As;
function kc(e) {
  return function(t) {
    return function(n) {
      return e.map(n, function(r) {
        return r(t);
      });
    };
  };
}
ke.flap = kc;
function Ac(e) {
  return function(t) {
    return function(n) {
      return e.map(n, function(r) {
        var a;
        return a = {}, a[t] = r, a;
      });
    };
  };
}
ke.bindTo = Ac;
function Lc(e) {
  return function(t, n) {
    return function(r) {
      return e.map(r, function(a) {
        var i;
        return Object.assign({}, a, (i = {}, i[t] = n(a), i));
      });
    };
  };
}
ke.let = Lc;
function Oc(e, t) {
  var n = As(e, t);
  return {
    map: function(r, a) {
      return (0, Rc.pipe)(r, n(a));
    }
  };
}
ke.getFunctorComposition = Oc;
function Ls(e) {
  return function(t, n) {
    return e.map(t, function() {
      return n;
    });
  };
}
ke.as = Ls;
function Mc(e) {
  var t = Ls(e);
  return function(n) {
    return t(n, void 0);
  };
}
ke.asUnit = Mc;
Object.defineProperty(_n, "__esModule", { value: !0 });
_n.getApplicativeComposition = _n.getApplicativeMonoid = void 0;
var Os = Oe, Pc = jt, Nc = ke;
function xc(e) {
  var t = (0, Os.getApplySemigroup)(e);
  return function(n) {
    return {
      concat: t(n).concat,
      empty: e.of(n.empty)
    };
  };
}
_n.getApplicativeMonoid = xc;
function Bc(e, t) {
  var n = (0, Nc.getFunctorComposition)(e, t).map, r = (0, Os.ap)(e, t);
  return {
    map: n,
    of: function(a) {
      return e.of(t.of(a));
    },
    ap: function(a, i) {
      return (0, Pc.pipe)(a, r(i));
    }
  };
}
_n.getApplicativeComposition = Bc;
var Mt = {};
Object.defineProperty(Mt, "__esModule", { value: !0 });
Mt.bind = Mt.tap = Mt.chainFirst = void 0;
function Hc(e) {
  var t = Ms(e);
  return function(n) {
    return function(r) {
      return t(r, n);
    };
  };
}
Mt.chainFirst = Hc;
function Ms(e) {
  return function(t, n) {
    return e.chain(t, function(r) {
      return e.map(n(r), function() {
        return r;
      });
    });
  };
}
Mt.tap = Ms;
function Dc(e) {
  return function(t, n) {
    return function(r) {
      return e.chain(r, function(a) {
        return e.map(n(a), function(i) {
          var o;
          return Object.assign({}, a, (o = {}, o[t] = i, o));
        });
      });
    };
  };
}
Mt.bind = Dc;
var Lr = {};
Object.defineProperty(Lr, "__esModule", { value: !0 });
Lr.tailRec = void 0;
var $c = function(e, t) {
  for (var n = t(e); n._tag === "Left"; )
    n = t(n.left);
  return n.right;
};
Lr.tailRec = $c;
var Ie = {}, Fc = fe && fe.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Uc = fe && fe.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), zc = fe && fe.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Fc(t, e, n);
  return Uc(t, e), t;
};
Object.defineProperty(Ie, "__esModule", { value: !0 });
Ie.tapEither = Ie.filterOrElse = Ie.chainFirstEitherK = Ie.chainEitherK = Ie.fromEitherK = Ie.chainOptionK = Ie.fromOptionK = Ie.fromPredicate = Ie.fromOption = void 0;
var Wc = Mt, Ps = jt, Jt = zc(zn);
function Ns(e) {
  return function(t) {
    return function(n) {
      return e.fromEither(Jt.isNone(n) ? Jt.left(t()) : Jt.right(n.value));
    };
  };
}
Ie.fromOption = Ns;
function jc(e) {
  return function(t, n) {
    return function(r) {
      return e.fromEither(t(r) ? Jt.right(r) : Jt.left(n(r)));
    };
  };
}
Ie.fromPredicate = jc;
function xs(e) {
  var t = Ns(e);
  return function(n) {
    var r = t(n);
    return function(a) {
      return (0, Ps.flow)(a, r);
    };
  };
}
Ie.fromOptionK = xs;
function qc(e, t) {
  var n = xs(e);
  return function(r) {
    var a = n(r);
    return function(i) {
      return function(o) {
        return t.chain(o, a(i));
      };
    };
  };
}
Ie.chainOptionK = qc;
function Va(e) {
  return function(t) {
    return (0, Ps.flow)(t, e.fromEither);
  };
}
Ie.fromEitherK = Va;
function Vc(e, t) {
  var n = Va(e);
  return function(r) {
    return function(a) {
      return t.chain(a, n(r));
    };
  };
}
Ie.chainEitherK = Vc;
function Gc(e, t) {
  var n = Bs(e, t);
  return function(r) {
    return function(a) {
      return n(a, r);
    };
  };
}
Ie.chainFirstEitherK = Gc;
function Yc(e, t) {
  return function(n, r) {
    return function(a) {
      return t.chain(a, function(i) {
        return e.fromEither(n(i) ? Jt.right(i) : Jt.left(r(i)));
      });
    };
  };
}
Ie.filterOrElse = Yc;
function Bs(e, t) {
  var n = Va(e), r = (0, Wc.tap)(t);
  return function(a, i) {
    return r(a, n(i));
  };
}
Ie.tapEither = Bs;
var Hs = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.right = e.left = e.flap = e.Functor = e.Bifunctor = e.URI = e.bimap = e.mapLeft = e.map = e.separated = void 0;
  var t = jt, n = ke, r = function(f, g) {
    return { left: f, right: g };
  };
  e.separated = r;
  var a = function(f, g) {
    return (0, t.pipe)(f, (0, e.map)(g));
  }, i = function(f, g) {
    return (0, t.pipe)(f, (0, e.mapLeft)(g));
  }, o = function(f, g, v) {
    return (0, t.pipe)(f, (0, e.bimap)(g, v));
  }, s = function(f) {
    return function(g) {
      return (0, e.separated)((0, e.left)(g), f((0, e.right)(g)));
    };
  };
  e.map = s;
  var l = function(f) {
    return function(g) {
      return (0, e.separated)(f((0, e.left)(g)), (0, e.right)(g));
    };
  };
  e.mapLeft = l;
  var u = function(f, g) {
    return function(v) {
      return (0, e.separated)(f((0, e.left)(v)), g((0, e.right)(v)));
    };
  };
  e.bimap = u, e.URI = "Separated", e.Bifunctor = {
    URI: e.URI,
    mapLeft: i,
    bimap: o
  }, e.Functor = {
    URI: e.URI,
    map: a
  }, e.flap = (0, n.flap)(e.Functor);
  var c = function(f) {
    return f.left;
  };
  e.left = c;
  var d = function(f) {
    return f.right;
  };
  e.right = d;
})(Hs);
var zt = {}, Xc = fe && fe.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Kc = fe && fe.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Zc = fe && fe.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Xc(t, e, n);
  return Kc(t, e), t;
};
Object.defineProperty(zt, "__esModule", { value: !0 });
zt.filterE = zt.witherDefault = zt.wiltDefault = void 0;
var Wi = Zc(zn);
function Qc(e, t) {
  return function(n) {
    var r = e.traverse(n);
    return function(a, i) {
      return n.map(r(a, i), t.separate);
    };
  };
}
zt.wiltDefault = Qc;
function Jc(e, t) {
  return function(n) {
    var r = e.traverse(n);
    return function(a, i) {
      return n.map(r(a, i), t.compact);
    };
  };
}
zt.witherDefault = Jc;
function ed(e) {
  return function(t) {
    var n = e.wither(t);
    return function(r) {
      return function(a) {
        return n(a, function(i) {
          return t.map(r(i), function(o) {
            return o ? Wi.some(i) : Wi.none;
          });
        });
      };
    };
  };
}
zt.filterE = ed;
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(T, _, L, K) {
    K === void 0 && (K = L);
    var Le = Object.getOwnPropertyDescriptor(_, L);
    (!Le || ("get" in Le ? !_.__esModule : Le.writable || Le.configurable)) && (Le = { enumerable: !0, get: function() {
      return _[L];
    } }), Object.defineProperty(T, K, Le);
  } : function(T, _, L, K) {
    K === void 0 && (K = L), T[K] = _[L];
  }), n = fe && fe.__setModuleDefault || (Object.create ? function(T, _) {
    Object.defineProperty(T, "default", { enumerable: !0, value: _ });
  } : function(T, _) {
    T.default = _;
  }), r = fe && fe.__importStar || function(T) {
    if (T && T.__esModule)
      return T;
    var _ = {};
    if (T != null)
      for (var L in T)
        L !== "default" && Object.prototype.hasOwnProperty.call(T, L) && t(_, T, L);
    return n(_, T), _;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.match = e.foldW = e.matchW = e.isRight = e.isLeft = e.fromOption = e.fromPredicate = e.FromEither = e.MonadThrow = e.throwError = e.ChainRec = e.Extend = e.extend = e.Alt = e.alt = e.altW = e.Bifunctor = e.mapLeft = e.bimap = e.Traversable = e.sequence = e.traverse = e.Foldable = e.reduceRight = e.foldMap = e.reduce = e.Monad = e.Chain = e.Applicative = e.Apply = e.ap = e.apW = e.Pointed = e.of = e.asUnit = e.as = e.Functor = e.map = e.getAltValidation = e.getApplicativeValidation = e.getWitherable = e.getFilterable = e.getCompactable = e.getSemigroup = e.getEq = e.getShow = e.URI = e.flatMap = e.right = e.left = void 0, e.chainFirstW = e.chainFirst = e.chain = e.chainW = e.sequenceArray = e.traverseArray = e.traverseArrayWithIndex = e.traverseReadonlyArrayWithIndex = e.traverseReadonlyNonEmptyArrayWithIndex = e.ApT = e.apSW = e.apS = e.bindW = e.bind = e.let = e.bindTo = e.Do = e.exists = e.elem = e.toError = e.toUnion = e.chainNullableK = e.fromNullableK = e.tryCatchK = e.tryCatch = e.fromNullable = e.orElse = e.orElseW = e.swap = e.filterOrElseW = e.filterOrElse = e.flatMapOption = e.flatMapNullable = e.liftOption = e.liftNullable = e.chainOptionKW = e.chainOptionK = e.fromOptionK = e.duplicate = e.flatten = e.flattenW = e.tap = e.apSecondW = e.apSecond = e.apFirstW = e.apFirst = e.flap = e.getOrElse = e.getOrElseW = e.fold = void 0, e.getValidation = e.getValidationMonoid = e.getValidationSemigroup = e.getApplyMonoid = e.getApplySemigroup = e.either = e.stringifyJSON = e.parseJSON = void 0;
  var a = _n, i = Oe, o = r(Mt), s = Lr, l = Ie, u = jt, c = ke, d = r(zn), f = Hs, g = zt;
  e.left = d.left, e.right = d.right, e.flatMap = (0, u.dual)(2, function(T, _) {
    return (0, e.isLeft)(T) ? T : _(T.right);
  });
  var v = function(T, _) {
    return (0, u.pipe)(T, (0, e.map)(_));
  }, C = function(T, _) {
    return (0, u.pipe)(T, (0, e.ap)(_));
  }, A = function(T, _, L) {
    return (0, u.pipe)(T, (0, e.reduce)(_, L));
  }, k = function(T) {
    return function(_, L) {
      var K = (0, e.foldMap)(T);
      return (0, u.pipe)(_, K(L));
    };
  }, R = function(T, _, L) {
    return (0, u.pipe)(T, (0, e.reduceRight)(_, L));
  }, y = function(T) {
    var _ = (0, e.traverse)(T);
    return function(L, K) {
      return (0, u.pipe)(L, _(K));
    };
  }, w = function(T, _, L) {
    return (0, u.pipe)(T, (0, e.bimap)(_, L));
  }, p = function(T, _) {
    return (0, u.pipe)(T, (0, e.mapLeft)(_));
  }, B = function(T, _) {
    return (0, u.pipe)(T, (0, e.alt)(_));
  }, b = function(T, _) {
    return (0, u.pipe)(T, (0, e.extend)(_));
  }, S = function(T, _) {
    return (0, s.tailRec)(_(T), function(L) {
      return (0, e.isLeft)(L) ? (0, e.right)((0, e.left)(L.left)) : (0, e.isLeft)(L.right) ? (0, e.left)(_(L.right.left)) : (0, e.right)((0, e.right)(L.right.right));
    });
  };
  e.URI = "Either";
  var O = function(T, _) {
    return {
      show: function(L) {
        return (0, e.isLeft)(L) ? "left(".concat(T.show(L.left), ")") : "right(".concat(_.show(L.right), ")");
      }
    };
  };
  e.getShow = O;
  var I = function(T, _) {
    return {
      equals: function(L, K) {
        return L === K || ((0, e.isLeft)(L) ? (0, e.isLeft)(K) && T.equals(L.left, K.left) : (0, e.isRight)(K) && _.equals(L.right, K.right));
      }
    };
  };
  e.getEq = I;
  var P = function(T) {
    return {
      concat: function(_, L) {
        return (0, e.isLeft)(L) ? _ : (0, e.isLeft)(_) ? L : (0, e.right)(T.concat(_.right, L.right));
      }
    };
  };
  e.getSemigroup = P;
  var $ = function(T) {
    var _ = (0, e.left)(T.empty);
    return {
      URI: e.URI,
      _E: void 0,
      compact: function(L) {
        return (0, e.isLeft)(L) ? L : L.right._tag === "None" ? _ : (0, e.right)(L.right.value);
      },
      separate: function(L) {
        return (0, e.isLeft)(L) ? (0, f.separated)(L, L) : (0, e.isLeft)(L.right) ? (0, f.separated)((0, e.right)(L.right.left), _) : (0, f.separated)(_, (0, e.right)(L.right.right));
      }
    };
  };
  e.getCompactable = $;
  var Q = function(T) {
    var _ = (0, e.left)(T.empty), L = (0, e.getCompactable)(T), K = L.compact, Le = L.separate, pt = function(Te, me) {
      return (0, e.isLeft)(Te) || me(Te.right) ? Te : _;
    }, Hr = function(Te, me) {
      return (0, e.isLeft)(Te) ? (0, f.separated)(Te, Te) : me(Te.right) ? (0, f.separated)(_, (0, e.right)(Te.right)) : (0, f.separated)((0, e.right)(Te.right), _);
    };
    return {
      URI: e.URI,
      _E: void 0,
      map: v,
      compact: K,
      separate: Le,
      filter: pt,
      filterMap: function(Te, me) {
        if ((0, e.isLeft)(Te))
          return Te;
        var Xe = me(Te.right);
        return Xe._tag === "None" ? _ : (0, e.right)(Xe.value);
      },
      partition: Hr,
      partitionMap: function(Te, me) {
        if ((0, e.isLeft)(Te))
          return (0, f.separated)(Te, Te);
        var Xe = me(Te.right);
        return (0, e.isLeft)(Xe) ? (0, f.separated)((0, e.right)(Xe.left), _) : (0, f.separated)(_, (0, e.right)(Xe.right));
      }
    };
  };
  e.getFilterable = Q;
  var Y = function(T) {
    var _ = (0, e.getFilterable)(T), L = (0, e.getCompactable)(T);
    return {
      URI: e.URI,
      _E: void 0,
      map: v,
      compact: _.compact,
      separate: _.separate,
      filter: _.filter,
      filterMap: _.filterMap,
      partition: _.partition,
      partitionMap: _.partitionMap,
      traverse: y,
      sequence: e.sequence,
      reduce: A,
      foldMap: k,
      reduceRight: R,
      wither: (0, g.witherDefault)(e.Traversable, L),
      wilt: (0, g.wiltDefault)(e.Traversable, L)
    };
  };
  e.getWitherable = Y;
  var he = function(T) {
    return {
      URI: e.URI,
      _E: void 0,
      map: v,
      ap: function(_, L) {
        return (0, e.isLeft)(_) ? (0, e.isLeft)(L) ? (0, e.left)(T.concat(_.left, L.left)) : _ : (0, e.isLeft)(L) ? L : (0, e.right)(_.right(L.right));
      },
      of: e.of
    };
  };
  e.getApplicativeValidation = he;
  var G = function(T) {
    return {
      URI: e.URI,
      _E: void 0,
      map: v,
      alt: function(_, L) {
        if ((0, e.isRight)(_))
          return _;
        var K = L();
        return (0, e.isLeft)(K) ? (0, e.left)(T.concat(_.left, K.left)) : K;
      }
    };
  };
  e.getAltValidation = G;
  var we = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? _ : (0, e.right)(T(_.right));
    };
  };
  e.map = we, e.Functor = {
    URI: e.URI,
    map: v
  }, e.as = (0, u.dual)(2, (0, c.as)(e.Functor)), e.asUnit = (0, c.asUnit)(e.Functor), e.of = e.right, e.Pointed = {
    URI: e.URI,
    of: e.of
  };
  var Ce = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? _ : (0, e.isLeft)(T) ? T : (0, e.right)(_.right(T.right));
    };
  };
  e.apW = Ce, e.ap = e.apW, e.Apply = {
    URI: e.URI,
    map: v,
    ap: C
  }, e.Applicative = {
    URI: e.URI,
    map: v,
    ap: C,
    of: e.of
  }, e.Chain = {
    URI: e.URI,
    map: v,
    ap: C,
    chain: e.flatMap
  }, e.Monad = {
    URI: e.URI,
    map: v,
    ap: C,
    of: e.of,
    chain: e.flatMap
  };
  var ie = function(T, _) {
    return function(L) {
      return (0, e.isLeft)(L) ? T : _(T, L.right);
    };
  };
  e.reduce = ie;
  var ct = function(T) {
    return function(_) {
      return function(L) {
        return (0, e.isLeft)(L) ? T.empty : _(L.right);
      };
    };
  };
  e.foldMap = ct;
  var be = function(T, _) {
    return function(L) {
      return (0, e.isLeft)(L) ? T : _(L.right, T);
    };
  };
  e.reduceRight = be, e.Foldable = {
    URI: e.URI,
    reduce: A,
    foldMap: k,
    reduceRight: R
  };
  var Ht = function(T) {
    return function(_) {
      return function(L) {
        return (0, e.isLeft)(L) ? T.of((0, e.left)(L.left)) : T.map(_(L.right), e.right);
      };
    };
  };
  e.traverse = Ht;
  var pe = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? T.of((0, e.left)(_.left)) : T.map(_.right, e.right);
    };
  };
  e.sequence = pe, e.Traversable = {
    URI: e.URI,
    map: v,
    reduce: A,
    foldMap: k,
    reduceRight: R,
    traverse: y,
    sequence: e.sequence
  };
  var Je = function(T, _) {
    return function(L) {
      return (0, e.isLeft)(L) ? (0, e.left)(T(L.left)) : (0, e.right)(_(L.right));
    };
  };
  e.bimap = Je;
  var At = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? (0, e.left)(T(_.left)) : _;
    };
  };
  e.mapLeft = At, e.Bifunctor = {
    URI: e.URI,
    bimap: w,
    mapLeft: p
  };
  var Dt = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? T() : _;
    };
  };
  e.altW = Dt, e.alt = e.altW, e.Alt = {
    URI: e.URI,
    map: v,
    alt: B
  };
  var bt = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? _ : (0, e.right)(T(_));
    };
  };
  e.extend = bt, e.Extend = {
    URI: e.URI,
    map: v,
    extend: b
  }, e.ChainRec = {
    URI: e.URI,
    map: v,
    ap: C,
    chain: e.flatMap,
    chainRec: S
  }, e.throwError = e.left, e.MonadThrow = {
    URI: e.URI,
    map: v,
    ap: C,
    of: e.of,
    chain: e.flatMap,
    throwError: e.throwError
  }, e.FromEither = {
    URI: e.URI,
    fromEither: u.identity
  }, e.fromPredicate = (0, l.fromPredicate)(e.FromEither), e.fromOption = /* @__PURE__ */ (0, l.fromOption)(e.FromEither), e.isLeft = d.isLeft, e.isRight = d.isRight;
  var dt = function(T, _) {
    return function(L) {
      return (0, e.isLeft)(L) ? T(L.left) : _(L.right);
    };
  };
  e.matchW = dt, e.foldW = e.matchW, e.match = e.matchW, e.fold = e.match;
  var Lt = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? T(_.left) : _.right;
    };
  };
  e.getOrElseW = Lt, e.getOrElse = e.getOrElseW, e.flap = (0, c.flap)(e.Functor), e.apFirst = (0, i.apFirst)(e.Apply), e.apFirstW = e.apFirst, e.apSecond = (0, i.apSecond)(e.Apply), e.apSecondW = e.apSecond, e.tap = (0, u.dual)(2, o.tap(e.Chain)), e.flattenW = /* @__PURE__ */ (0, e.flatMap)(u.identity), e.flatten = e.flattenW, e.duplicate = (0, e.extend)(u.identity), e.fromOptionK = /* @__PURE__ */ (0, l.fromOptionK)(e.FromEither), e.chainOptionK = (0, l.chainOptionK)(e.FromEither, e.Chain), e.chainOptionKW = e.chainOptionK;
  var Me = {
    fromEither: e.FromEither.fromEither
  };
  e.liftNullable = d.liftNullable(Me), e.liftOption = d.liftOption(Me);
  var We = {
    flatMap: e.flatMap
  };
  e.flatMapNullable = d.flatMapNullable(Me, We), e.flatMapOption = d.flatMapOption(Me, We), e.filterOrElse = (0, l.filterOrElse)(e.FromEither, e.Chain), e.filterOrElseW = e.filterOrElse;
  var H = function(T) {
    return (0, e.isLeft)(T) ? (0, e.right)(T.left) : (0, e.left)(T.right);
  };
  e.swap = H;
  var et = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? T(_.left) : _;
    };
  };
  e.orElseW = et, e.orElse = e.orElseW;
  var Pe = function(T) {
    return function(_) {
      return _ == null ? (0, e.left)(T) : (0, e.right)(_);
    };
  };
  e.fromNullable = Pe;
  var tt = function(T, _) {
    try {
      return (0, e.right)(T());
    } catch (L) {
      return (0, e.left)(_(L));
    }
  };
  e.tryCatch = tt;
  var j = function(T, _) {
    return function() {
      for (var L = [], K = 0; K < arguments.length; K++)
        L[K] = arguments[K];
      return (0, e.tryCatch)(function() {
        return T.apply(void 0, L);
      }, _);
    };
  };
  e.tryCatchK = j;
  var J = function(T) {
    var _ = (0, e.fromNullable)(T);
    return function(L) {
      return (0, u.flow)(L, _);
    };
  };
  e.fromNullableK = J;
  var X = function(T) {
    var _ = (0, e.fromNullableK)(T);
    return function(L) {
      return (0, e.flatMap)(_(L));
    };
  };
  e.chainNullableK = X, e.toUnion = (0, e.foldW)(u.identity, u.identity);
  function nt(T) {
    return T instanceof Error ? T : new Error(String(T));
  }
  e.toError = nt;
  function ft(T) {
    return function(_, L) {
      if (L === void 0) {
        var K = ft(T);
        return function(Le) {
          return K(_, Le);
        };
      }
      return (0, e.isLeft)(L) ? !1 : T.equals(_, L.right);
    };
  }
  e.elem = ft;
  var ht = function(T) {
    return function(_) {
      return (0, e.isLeft)(_) ? !1 : T(_.right);
    };
  };
  e.exists = ht, e.Do = (0, e.of)(d.emptyRecord), e.bindTo = (0, c.bindTo)(e.Functor);
  var je = /* @__PURE__ */ (0, c.let)(e.Functor);
  e.let = je, e.bind = o.bind(e.Chain), e.bindW = e.bind, e.apS = (0, i.apS)(e.Apply), e.apSW = e.apS, e.ApT = (0, e.of)(d.emptyReadonlyArray);
  var Ye = function(T) {
    return function(_) {
      var L = T(0, d.head(_));
      if ((0, e.isLeft)(L))
        return L;
      for (var K = [L.right], Le = 1; Le < _.length; Le++) {
        var pt = T(Le, _[Le]);
        if ((0, e.isLeft)(pt))
          return pt;
        K.push(pt.right);
      }
      return (0, e.right)(K);
    };
  };
  e.traverseReadonlyNonEmptyArrayWithIndex = Ye;
  var Vt = function(T) {
    var _ = (0, e.traverseReadonlyNonEmptyArrayWithIndex)(T);
    return function(L) {
      return d.isNonEmpty(L) ? _(L) : e.ApT;
    };
  };
  e.traverseReadonlyArrayWithIndex = Vt, e.traverseArrayWithIndex = e.traverseReadonlyArrayWithIndex;
  var Xn = function(T) {
    return (0, e.traverseReadonlyArrayWithIndex)(function(_, L) {
      return T(L);
    });
  };
  e.traverseArray = Xn, e.sequenceArray = /* @__PURE__ */ (0, e.traverseArray)(u.identity), e.chainW = e.flatMap, e.chain = e.flatMap, e.chainFirst = e.tap, e.chainFirstW = e.tap;
  function Kn(T, _) {
    return (0, e.tryCatch)(function() {
      return JSON.parse(T);
    }, _);
  }
  e.parseJSON = Kn;
  var wn = function(T, _) {
    return (0, e.tryCatch)(function() {
      var L = JSON.stringify(T);
      if (typeof L != "string")
        throw new Error("Converting unsupported structure to JSON");
      return L;
    }, _);
  };
  e.stringifyJSON = wn, e.either = {
    URI: e.URI,
    map: v,
    of: e.of,
    ap: C,
    chain: e.flatMap,
    reduce: A,
    foldMap: k,
    reduceRight: R,
    traverse: y,
    sequence: e.sequence,
    bimap: w,
    mapLeft: p,
    alt: B,
    extend: b,
    chainRec: S,
    throwError: e.throwError
  }, e.getApplySemigroup = /* @__PURE__ */ (0, i.getApplySemigroup)(e.Apply), e.getApplyMonoid = /* @__PURE__ */ (0, a.getApplicativeMonoid)(e.Applicative);
  var Zn = function(T, _) {
    return (0, i.getApplySemigroup)((0, e.getApplicativeValidation)(T))(_);
  };
  e.getValidationSemigroup = Zn;
  var dn = function(T, _) {
    return (0, a.getApplicativeMonoid)((0, e.getApplicativeValidation)(T))(_);
  };
  e.getValidationMonoid = dn;
  function fn(T) {
    var _ = (0, e.getApplicativeValidation)(T).ap, L = (0, e.getAltValidation)(T).alt;
    return {
      URI: e.URI,
      _E: void 0,
      map: v,
      of: e.of,
      chain: e.flatMap,
      bimap: w,
      mapLeft: p,
      reduce: A,
      foldMap: k,
      reduceRight: R,
      extend: b,
      traverse: y,
      sequence: e.sequence,
      chainRec: S,
      throwError: e.throwError,
      ap: _,
      alt: L
    };
  }
  e.getValidation = fn;
})(ks);
const td = (e) => [...new Set(e)], nd = (e) => e.map((t) => t.key).filter(Boolean).map((t) => isNaN(Number(t)) ? t : "[]").join(".").replace(/\.\[]/g, "[]"), rd = ({ context: e, value: t }) => {
  const n = nd(e), r = e[e.length - 1];
  return `Invalid type "${typeof t}" supplied for "${n}" (${r == null ? void 0 : r.type.name})`;
}, Ga = async (e, t) => {
  const n = await t, r = n.data, a = e.decode(r), i = ks.isLeft(a) ? a.left : void 0, o = i ? td(i.map(rd)) : void 0, { baseURL: s = "", method: l = "", url: u = "" } = n.config, c = `${s.replace(/\/$/, "")}/${u.replace(/^\//, "")}`;
  if (i && sn.NODE_ENV === "development") {
    const d = `${i.length} data validation errors (${l} ${c})`;
    console.error(d, o, zu(i));
  }
  return n;
}, mn = (e) => {
  (typeof e.cancelable != "boolean" || e.cancelable) && e.preventDefault();
}, Jn = (e) => {
  e.current && clearTimeout(e.current), e.current = null;
}, da = (e) => {
  e.current && clearInterval(e.current);
}, ji = (e) => {
  da(e), e.current = null;
}, qi = ({
  onClick: e,
  onPress: t,
  onStop: n,
  timings: r
}) => {
  const a = ae(null), i = ae(null), o = ae(null), s = ne(() => {
    Jn(a), Jn(i), ji(o);
  }, []);
  de(() => s, [s]);
  const l = ne(
    async (d) => {
      Jn(a), Jn(i), o.current ? (ji(o), n()) : e(d);
    },
    [e, n]
  ), u = ne(
    (d) => {
      const f = () => {
        a.current = setTimeout(() => {
          da(o), o.current = setInterval(() => {
            e(d);
          }, r.firstLongPressTimeInterval);
        }, r.firstLongPressDelay);
      }, g = () => {
        i.current = setTimeout(() => {
          da(o), o.current = setInterval(() => {
            t();
          }, r.secondLongPressTimeInterval);
        }, r.firstLongPressDelay + r.firstLongPressDuration);
      };
      d.button === 0 && (f(), g());
    },
    [r, e, t]
  ), c = ne(() => {
    s(), n();
  }, [n, s]);
  return {
    handleClick: l,
    handleMouseDown: u,
    handleMouseLeave: c
  };
}, ad = (e) => new Promise((t) => setTimeout(t, e)), id = 50, jr = (e, t, n) => {
  const r = ne(() => {
    var i;
    (i = e == null ? void 0 : e.current) == null || i.removeAttribute(t);
  }, [e, t]), a = ne(async () => {
    var i;
    n && r(), await ad(id), (i = e == null ? void 0 : e.current) == null || i.setAttribute(t, "true");
  }, [e, t, r, n]);
  return xt(() => ({
    animate: a,
    reset: r
  }), [a, r]);
}, od = (e) => {
  const t = ae(e);
  t.current = e, de(() => {
    const n = (r) => {
      t.current(r);
    };
    return window.addEventListener("keyup", n), () => window.removeEventListener("keyup", n);
  }, []);
}, sd = typeof window == "object" ? Pu : de;
var en = [], ld = function() {
  return en.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, ud = function() {
  return en.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, Vi = "ResizeObserver loop completed with undelivered notifications.", cd = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: Vi
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = Vi), window.dispatchEvent(e);
}, Hn;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Hn || (Hn = {}));
var tn = function(e) {
  return Object.freeze(e);
}, dd = /* @__PURE__ */ function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, tn(this);
  }
  return e;
}(), Ds = function() {
  function e(t, n, r, a) {
    return this.x = t, this.y = n, this.width = r, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, tn(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, a = t.top, i = t.right, o = t.bottom, s = t.left, l = t.width, u = t.height;
    return { x: n, y: r, top: a, right: i, bottom: o, left: s, width: l, height: u };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), Ya = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, $s = function(e) {
  if (Ya(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var a = e, i = a.offsetWidth, o = a.offsetHeight;
  return !(i || o || e.getClientRects().length);
}, Gi = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, fd = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Mn = typeof window < "u" ? window : {}, er = /* @__PURE__ */ new WeakMap(), Yi = /auto|scroll/, hd = /^tb|vertical/, pd = /msie|trident/i.test(Mn.navigator && Mn.navigator.userAgent), yt = function(e) {
  return parseFloat(e || "0");
}, yn = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new dd((n ? t : e) || 0, (n ? e : t) || 0);
}, Xi = tn({
  devicePixelContentBoxSize: yn(),
  borderBoxSize: yn(),
  contentBoxSize: yn(),
  contentRect: new Ds(0, 0, 0, 0)
}), Fs = function(e, t) {
  if (t === void 0 && (t = !1), er.has(e) && !t)
    return er.get(e);
  if ($s(e))
    return er.set(e, Xi), Xi;
  var n = getComputedStyle(e), r = Ya(e) && e.ownerSVGElement && e.getBBox(), a = !pd && n.boxSizing === "border-box", i = hd.test(n.writingMode || ""), o = !r && Yi.test(n.overflowY || ""), s = !r && Yi.test(n.overflowX || ""), l = r ? 0 : yt(n.paddingTop), u = r ? 0 : yt(n.paddingRight), c = r ? 0 : yt(n.paddingBottom), d = r ? 0 : yt(n.paddingLeft), f = r ? 0 : yt(n.borderTopWidth), g = r ? 0 : yt(n.borderRightWidth), v = r ? 0 : yt(n.borderBottomWidth), C = r ? 0 : yt(n.borderLeftWidth), A = d + u, k = l + c, R = C + g, y = f + v, w = s ? e.offsetHeight - y - e.clientHeight : 0, p = o ? e.offsetWidth - R - e.clientWidth : 0, B = a ? A + R : 0, b = a ? k + y : 0, S = r ? r.width : yt(n.width) - B - p, O = r ? r.height : yt(n.height) - b - w, I = S + A + p + R, P = O + k + w + y, $ = tn({
    devicePixelContentBoxSize: yn(Math.round(S * devicePixelRatio), Math.round(O * devicePixelRatio), i),
    borderBoxSize: yn(I, P, i),
    contentBoxSize: yn(S, O, i),
    contentRect: new Ds(d, l, S, O)
  });
  return er.set(e, $), $;
}, Us = function(e, t, n) {
  var r = Fs(e, n), a = r.borderBoxSize, i = r.contentBoxSize, o = r.devicePixelContentBoxSize;
  switch (t) {
    case Hn.DEVICE_PIXEL_CONTENT_BOX:
      return o;
    case Hn.BORDER_BOX:
      return a;
    default:
      return i;
  }
}, md = /* @__PURE__ */ function() {
  function e(t) {
    var n = Fs(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = tn([n.borderBoxSize]), this.contentBoxSize = tn([n.contentBoxSize]), this.devicePixelContentBoxSize = tn([n.devicePixelContentBoxSize]);
  }
  return e;
}(), zs = function(e) {
  if ($s(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, gd = function() {
  var e = 1 / 0, t = [];
  en.forEach(function(o) {
    if (o.activeTargets.length !== 0) {
      var s = [];
      o.activeTargets.forEach(function(u) {
        var c = new md(u.target), d = zs(u.target);
        s.push(c), u.lastReportedSize = Us(u.target, u.observedBox), d < e && (e = d);
      }), t.push(function() {
        o.callback.call(o.observer, s, o.observer);
      }), o.activeTargets.splice(0, o.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var a = r[n];
    a();
  }
  return e;
}, Ki = function(e) {
  en.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(a) {
      a.isActive() && (zs(a.target) > e ? n.activeTargets.push(a) : n.skippedTargets.push(a));
    });
  });
}, bd = function() {
  var e = 0;
  for (Ki(e); ld(); )
    e = gd(), Ki(e);
  return ud() && cd(), e > 0;
}, qr, Ws = [], vd = function() {
  return Ws.splice(0).forEach(function(e) {
    return e();
  });
}, yd = function(e) {
  if (!qr) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return vd();
    }).observe(n, r), qr = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  Ws.push(e), qr();
}, _d = function(e) {
  yd(function() {
    requestAnimationFrame(e);
  });
}, pr = 0, Ed = function() {
  return !!pr;
}, Sd = 250, Td = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Zi = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Qi = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, Vr = !1, wd = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = Sd), !Vr) {
      Vr = !0;
      var r = Qi(t);
      _d(function() {
        var a = !1;
        try {
          a = bd();
        } finally {
          if (Vr = !1, t = r - Qi(), !Ed())
            return;
          a ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, Td);
    };
    document.body ? n() : Mn.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Zi.forEach(function(n) {
      return Mn.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), Zi.forEach(function(n) {
      return Mn.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), fa = new wd(), Ji = function(e) {
  !pr && e > 0 && fa.start(), pr += e, !pr && fa.stop();
}, Cd = function(e) {
  return !Ya(e) && !fd(e) && getComputedStyle(e).display === "inline";
}, Id = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || Hn.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = Us(this.target, this.observedBox, !0);
    return Cd(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), Rd = /* @__PURE__ */ function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), tr = /* @__PURE__ */ new WeakMap(), eo = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, nr = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new Rd(t, n);
    tr.set(t, r);
  }, e.observe = function(t, n, r) {
    var a = tr.get(t), i = a.observationTargets.length === 0;
    eo(a.observationTargets, n) < 0 && (i && en.push(a), a.observationTargets.push(new Id(n, r && r.box)), Ji(1), fa.schedule());
  }, e.unobserve = function(t, n) {
    var r = tr.get(t), a = eo(r.observationTargets, n), i = r.observationTargets.length === 1;
    a >= 0 && (i && en.splice(en.indexOf(r), 1), r.observationTargets.splice(a, 1), Ji(-1));
  }, e.disconnect = function(t) {
    var n = this, r = tr.get(t);
    r.observationTargets.slice().forEach(function(a) {
      return n.unobserve(t, a.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), kd = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    nr.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Gi(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    nr.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Gi(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    nr.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    nr.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
const Ad = mt[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], Ld = (e) => {
  const t = q.useRef(e);
  return q.useEffect(() => {
    t.current = e;
  }), t;
}, Od = typeof window < "u" && "ResizeObserver" in window ? (
  // @ts-ignore
  window.ResizeObserver
) : kd;
function Md() {
}
function ha(e, t) {
  const n = Nd(), r = Ld(t);
  return Ad(() => {
    let a = !1;
    const i = e && "current" in e ? e.current : e;
    if (!i)
      return Md;
    function o(s, l) {
      a || r.current(s, l);
    }
    return n.subscribe(i, o), () => {
      a = !0, n.unsubscribe(i, o);
    };
  }, [e, n, r]), n.observer;
}
function Pd() {
  let e = !1, t = [];
  const n = /* @__PURE__ */ new Map(), r = new Od((a, i) => {
    t = t.concat(a);
    function o() {
      const s = /* @__PURE__ */ new Set();
      for (let l = 0; l < t.length; l++) {
        if (s.has(t[l].target))
          continue;
        s.add(t[l].target);
        const u = n.get(t[l].target);
        u == null || u.forEach((c) => c(t[l], i));
      }
      t = [], e = !1;
    }
    e || window.requestAnimationFrame(o), e = !0;
  });
  return {
    observer: r,
    subscribe(a, i) {
      var o;
      r.observe(a);
      const s = (o = n.get(a)) !== null && o !== void 0 ? o : [];
      s.push(i), n.set(a, s);
    },
    unsubscribe(a, i) {
      var o;
      const s = (o = n.get(a)) !== null && o !== void 0 ? o : [];
      if (s.length === 1) {
        r.unobserve(a), n.delete(a);
        return;
      }
      const l = s.indexOf(i);
      l !== -1 && s.splice(l, 1), n.set(a, s);
    }
  };
}
let Gr;
const Nd = () => Gr || (Gr = Pd()), xd = (e, t) => {
  const n = (t == null ? void 0 : t.debounceWait) || 120, [r, a] = Ae(
    e.current ? {
      clientHeight: e.current.clientHeight,
      clientWidth: e.current.clientWidth,
      offsetHeight: e.current.offsetHeight,
      offsetWidth: e.current.offsetWidth,
      scrollHeight: e.current.scrollHeight,
      scrollWidth: e.current.scrollWidth
    } : void 0
  ), i = ne(() => {
    const s = e == null ? void 0 : e.current;
    s && a({
      clientHeight: s.clientHeight,
      clientWidth: s.clientWidth,
      offsetHeight: s.offsetHeight,
      offsetWidth: s.offsetWidth,
      scrollHeight: s.scrollHeight,
      scrollWidth: s.scrollWidth
    });
  }, [e, a]), o = xt(() => Fa(() => i(), n), [i, n]);
  return ha(
    e,
    o
  ), de(() => {
    i();
  }, [i]), r;
}, br = (e, t) => {
  const n = ae(t);
  n.current = t;
  const r = ae(null), a = e.current;
  de(() => (r.current = new ResizeObserver(([i]) => {
    i && n.current(i);
  }), a && r.current.observe(a), () => {
    var i;
    (i = r.current) == null || i.disconnect();
  }), [a, r, n]);
}, Bd = Is({
  baseURL: sn.CDN_URL
}), Hd = ["angry", "sad", "speechless", "happy", "pleased"], Dd = (e) => `/lottie/emoji/smiley_web_${e}.json`, $d = (e) => Ga(E.UnknownRecord, Bd.get(e)).then((t) => t.data), Fd = () => {
  const e = Hd.map(Dd).map($d);
  return Promise.all(e);
}, Ud = (e) => {
  if (!Array.isArray(e))
    return !1;
  const n = e.length === 5, r = e.every((a) => Ua(a));
  return !(!n && !r);
}, zd = [void 0, void 0, void 0, void 0, void 0], Wd = () => {
  const { data: e, isLoading: t } = za(["smiley_lottie_files"], Fd);
  return {
    files: Ud(e) ? e : zd,
    isLoaded: !t
  };
}, js = typeof document < "u" ? mt.useLayoutEffect : () => {
};
function jd(e) {
  const t = ae(null);
  return js(() => {
    t.current = e;
  }, [
    e
  ]), ne((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const Or = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, pa = (e) => e && "window" in e && e.window === e ? e : Or(e).defaultView || window;
function qd(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Vd(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Gd() {
  return Vd(/^Mac/i);
}
function Yd() {
  return qd(/Android/i);
}
let In = /* @__PURE__ */ new Map(), to = /* @__PURE__ */ new Set();
function no() {
  if (typeof window > "u")
    return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target)
      return;
    let a = In.get(r.target);
    a || (a = /* @__PURE__ */ new Set(), In.set(r.target, a), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target)
      return;
    let a = In.get(r.target);
    if (a && (a.delete(r.propertyName), a.size === 0 && (r.target.removeEventListener("transitioncancel", n), In.delete(r.target)), In.size === 0)) {
      for (let i of to)
        i();
      to.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? no() : document.addEventListener("DOMContentLoaded", no));
function Xd(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Yd() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
var ma = function(e, t) {
  return ma = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, ma(e, t);
};
function lt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ma(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var D = function() {
  return D = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, D.apply(this, arguments);
};
function Mr(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function St(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ee;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(ee || (ee = {}));
var ye;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(ye || (ye = {}));
var En;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(En || (En = {}));
function ro(e) {
  return e.type === ye.literal;
}
function Kd(e) {
  return e.type === ye.argument;
}
function qs(e) {
  return e.type === ye.number;
}
function Vs(e) {
  return e.type === ye.date;
}
function Gs(e) {
  return e.type === ye.time;
}
function Ys(e) {
  return e.type === ye.select;
}
function Xs(e) {
  return e.type === ye.plural;
}
function Zd(e) {
  return e.type === ye.pound;
}
function Ks(e) {
  return e.type === ye.tag;
}
function Zs(e) {
  return !!(e && typeof e == "object" && e.type === En.number);
}
function ga(e) {
  return !!(e && typeof e == "object" && e.type === En.dateTime);
}
var Qs = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Qd = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Jd(e) {
  var t = {};
  return e.replace(Qd, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var ef = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function tf(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(ef).filter(function(f) {
    return f.length > 0;
  }), n = [], r = 0, a = t; r < a.length; r++) {
    var i = a[r], o = i.split("/");
    if (o.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = o[0], l = o.slice(1), u = 0, c = l; u < c.length; u++) {
      var d = c[u];
      if (d.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function nf(e) {
  return e.replace(/^(.*?)-/, "");
}
var ao = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Js = /^(@+)?(\+|#+)?[rs]?$/g, rf = /(\*)(0+)|(#+)(0+)|(0+)/g, el = /^(0+)$/;
function io(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Js, function(n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function tl(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function af(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !el.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function oo(e) {
  var t = {}, n = tl(e);
  return n || t;
}
function of(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = nf(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = D(D(D({}, t), { notation: "scientific" }), a.options.reduce(function(l, u) {
          return D(D({}, l), oo(u));
        }, {}));
        continue;
      case "engineering":
        t = D(D(D({}, t), { notation: "engineering" }), a.options.reduce(function(l, u) {
          return D(D({}, l), oo(u));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(rf, function(l, u, c, d, f, g) {
          if (u)
            t.minimumIntegerDigits = c.length;
          else {
            if (d && f)
              throw new Error("We currently do not support maximum integer digits");
            if (g)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (el.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (ao.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(ao, function(l, u, c, d, f, g) {
        return c === "*" ? t.minimumFractionDigits = u.length : d && d[0] === "#" ? t.maximumFractionDigits = d.length : f && g ? (t.minimumFractionDigits = f.length, t.maximumFractionDigits = f.length + g.length) : (t.minimumFractionDigits = u.length, t.maximumFractionDigits = u.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = D(D({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = D(D({}, t), io(i)));
      continue;
    }
    if (Js.test(a.stem)) {
      t = D(D({}, t), io(a.stem));
      continue;
    }
    var o = tl(a.stem);
    o && (t = D(D({}, t), o));
    var s = af(a.stem);
    s && (t = D(D({}, t), s));
  }
  return t;
}
var rr = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function sf(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === a; )
        i++, r++;
      var o = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), l = "a", u = lf(t);
      for ((u == "H" || u == "k") && (s = 0); s-- > 0; )
        n += l;
      for (; o-- > 0; )
        n = u + n;
    } else
      a === "J" ? n += "H" : n += a;
  }
  return n;
}
function lf(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var a = rr[r || ""] || rr[n || ""] || rr["".concat(n, "-001")] || rr["001"];
  return a[0];
}
var Yr, uf = new RegExp("^".concat(Qs.source, "*")), cf = new RegExp("".concat(Qs.source, "*$"));
function te(e, t) {
  return { start: e, end: t };
}
var df = !!String.prototype.startsWith && "_a".startsWith("a", 1), ff = !!String.fromCodePoint, hf = !!Object.fromEntries, pf = !!String.prototype.codePointAt, mf = !!String.prototype.trimStart, gf = !!String.prototype.trimEnd, bf = !!Number.isSafeInteger, vf = bf ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, ba = !0;
try {
  var yf = rl("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  ba = ((Yr = yf.exec("a")) === null || Yr === void 0 ? void 0 : Yr[0]) === "a";
} catch {
  ba = !1;
}
var so = df ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), va = ff ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", a = t.length, i = 0, o; a > i; ) {
      if (o = t[i++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      r += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return r;
  }
), lo = (
  // native
  hf ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, a = t; r < a.length; r++) {
        var i = a[r], o = i[0], s = i[1];
        n[o] = s;
      }
      return n;
    }
  )
), nl = pf ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var a = t.charCodeAt(n), i;
      return a < 55296 || a > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), _f = mf ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(uf, "");
  }
), Ef = gf ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(cf, "");
  }
);
function rl(e, t) {
  return new RegExp(e, t);
}
var ya;
if (ba) {
  var uo = rl("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  ya = function(t, n) {
    var r;
    uo.lastIndex = n;
    var a = uo.exec(t);
    return (r = a[1]) !== null && r !== void 0 ? r : "";
  };
} else
  ya = function(t, n) {
    for (var r = []; ; ) {
      var a = nl(t, n);
      if (a === void 0 || al(a) || Cf(a))
        break;
      r.push(a), n += a >= 65536 ? 2 : 1;
    }
    return va.apply(void 0, r);
  };
var Sf = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var o = this.parseArgument(t, r);
          if (o.err)
            return o;
          a.push(o.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: ye.pound,
              location: te(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(ee.UNMATCHED_CLOSING_TAG, te(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && _a(this.peek() || 0)) {
            var o = this.parseTag(t, n);
            if (o.err)
              return o;
            a.push(o.val);
          } else {
            var o = this.parseLiteral(t, n);
            if (o.err)
              return o;
            a.push(o.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: ye.literal,
            value: "<".concat(a, "/>"),
            location: te(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var o = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !_a(this.char()))
            return this.error(ee.INVALID_TAG, te(s, this.clonePosition()));
          var l = this.clonePosition(), u = this.parseTagName();
          return a !== u ? this.error(ee.UNMATCHED_CLOSING_TAG, te(l, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: ye.tag,
              value: a,
              children: o,
              location: te(r, this.clonePosition())
            },
            err: null
          } : this.error(ee.INVALID_TAG, te(s, this.clonePosition())));
        } else
          return this.error(ee.UNCLOSED_TAG, te(r, this.clonePosition()));
      } else
        return this.error(ee.INVALID_TAG, te(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && wf(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          a += i;
          continue;
        }
        var o = this.tryParseUnquoted(t, n);
        if (o) {
          a += o;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var l = te(r, this.clonePosition());
      return {
        val: { type: ye.literal, value: a, location: l },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Tf(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return va.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), va(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, te(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(ee.EMPTY_ARGUMENT, te(r, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(ee.MALFORMED_ARGUMENT, te(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, te(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: ye.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: te(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, te(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
        default:
          return this.error(ee.MALFORMED_ARGUMENT, te(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = ya(this.message, n), a = n + r.length;
      this.bumpTo(a);
      var i = this.clonePosition(), o = te(t, i);
      return { value: r, location: o };
    }, e.prototype.parseArgumentOptions = function(t, n, r, a) {
      var i, o = this.clonePosition(), s = this.parseIdentifierIfPossible().value, l = this.clonePosition();
      switch (s) {
        case "":
          return this.error(ee.EXPECT_ARGUMENT_TYPE, te(o, l));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var u = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var c = this.clonePosition(), d = this.parseSimpleArgStyleIfPossible();
            if (d.err)
              return d;
            var f = Ef(d.val);
            if (f.length === 0)
              return this.error(ee.EXPECT_ARGUMENT_STYLE, te(this.clonePosition(), this.clonePosition()));
            var g = te(c, this.clonePosition());
            u = { style: f, styleLocation: g };
          }
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var C = te(a, this.clonePosition());
          if (u && so(u == null ? void 0 : u.style, "::", 0)) {
            var A = _f(u.style.slice(2));
            if (s === "number") {
              var d = this.parseNumberSkeletonFromString(A, u.styleLocation);
              return d.err ? d : {
                val: { type: ye.number, value: r, location: C, style: d.val },
                err: null
              };
            } else {
              if (A.length === 0)
                return this.error(ee.EXPECT_DATE_TIME_SKELETON, C);
              var k = A;
              this.locale && (k = sf(A, this.locale));
              var f = {
                type: En.dateTime,
                pattern: k,
                location: u.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Jd(k) : {}
              }, R = s === "date" ? ye.date : ye.time;
              return {
                val: { type: R, value: r, location: C, style: f },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? ye.number : s === "date" ? ye.date : ye.time,
              value: r,
              location: C,
              style: (i = u == null ? void 0 : u.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var y = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(ee.EXPECT_SELECT_ARGUMENT_OPTIONS, te(y, D({}, y)));
          this.bumpSpace();
          var w = this.parseIdentifierIfPossible(), p = 0;
          if (s !== "select" && w.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, te(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var d = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ee.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (d.err)
              return d;
            this.bumpSpace(), w = this.parseIdentifierIfPossible(), p = d.val;
          }
          var B = this.tryParsePluralOrSelectOptions(t, s, n, w);
          if (B.err)
            return B;
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var b = te(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: ye.select,
              value: r,
              options: lo(B.val),
              location: b
            },
            err: null
          } : {
            val: {
              type: ye.plural,
              value: r,
              options: lo(B.val),
              offset: p,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: b
            },
            err: null
          };
        }
        default:
          return this.error(ee.INVALID_ARGUMENT_TYPE, te(o, l));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, te(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(ee.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, te(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = tf(t);
      } catch {
        return this.error(ee.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: En.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? of(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, a) {
      for (var i, o = !1, s = [], l = /* @__PURE__ */ new Set(), u = a.value, c = a.location; ; ) {
        if (u.length === 0) {
          var d = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var f = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, ee.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (f.err)
              return f;
            c = te(d, this.clonePosition()), u = this.message.slice(d.offset, this.offset());
          } else
            break;
        }
        if (l.has(u))
          return this.error(n === "select" ? ee.DUPLICATE_SELECT_ARGUMENT_SELECTOR : ee.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
        u === "other" && (o = !0), this.bumpSpace();
        var g = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, te(this.clonePosition(), this.clonePosition()));
        var v = this.parseMessage(t + 1, n, r);
        if (v.err)
          return v;
        var C = this.tryParseArgumentClose(g);
        if (C.err)
          return C;
        s.push([
          u,
          {
            value: v.val,
            location: te(g, this.clonePosition())
          }
        ]), l.add(u), this.bumpSpace(), i = this.parseIdentifierIfPossible(), u = i.value, c = i.location;
      }
      return s.length === 0 ? this.error(n === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, te(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(ee.MISSING_OTHER_CLAUSE, te(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, o = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, o = o * 10 + (s - 48), this.bump();
        else
          break;
      }
      var l = te(a, this.clonePosition());
      return i ? (o *= r, vf(o) ? { val: o, err: null } : this.error(n, l)) : this.error(t, l);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = nl(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (so(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && al(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  }()
);
function _a(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Tf(e) {
  return _a(e) || e === 47;
}
function wf(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function al(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Cf(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Ea(e) {
  e.forEach(function(t) {
    if (delete t.location, Ys(t) || Xs(t))
      for (var n in t.options)
        delete t.options[n].location, Ea(t.options[n].value);
    else
      qs(t) && Zs(t.style) || (Vs(t) || Gs(t)) && ga(t.style) ? delete t.style.location : Ks(t) && Ea(t.children);
  });
}
function If(e, t) {
  t === void 0 && (t = {}), t = D({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new Sf(e, t).parse();
  if (n.err) {
    var r = SyntaxError(ee[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || Ea(n.val), n.val;
}
function _t(e, t) {
  var n = t && t.cache ? t.cache : Mf, r = t && t.serializer ? t.serializer : Of, a = t && t.strategy ? t.strategy : kf;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function Rf(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function il(e, t, n, r) {
  var a = Rf(r) ? r : n(r), i = t.get(a);
  return typeof i > "u" && (i = e.call(this, r), t.set(a, i)), i;
}
function ol(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), a = n(r), i = t.get(a);
  return typeof i > "u" && (i = e.apply(this, r), t.set(a, i)), i;
}
function Xa(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function kf(e, t) {
  var n = e.length === 1 ? il : ol;
  return Xa(e, this, n, t.cache.create(), t.serializer);
}
function Af(e, t) {
  return Xa(e, this, ol, t.cache.create(), t.serializer);
}
function Lf(e, t) {
  return Xa(e, this, il, t.cache.create(), t.serializer);
}
var Of = function() {
  return JSON.stringify(arguments);
};
function Ka() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Ka.prototype.get = function(e) {
  return this.cache[e];
};
Ka.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Mf = {
  create: function() {
    return new Ka();
  }
}, Et = {
  variadic: Af,
  monadic: Lf
}, Rt;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(Rt || (Rt = {}));
var qt = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), co = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), Rt.INVALID_VALUE, i) || this;
    }
    return t;
  }(qt)
), Pf = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), Rt.INVALID_VALUE, a) || this;
    }
    return t;
  }(qt)
), Nf = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), Rt.MISSING_VALUE, r) || this;
    }
    return t;
  }(qt)
), $e;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})($e || ($e = {}));
function xf(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== $e.literal || n.type !== $e.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function sl(e) {
  return typeof e == "function";
}
function mr(e, t, n, r, a, i, o) {
  if (e.length === 1 && ro(e[0]))
    return [
      {
        type: $e.literal,
        value: e[0].value
      }
    ];
  for (var s = [], l = 0, u = e; l < u.length; l++) {
    var c = u[l];
    if (ro(c)) {
      s.push({
        type: $e.literal,
        value: c.value
      });
      continue;
    }
    if (Zd(c)) {
      typeof i == "number" && s.push({
        type: $e.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var d = c.value;
    if (!(a && d in a))
      throw new Nf(d, o);
    var f = a[d];
    if (Kd(c)) {
      (!f || typeof f == "string" || typeof f == "number") && (f = typeof f == "string" || typeof f == "number" ? String(f) : ""), s.push({
        type: typeof f == "string" ? $e.literal : $e.object,
        value: f
      });
      continue;
    }
    if (Vs(c)) {
      var g = typeof c.style == "string" ? r.date[c.style] : ga(c.style) ? c.style.parsedOptions : void 0;
      s.push({
        type: $e.literal,
        value: n.getDateTimeFormat(t, g).format(f)
      });
      continue;
    }
    if (Gs(c)) {
      var g = typeof c.style == "string" ? r.time[c.style] : ga(c.style) ? c.style.parsedOptions : r.time.medium;
      s.push({
        type: $e.literal,
        value: n.getDateTimeFormat(t, g).format(f)
      });
      continue;
    }
    if (qs(c)) {
      var g = typeof c.style == "string" ? r.number[c.style] : Zs(c.style) ? c.style.parsedOptions : void 0;
      g && g.scale && (f = f * (g.scale || 1)), s.push({
        type: $e.literal,
        value: n.getNumberFormat(t, g).format(f)
      });
      continue;
    }
    if (Ks(c)) {
      var v = c.children, C = c.value, A = a[C];
      if (!sl(A))
        throw new Pf(C, "function", o);
      var k = mr(v, t, n, r, a, i), R = A(k.map(function(p) {
        return p.value;
      }));
      Array.isArray(R) || (R = [R]), s.push.apply(s, R.map(function(p) {
        return {
          type: typeof p == "string" ? $e.literal : $e.object,
          value: p
        };
      }));
    }
    if (Ys(c)) {
      var y = c.options[f] || c.options.other;
      if (!y)
        throw new co(c.value, f, Object.keys(c.options), o);
      s.push.apply(s, mr(y.value, t, n, r, a));
      continue;
    }
    if (Xs(c)) {
      var y = c.options["=".concat(f)];
      if (!y) {
        if (!Intl.PluralRules)
          throw new qt(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, Rt.MISSING_INTL_API, o);
        var w = n.getPluralRules(t, { type: c.pluralType }).select(f - (c.offset || 0));
        y = c.options[w] || c.options.other;
      }
      if (!y)
        throw new co(c.value, f, Object.keys(c.options), o);
      s.push.apply(s, mr(y.value, t, n, r, a, f - (c.offset || 0)));
      continue;
    }
  }
  return xf(s);
}
function Bf(e, t) {
  return t ? D(D(D({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = D(D({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Hf(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Bf(e[r], t[r]), n;
  }, D({}, e)) : e;
}
function Xr(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Df(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: _t(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, St([void 0], n, !1)))();
    }, {
      cache: Xr(e.number),
      strategy: Et.variadic
    }),
    getDateTimeFormat: _t(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, St([void 0], n, !1)))();
    }, {
      cache: Xr(e.dateTime),
      strategy: Et.variadic
    }),
    getPluralRules: _t(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, St([void 0], n, !1)))();
    }, {
      cache: Xr(e.pluralRules),
      strategy: Et.variadic
    })
  };
}
var ll = (
  /** @class */
  function() {
    function e(t, n, r, a) {
      var i = this;
      if (n === void 0 && (n = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(l) {
        var u = i.formatToParts(l);
        if (u.length === 1)
          return u[0].value;
        var c = u.reduce(function(d, f) {
          return !d.length || f.type !== $e.literal || typeof d[d.length - 1] != "string" ? d.push(f.value) : d[d.length - 1] += f.value, d;
        }, []);
        return c.length <= 1 ? c[0] || "" : c;
      }, this.formatToParts = function(l) {
        return mr(i.ast, i.locales, i.formatters, i.formats, l, void 0, i.message);
      }, this.resolvedOptions = function() {
        var l;
        return {
          locale: ((l = i.resolvedLocale) === null || l === void 0 ? void 0 : l.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var o = a || {};
        o.formatters;
        var s = Mr(o, ["formatters"]);
        this.ast = e.__parse(t, D(D({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Hf(e.formats, r), this.formatters = a && a.formatters || Df(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = If, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
);
const $f = mt.createContext({
  register: () => {
  }
});
$f.displayName = "PressResponderContext";
class Ff {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function Uf(e) {
  let t = ae({
    isFocused: !1,
    observer: null
  });
  js(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = jd((r) => {
    e == null || e(r);
  });
  return ne((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, i = (o) => {
        t.current.isFocused = !1, a.disabled && n(new Ff("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let zf = /* @__PURE__ */ new Set(), Pn = /* @__PURE__ */ new Map(), nn = !1, Sa = !1;
function Za(e, t) {
  for (let n of zf)
    n(e, t);
}
function Wf(e) {
  return !(e.metaKey || !Gd() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function vr(e) {
  nn = !0, Wf(e) && Za("keyboard", e);
}
function it(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (nn = !0, Za("pointer", e));
}
function ul(e) {
  Xd(e) && (nn = !0);
}
function cl(e) {
  e.target === window || e.target === document || (!nn && !Sa && Za("virtual", e), nn = !1, Sa = !1);
}
function dl() {
  nn = !1, Sa = !0;
}
function fo(e) {
  if (typeof window > "u" || Pn.get(pa(e)))
    return;
  const t = pa(e), n = Or(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    nn = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", vr, !0), n.addEventListener("keyup", vr, !0), n.addEventListener("click", ul, !0), t.addEventListener("focus", cl, !0), t.addEventListener("blur", dl, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", it, !0), n.addEventListener("pointermove", it, !0), n.addEventListener("pointerup", it, !0)) : (n.addEventListener("mousedown", it, !0), n.addEventListener("mousemove", it, !0), n.addEventListener("mouseup", it, !0)), t.addEventListener("beforeunload", () => {
    fl(e);
  }, {
    once: !0
  }), Pn.set(t, {
    focus: r
  });
}
const fl = (e, t) => {
  const n = pa(e), r = Or(e);
  t && r.removeEventListener("DOMContentLoaded", t), Pn.has(n) && (n.HTMLElement.prototype.focus = Pn.get(n).focus, r.removeEventListener("keydown", vr, !0), r.removeEventListener("keyup", vr, !0), r.removeEventListener("click", ul, !0), n.removeEventListener("focus", cl, !0), n.removeEventListener("blur", dl, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", it, !0), r.removeEventListener("pointermove", it, !0), r.removeEventListener("pointerup", it, !0)) : (r.removeEventListener("mousedown", it, !0), r.removeEventListener("mousemove", it, !0), r.removeEventListener("mouseup", it, !0)), Pn.delete(n));
};
function jf(e) {
  const t = Or(e);
  let n;
  return t.readyState !== "loading" ? fo(e) : (n = () => {
    fo(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => fl(e, n);
}
typeof document < "u" && jf();
function qf(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, i = ae({
    isFocusWithin: !1
  }), o = ne((u) => {
    i.current.isFocusWithin && !u.currentTarget.contains(u.relatedTarget) && (i.current.isFocusWithin = !1, n && n(u), a && a(!1));
  }, [
    n,
    a,
    i
  ]), s = Uf(o), l = ne((u) => {
    !i.current.isFocusWithin && document.activeElement === u.target && (r && r(u), a && a(!0), i.current.isFocusWithin = !0, s(u));
  }, [
    r,
    a,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: l,
      onBlur: o
    }
  };
}
const ho = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function hl(e = {}) {
  let { style: t, isFocusable: n } = e, [r, a] = Ae(!1), { focusWithinProps: i } = qf({
    isDisabled: !n,
    onFocusWithinChange: (s) => a(s)
  }), o = xt(() => r ? t : t ? {
    ...ho,
    ...t
  } : ho, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...i,
      style: o
    }
  };
}
let Rn = /* @__PURE__ */ new WeakMap(), rt = [];
function Vf(e, t = document.body) {
  let n = new Set(e), r = /* @__PURE__ */ new Set(), a = (l) => {
    for (let f of l.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))
      n.add(f);
    let u = (f) => {
      if (n.has(f) || r.has(f.parentElement) && f.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let g of n)
        if (f.contains(g))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, c = document.createTreeWalker(l, NodeFilter.SHOW_ELEMENT, {
      acceptNode: u
    }), d = u(l);
    if (d === NodeFilter.FILTER_ACCEPT && i(l), d !== NodeFilter.FILTER_REJECT) {
      let f = c.nextNode();
      for (; f != null; )
        i(f), f = c.nextNode();
    }
  }, i = (l) => {
    var u;
    let c = (u = Rn.get(l)) !== null && u !== void 0 ? u : 0;
    l.getAttribute("aria-hidden") === "true" && c === 0 || (c === 0 && l.setAttribute("aria-hidden", "true"), r.add(l), Rn.set(l, c + 1));
  };
  rt.length && rt[rt.length - 1].disconnect(), a(t);
  let o = new MutationObserver((l) => {
    for (let u of l)
      if (!(u.type !== "childList" || u.addedNodes.length === 0) && ![
        ...n,
        ...r
      ].some((c) => c.contains(u.target))) {
        for (let c of u.removedNodes)
          c instanceof Element && (n.delete(c), r.delete(c));
        for (let c of u.addedNodes)
          (c instanceof HTMLElement || c instanceof SVGElement) && (c.dataset.liveAnnouncer === "true" || c.dataset.reactAriaTopLayer === "true") ? n.add(c) : c instanceof Element && a(c);
      }
  });
  o.observe(t, {
    childList: !0,
    subtree: !0
  });
  let s = {
    observe() {
      o.observe(t, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      o.disconnect();
    }
  };
  return rt.push(s), () => {
    o.disconnect();
    for (let l of r) {
      let u = Rn.get(l);
      u === 1 ? (l.removeAttribute("aria-hidden"), Rn.delete(l)) : Rn.set(l, u - 1);
    }
    s === rt[rt.length - 1] ? (rt.pop(), rt.length && rt[rt.length - 1].observe()) : rt.splice(rt.indexOf(s), 1);
  };
}
const le = {
  /* :disabled matches both [disabled] elements, and also those in disabled fieldsets etc. */
  disabled: ":not(:disabled)",
  /* inert elements are both those that are inert themselves, and those that belong in an inert subtree */
  inert: ":not([inert]):not([inert] *)",
  /* all negative tab indices are considered */
  negTabIndex: ':not([tabindex^="-"])'
}, pl = [
  /* Only link anchors/areas with an href are focusable */
  `a[href]${le.inert}${le.negTabIndex}`,
  `area[href]${le.inert}${le.negTabIndex}`,
  /* We consider all inputs focusable, but for radio inputs this does not exactly match native browser behaviour:
   * For input[type="radio'], if a radio input is checked in a group, only that input receives sequential focus.
   * If no radio inputs are checked in a group, any of them can receive focus (FF makes all of them focusable, Chrome and Safari only the first one).
   * We do not have a way of spotting this with CSS alone, so we allow all of them to receive focus.
   * This causes no harm for our purposes (it's a false positive), but good to note anyway.
   */
  `input:not([type="hidden"])${le.inert}${le.negTabIndex}${le.disabled}`,
  `select${le.inert}${le.negTabIndex}${le.disabled}`,
  `textarea${le.inert}${le.negTabIndex}${le.disabled}`,
  `button${le.inert}${le.negTabIndex}${le.disabled}`,
  `details${le.inert} > summary:first-of-type${le.negTabIndex}`,
  /* In principle, details without summary are also focusable
   * Discard until Firefox supports `:has()`
   * See: https://github.com/KittyGiraudel/focusable-selectors/issues/12
   */
  // `details:not(:has(> summary))${not.inert}${not.negTabIndex}`,
  `iframe${le.inert}${le.negTabIndex}`,
  `audio[controls]${le.inert}${le.negTabIndex}`,
  `video[controls]${le.inert}${le.negTabIndex}`,
  `[contenteditable]${le.inert}${le.negTabIndex}`,
  `[tabindex]${le.disabled}${le.inert}${le.negTabIndex}`
], Ta = pl.join(","), po = pl.map((e) => e.replace(le.negTabIndex, "")).join(","), mo = (e) => e != null && e.matches(po) ? e : ((e == null ? void 0 : e.querySelectorAll(po)) || [])[0] || null, Gf = (e) => (t) => ![...e].includes(t.className), Qa = Wa(null), Yf = ({ children: e }) => /* @__PURE__ */ h(Qa.Provider, { value: Ae([]), children: e }), Xf = () => kt(Qa, (e) => {
  if (!e)
    throw new Error("useActiveFocusScope must be used within a FocusScopesProvider");
  return e[0][e[0].length - 1];
}), Kf = () => kt(Qa, (e) => {
  if (!e)
    throw new Error("useSetFocusScopes must be used within a FocusScopesProvider");
  return e[1];
}), go = (e) => [
  e.matches(Ta) ? e : void 0,
  ...e.querySelectorAll(Ta)
].filter(Wt), Zf = ({
  customCaptureRef: e,
  disabled: t = !1,
  enableArrowKeys: n = !1,
  enableSpaceKey: r = !0,
  enableTabKey: a = !0,
  focusAllowedElementRefsAfter: i,
  focusAllowedElementRefsBefore: o,
  focusDisabledClassNames: s = ["ps__thumb-x", "ps__thumb-y"],
  onClose: l,
  onFocusReturned: u,
  onOpen: c
}) => {
  const d = ae(null), f = ae(null), g = e ?? f, v = ae(null), [C, A] = Ae(!1), k = Kf(), R = Xf(), y = (R == null ? void 0 : R.current) === g.current, w = ne(() => {
    var I;
    return [
      ...(o == null ? void 0 : o.flatMap((P) => P.current ? go(P.current) : void 0)) || [],
      ...((I = g.current) == null ? void 0 : I.querySelectorAll(Ta)) || [],
      ...(i == null ? void 0 : i.flatMap((P) => P.current ? go(P.current) : [])) || []
    ].filter(Wt).filter(Gf(s));
  }, [
    g,
    o,
    i,
    s
  ]), p = xt(w, [w]), B = ae(p[0]);
  B.current = p[0];
  const b = ne(
    (I = !0) => {
      t || (v.current = document.activeElement, k((P) => [...P, g]), A(!0), I && setTimeout(() => {
        vt(B.current, { focusVisible: "auto" });
      }, 0));
    },
    [t, g, A, k]
  ), S = ne(() => {
    t || (!d.current && v.current ? v.current !== document.activeElement && (u == null || u(), vt(v.current, { focusVisible: "auto" })) : vt(mo(d.current), {
      focusVisible: "auto"
    }), k((I) => I.slice(0, -1)), A(!1));
  }, [t, d, k, u]), O = ne(
    (I) => {
      if (t || I.metaKey || I.ctrlKey)
        return;
      const P = document.activeElement;
      if (!C && !y && P === mo(d.current) && ((I.key === "ArrowUp" || I.key === "ArrowDown") && n || I.key === " " && r) && c) {
        mn(I), c();
        return;
      }
      if (!C || !y)
        return;
      if (l && (I.key === "Escape" || I.key === "Tab" && !a)) {
        l();
        return;
      }
      const $ = w(), Q = $[0], Y = $[$.length - 1];
      if (I.key === "Tab" && !P || P && !$.includes(P)) {
        mn(I), vt(Q);
        return;
      }
      if ((a && I.key === "Tab" && !I.shiftKey || I.key === "ArrowDown" && n) && P && P !== Y) {
        const he = $.indexOf(P);
        mn(I), he > -1 ? vt($[he + 1]) : vt(Q);
        return;
      }
      if ((a && I.key === "Tab" && I.shiftKey || I.key === "ArrowUp" && n) && P && P !== Q) {
        const he = $.indexOf(P);
        mn(I), he > -1 ? vt($[he - 1]) : vt(Y);
        return;
      }
      if ((I.key === "Tab" && !I.shiftKey && a || I.key === "ArrowDown" && n) && P === Y) {
        mn(I), vt(Q);
        return;
      }
      if ((I.key === "Tab" && I.shiftKey && a || I.key === "ArrowUp" && n) && P === Q) {
        mn(I), vt(Y);
        return;
      }
    },
    [
      t,
      w,
      l,
      c,
      n,
      C,
      a,
      r,
      y
    ]
  );
  return de(() => (document.addEventListener("keydown", O), () => {
    document.removeEventListener("keydown", O);
  }), [O]), de(() => {
    if (!t && C && y) {
      const I = [
        ...o ?? [],
        g,
        ...i ?? []
      ].map((P) => (P == null ? void 0 : P.current) ?? void 0).filter(Wt);
      return Vf(I);
    }
  }, [
    g,
    C,
    t,
    i,
    o,
    y
  ]), { captureRef: g, handleMounted: b, handleUnmounted: S, returnRef: d };
}, Qf = ({
  autofocus: e = !0,
  captureRef: t,
  children: n,
  focusAllowedElementRefsAfter: r,
  focusAllowedElementRefsBefore: a
}) => {
  const { handleMounted: i, handleUnmounted: o } = Zf({
    customCaptureRef: t,
    focusAllowedElementRefsAfter: r,
    focusAllowedElementRefsBefore: a
  });
  return de(() => (i(e), () => {
    o();
  }), [i, o, e]), /* @__PURE__ */ h(Rr, { children: n });
}, ml = (e) => {
  de(() => (window.addEventListener("beforeunload", e), () => {
    window.removeEventListener("beforeunload", e);
  }), [e]);
}, Jf = (e) => {
  de(() => {
    const t = () => {
      e(document.visibilityState === "visible");
    };
    return document.addEventListener("visibilitychange", t), () => {
      document.removeEventListener("visibilitychange", t);
    };
  }, [e]);
};
function bo(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nn.apply(this, arguments);
}
function vo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wa(e, t) {
  return wa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, wa(e, t);
}
function eh(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, wa(e, t);
}
var Ca = { exports: {} }, oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yo;
function th() {
  if (yo)
    return oe;
  yo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function y(p) {
    if (typeof p == "object" && p !== null) {
      var B = p.$$typeof;
      switch (B) {
        case t:
          switch (p = p.type, p) {
            case l:
            case u:
            case r:
            case i:
            case a:
            case d:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case c:
                case v:
                case g:
                case o:
                  return p;
                default:
                  return B;
              }
          }
        case n:
          return B;
      }
    }
  }
  function w(p) {
    return y(p) === u;
  }
  return oe.AsyncMode = l, oe.ConcurrentMode = u, oe.ContextConsumer = s, oe.ContextProvider = o, oe.Element = t, oe.ForwardRef = c, oe.Fragment = r, oe.Lazy = v, oe.Memo = g, oe.Portal = n, oe.Profiler = i, oe.StrictMode = a, oe.Suspense = d, oe.isAsyncMode = function(p) {
    return w(p) || y(p) === l;
  }, oe.isConcurrentMode = w, oe.isContextConsumer = function(p) {
    return y(p) === s;
  }, oe.isContextProvider = function(p) {
    return y(p) === o;
  }, oe.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, oe.isForwardRef = function(p) {
    return y(p) === c;
  }, oe.isFragment = function(p) {
    return y(p) === r;
  }, oe.isLazy = function(p) {
    return y(p) === v;
  }, oe.isMemo = function(p) {
    return y(p) === g;
  }, oe.isPortal = function(p) {
    return y(p) === n;
  }, oe.isProfiler = function(p) {
    return y(p) === i;
  }, oe.isStrictMode = function(p) {
    return y(p) === a;
  }, oe.isSuspense = function(p) {
    return y(p) === d;
  }, oe.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === u || p === i || p === a || p === d || p === f || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === g || p.$$typeof === o || p.$$typeof === s || p.$$typeof === c || p.$$typeof === A || p.$$typeof === k || p.$$typeof === R || p.$$typeof === C);
  }, oe.typeOf = y, oe;
}
var se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _o;
function nh() {
  return _o || (_o = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function y(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === r || H === u || H === i || H === a || H === d || H === f || typeof H == "object" && H !== null && (H.$$typeof === v || H.$$typeof === g || H.$$typeof === o || H.$$typeof === s || H.$$typeof === c || H.$$typeof === A || H.$$typeof === k || H.$$typeof === R || H.$$typeof === C);
    }
    function w(H) {
      if (typeof H == "object" && H !== null) {
        var et = H.$$typeof;
        switch (et) {
          case t:
            var Pe = H.type;
            switch (Pe) {
              case l:
              case u:
              case r:
              case i:
              case a:
              case d:
                return Pe;
              default:
                var tt = Pe && Pe.$$typeof;
                switch (tt) {
                  case s:
                  case c:
                  case v:
                  case g:
                  case o:
                    return tt;
                  default:
                    return et;
                }
            }
          case n:
            return et;
        }
      }
    }
    var p = l, B = u, b = s, S = o, O = t, I = c, P = r, $ = v, Q = g, Y = n, he = i, G = a, we = d, Ce = !1;
    function ie(H) {
      return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ct(H) || w(H) === l;
    }
    function ct(H) {
      return w(H) === u;
    }
    function be(H) {
      return w(H) === s;
    }
    function Ht(H) {
      return w(H) === o;
    }
    function pe(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function Je(H) {
      return w(H) === c;
    }
    function At(H) {
      return w(H) === r;
    }
    function Dt(H) {
      return w(H) === v;
    }
    function bt(H) {
      return w(H) === g;
    }
    function dt(H) {
      return w(H) === n;
    }
    function Lt(H) {
      return w(H) === i;
    }
    function Me(H) {
      return w(H) === a;
    }
    function We(H) {
      return w(H) === d;
    }
    se.AsyncMode = p, se.ConcurrentMode = B, se.ContextConsumer = b, se.ContextProvider = S, se.Element = O, se.ForwardRef = I, se.Fragment = P, se.Lazy = $, se.Memo = Q, se.Portal = Y, se.Profiler = he, se.StrictMode = G, se.Suspense = we, se.isAsyncMode = ie, se.isConcurrentMode = ct, se.isContextConsumer = be, se.isContextProvider = Ht, se.isElement = pe, se.isForwardRef = Je, se.isFragment = At, se.isLazy = Dt, se.isMemo = bt, se.isPortal = dt, se.isProfiler = Lt, se.isStrictMode = Me, se.isSuspense = We, se.isValidElementType = y, se.typeOf = w;
  }()), se;
}
process.env.NODE_ENV === "production" ? Ca.exports = th() : Ca.exports = nh();
var rh = Ca.exports, Ja = rh, ah = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, ih = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, oh = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, gl = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ei = {};
ei[Ja.ForwardRef] = oh;
ei[Ja.Memo] = gl;
function Eo(e) {
  return Ja.isMemo(e) ? gl : ei[e.$$typeof] || ah;
}
var sh = Object.defineProperty, lh = Object.getOwnPropertyNames, So = Object.getOwnPropertySymbols, uh = Object.getOwnPropertyDescriptor, ch = Object.getPrototypeOf, To = Object.prototype;
function bl(e, t, n) {
  if (typeof t != "string") {
    if (To) {
      var r = ch(t);
      r && r !== To && bl(e, r, n);
    }
    var a = lh(t);
    So && (a = a.concat(So(t)));
    for (var i = Eo(e), o = Eo(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!ih[l] && !(n && n[l]) && !(o && o[l]) && !(i && i[l])) {
        var u = uh(t, l);
        try {
          sh(e, l, u);
        } catch {
        }
      }
    }
  }
  return e;
}
var dh = bl;
const fh = /* @__PURE__ */ Rs(dh);
function hh(e, t) {
  if (!e) {
    var n = new Error("loadable: " + t);
    throw n.framesToPop = 1, n.name = "Invariant Violation", n;
  }
}
var ph = /* @__PURE__ */ mt.createContext(), mh = {
  initialChunks: {}
}, wo = "PENDING", gh = "RESOLVED", Kr = "REJECTED";
function bh(e) {
  return typeof e == "function" ? {
    requireAsync: e,
    resolve: function() {
    },
    chunkName: function() {
    }
  } : e;
}
var vh = function(t) {
  var n = function(a) {
    return mt.createElement(ph.Consumer, null, function(i) {
      return mt.createElement(t, Object.assign({
        __chunkExtractor: i
      }, a));
    });
  };
  return t.displayName && (n.displayName = t.displayName + "WithChunkExtractor"), n;
}, yh = function(t) {
  return t;
};
function vl(e) {
  var t = e.defaultResolveComponent, n = t === void 0 ? yh : t, r = e.render, a = e.onLoad;
  function i(s, l) {
    l === void 0 && (l = {});
    var u = bh(s), c = {};
    function d(k) {
      return l.cacheKey ? l.cacheKey(k) : u.resolve ? u.resolve(k) : "static";
    }
    function f(k, R, y) {
      var w = l.resolveComponent ? l.resolveComponent(k, R) : n(k);
      return fh(y, w, {
        preload: !0
      }), w;
    }
    var g = function(R) {
      var y = d(R), w = c[y];
      return (!w || w.status === Kr) && (w = u.requireAsync(R), w.status = wo, c[y] = w, w.then(function() {
        w.status = gh;
      }, function(p) {
        console.error("loadable-components: failed to asynchronously load component", {
          fileName: u.resolve(R),
          chunkName: u.chunkName(R),
          error: p && p.message
        }), w.status = Kr;
      })), w;
    }, v = /* @__PURE__ */ function(k) {
      eh(R, k), R.getDerivedStateFromProps = function(p, B) {
        var b = d(p);
        return Nn({}, B, {
          cacheKey: b,
          // change of a key triggers loading state automatically
          loading: B.loading || B.cacheKey !== b
        });
      };
      function R(w) {
        var p;
        return p = k.call(this, w) || this, p.state = {
          result: null,
          error: null,
          loading: !0,
          cacheKey: d(w)
        }, hh(!w.__chunkExtractor || u.requireSync, "SSR requires `@loadable/babel-plugin`, please install it"), w.__chunkExtractor ? (l.ssr === !1 || (u.requireAsync(w).catch(function() {
          return null;
        }), p.loadSync(), w.__chunkExtractor.addChunk(u.chunkName(w))), vo(p)) : (l.ssr !== !1 && // is ready - was loaded in this session
        (u.isReady && u.isReady(w) || // is ready - was loaded during SSR process
        u.chunkName && mh.initialChunks[u.chunkName(w)]) && p.loadSync(), p);
      }
      var y = R.prototype;
      return y.componentDidMount = function() {
        this.mounted = !0;
        var p = this.getCache();
        p && p.status === Kr && this.setCache(), this.state.loading && this.loadAsync();
      }, y.componentDidUpdate = function(p, B) {
        B.cacheKey !== this.state.cacheKey && this.loadAsync();
      }, y.componentWillUnmount = function() {
        this.mounted = !1;
      }, y.safeSetState = function(p, B) {
        this.mounted && this.setState(p, B);
      }, y.getCacheKey = function() {
        return d(this.props);
      }, y.getCache = function() {
        return c[this.getCacheKey()];
      }, y.setCache = function(p) {
        p === void 0 && (p = void 0), c[this.getCacheKey()] = p;
      }, y.triggerOnLoad = function() {
        var p = this;
        a && setTimeout(function() {
          a(p.state.result, p.props);
        });
      }, y.loadSync = function() {
        if (this.state.loading)
          try {
            var p = u.requireSync(this.props), B = f(p, this.props, A);
            this.state.result = B, this.state.loading = !1;
          } catch (b) {
            console.error("loadable-components: failed to synchronously load component, which expected to be available", {
              fileName: u.resolve(this.props),
              chunkName: u.chunkName(this.props),
              error: b && b.message
            }), this.state.error = b;
          }
      }, y.loadAsync = function() {
        var p = this, B = this.resolveAsync();
        return B.then(function(b) {
          var S = f(b, p.props, A);
          p.safeSetState({
            result: S,
            loading: !1
          }, function() {
            return p.triggerOnLoad();
          });
        }).catch(function(b) {
          return p.safeSetState({
            error: b,
            loading: !1
          });
        }), B;
      }, y.resolveAsync = function() {
        var p = this.props;
        p.__chunkExtractor, p.forwardedRef;
        var B = bo(p, ["__chunkExtractor", "forwardedRef"]);
        return g(B);
      }, y.render = function() {
        var p = this.props, B = p.forwardedRef, b = p.fallback;
        p.__chunkExtractor;
        var S = bo(p, ["forwardedRef", "fallback", "__chunkExtractor"]), O = this.state, I = O.error, P = O.loading, $ = O.result;
        if (l.suspense) {
          var Q = this.getCache() || this.loadAsync();
          if (Q.status === wo)
            throw this.loadAsync();
        }
        if (I)
          throw I;
        var Y = b || l.fallback || null;
        return P ? Y : r({
          fallback: Y,
          result: $,
          options: l,
          props: Nn({}, S, {
            ref: B
          })
        });
      }, R;
    }(mt.Component), C = vh(v), A = mt.forwardRef(function(k, R) {
      return mt.createElement(C, Object.assign({
        forwardedRef: R
      }, k));
    });
    return A.displayName = "Loadable", A.preload = function(k) {
      A.load(k);
    }, A.load = function(k) {
      return g(k);
    }, A;
  }
  function o(s, l) {
    return i(s, Nn({}, l, {
      suspense: !0
    }));
  }
  return {
    loadable: i,
    lazy: o
  };
}
function _h(e) {
  return e.__esModule ? e.default : e.default || e;
}
var yl = /* @__PURE__ */ vl({
  defaultResolveComponent: _h,
  render: function(t) {
    var n = t.result, r = t.props;
    return mt.createElement(n, r);
  }
}), Eh = yl.loadable, Sh = yl.lazy, _l = /* @__PURE__ */ vl({
  onLoad: function(t, n) {
    t && n.forwardedRef && (typeof n.forwardedRef == "function" ? n.forwardedRef(t) : n.forwardedRef.current = t);
  },
  render: function(t) {
    var n = t.result, r = t.props;
    return r.children ? r.children(n) : null;
  }
}), Th = _l.loadable, wh = _l.lazy, El = Eh;
El.lib = Th;
var Ch = Sh;
Ch.lib = wh;
const Ih = Xu(["color", "size"]), Rh = "cb_Spinner_root_rpin", kh = "cb_Spinner_animationContainer_a1x9", Ah = "cb_Spinner_container1_c3ni", Lh = "cb_Spinner_container2_c158", Oh = "cb_Spinner_container3_c1m1", Sl = Qe(({
  className: e,
  color: t = "blue",
  size: n,
  style: r,
  styleParams: a,
  ...i
}, o) => (Mu("consumer"), /* @__PURE__ */ h("div", {
  className: re(Rh, e),
  "data-color": t,
  "data-size": n,
  ...i,
  ref: o,
  style: a ? {
    ...r,
    ...ja(Ih, a)
  } : r,
  children: /* @__PURE__ */ V("div", {
    className: kh,
    children: [/* @__PURE__ */ h("div", {
      className: Ah,
      children: /* @__PURE__ */ h("svg", {
        viewBox: "0 0 50 50",
        children: /* @__PURE__ */ h("circle", {
          cx: "25",
          cy: "25",
          fill: "none",
          r: "20",
          strokeWidth: "5"
        })
      })
    }), /* @__PURE__ */ h("div", {
      className: Lh,
      children: /* @__PURE__ */ h("svg", {
        viewBox: "0 0 50 50",
        children: /* @__PURE__ */ h("circle", {
          cx: "25",
          cy: "25",
          fill: "none",
          r: "20",
          strokeWidth: "5"
        })
      })
    }), /* @__PURE__ */ h("div", {
      className: Oh,
      children: /* @__PURE__ */ h("svg", {
        viewBox: "0 0 50 50",
        children: /* @__PURE__ */ h("circle", {
          cx: "25",
          cy: "25",
          fill: "none",
          r: "20",
          strokeWidth: "5"
        })
      })
    })]
  })
})));
Sl.displayName = "Spinner";
const Mh = () => {
  const [e, t] = Ae(
    typeof document > "u" ? !1 : document.visibilityState === "visible"
  ), n = ne(() => t(document.visibilityState === "visible"), [t]);
  return de(() => {
    if (!(typeof document > "u"))
      return document.addEventListener("visibilitychange", n), () => document.removeEventListener("visibilitychange", n);
  }, [n]), e;
};
function Ph(e, t) {
  const n = ae(e);
  de(() => {
    n.current = e;
  }, [e]), de(() => {
    function r() {
      n.current();
    }
    if (t !== void 0) {
      const a = setInterval(r, t);
      return () => {
        clearInterval(a);
      };
    }
  }, [t]);
}
const Nh = (e, t) => {
  const n = Date.now() - e;
  return Math.max(t - n, 0);
}, xh = (e, t, n = !0, r = !0) => {
  const a = Mh(), i = ae(), [o, s] = Ae(t), l = ne(() => i.current ? Nh(i.current, t) : t, [t, i]), u = ne(() => {
    i.current = void 0, e();
  }, [e]), c = ne(() => {
    if (!i.current)
      return;
    const d = setTimeout(() => {
      u(), s(t);
    }, l());
    return () => clearTimeout(d);
  }, [u, t, s, l]);
  de(() => {
    !n || !r || e();
  }, [n, e]), de(() => {
    s(l());
  }, [l, s]), de(() => {
    if (n)
      return a || (i.current || (i.current = Date.now()), s(void 0)), c();
  }, [i, s, n, a, c]), Ph(u, n ? o : void 0);
}, Bh = El.lib(() => import("@lottiefiles/react-lottie-player")), Hh = () => ({
  aspectRatio: e
}) => {
  switch (e) {
    case "3/2":
      return `${2 / 3 * 100}%`;
    case "1/1":
      return "100%";
    default:
      return "0";
  }
}, Dh = () => ({
  aspectRatio: e
}) => e !== void 0 ? "absolute" : "static", $h = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-LottiePlayer_Root_rkdtiqf",
  propsAsIs: !1,
  vars: {
    "rkdtiqf-0": [Hh()],
    "rkdtiqf-1": [Dh()]
  }
}), Fh = /* @__PURE__ */ M("div")({
  name: "SpinnerContainer",
  class: "support-layer-LottiePlayer_SpinnerContainer_s1sduw4r",
  propsAsIs: !1
}), ti = q.forwardRef(({
  aspectRatio: e,
  autoplay: t = !0,
  className: n,
  dataTestId: r,
  interval: a,
  loop: i = !1,
  seeker: o,
  showSpinner: s = !0,
  src: l,
  style: u
}, c) => {
  const [d, f] = Ae(!1), [g, v] = Ae(!1), C = ae(null), A = xt(() => Cs([c, C]), [c]), k = Fn(o), R = ae(null);
  de(() => {
    var p;
    (p = R == null ? void 0 : R.current) != null && p.isLoaded && o !== void 0 && (k == null ? void 0 : k.from) !== (o == null ? void 0 : o.from) && (k == null ? void 0 : k.to) !== (o == null ? void 0 : o.to) && (R == null || R.current.playSegments([o == null ? void 0 : o.from, o.to], !0));
  }, [k, o]), xh(() => {
    var p;
    return (p = C.current) == null ? void 0 : p.play();
  }, a || 1e4, d && !g && t, !1);
  const [y, w] = Ae(!1);
  return de(() => {
    if (d)
      return;
    const p = setTimeout(() => w(!0), 300);
    return () => clearTimeout(p);
  }, [d]), /* @__PURE__ */ V($h, {
    aspectRatio: e,
    "data-test-id": r,
    className: n,
    style: u,
    "aria-hidden": !0,
    children: [s && !d && y && /* @__PURE__ */ h(Fh, {
      children: /* @__PURE__ */ h(Sl, {
        color: "lightGrey",
        size: "large"
      })
    }), /* @__PURE__ */ h(Bh, {
      children: ({
        Player: p,
        PlayerEvent: B
      }) => {
        const b = (S) => {
          var O;
          switch (S) {
            case B.Load:
              f(!0), o && ((O = R == null ? void 0 : R.current) == null || O.playSegments([o == null ? void 0 : o.from, o.to], !0));
              break;
            case B.Play:
              v(!0);
              break;
            case B.Complete:
            case B.Pause:
              v(!1);
              break;
          }
        };
        return /* @__PURE__ */ h(Be.div, {
          animate: {
            opacity: d ? 1 : 0
          },
          style: {
            opacity: 0
          },
          children: p && /* @__PURE__ */ h(p, {
            lottieRef: (S) => {
              R.current = S;
            },
            loop: i,
            ref: A,
            onEvent: b,
            src: l,
            autoplay: t ?? !0
          })
        });
      }
    })]
  });
});
ti.displayName = "LottiePlayer";
const Tl = 1200, Uh = [200, 300, 600, 960, Tl, 1600, 1920], zh = (e) => typeof e == "string" ? e : e.map(({ intrinsicWidth: t, viewportMinWidth: n }) => `(min-width: ${n}) ${t}`).concat("100vw").join(", "), Wh = (e, t) => {
  if (t === Tl)
    return e;
  try {
    const n = new URL(e);
    return n.searchParams.set("w", String(t)), n.toString();
  } catch {
    return e;
  }
}, jh = (e) => Uh.map((t) => `${Wh(e, t)} ${t}w`).join(", "), qh = (e) => e.split(",").map((n) => {
  const r = n.trim(), a = r.split(" ");
  if (a.length > 2)
    return r;
  const [i, o] = a;
  return o ? [i, o].join(" ") : i;
}).join(", ");
function Vh(e) {
  switch (e) {
    case "likelyLCP":
      return {
        decoding: "auto",
        // might not make much of a difference; left for completeness
        fetchPriority: "high",
        loading: "eager"
      };
    case "likelyVisible":
      return {
        decoding: "async",
        loading: "eager"
      };
    case "lazy":
      return {
        decoding: "async",
        loading: "lazy"
      };
    default:
      return {
        decoding: "async",
        loading: "lazy"
      };
  }
}
const ni = Qe(
  ({ alt: e, decoding: t, fetchPriority: n, loading: r, loadingStrategy: a, sizes: i, src: o, srcSet: s, ...l }, u) => {
    const c = i && zh(i), d = s ? qh(s) : i && o && jh(o);
    process.env.NODE_ENV === "development" && (d && !c && Ui(
      `Image was provided a "srcSet" prop, but no "sizes" prop. This will lead to suboptimal loading. srcSet: ${s}`
    ), a && (r || n || t) && Ui(
      `You have specified both a loading strategy and one of loading/fetchPriority/decoding. Ad-hoc props will take priority. Remove loadingStrategy or the ad-hoc props to clear this message. ${o}`
    ));
    const f = Vh(a);
    return /* @__PURE__ */ h(
      "img",
      {
        loading: r ?? f.loading,
        decoding: t ?? f.decoding,
        fetchpriority: n ?? f.fetchPriority,
        sizes: c,
        srcSet: d,
        src: o,
        ref: u,
        alt: e ?? "",
        ...l
      }
    );
  }
);
ni.displayName = "Image";
var wl = {}, ri = {}, ai = {};
Object.defineProperty(ai, "__esModule", { value: !0 });
var Gh = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  ":",
  ";"
];
ai.decode64 = function(e) {
  for (var t = 0, n = 0; n < e.length; n++) {
    var r = e[n], a = Gh.indexOf(r);
    t = (t << 6) + a;
  }
  return t;
};
var Cl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.sRGBToLinear = function(t) {
    var n = t / 255;
    return n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }, e.linearTosRGB = function(t) {
    var n = Math.max(0, Math.min(1, t));
    return n <= 31308e-7 ? Math.round(n * 12.92 * 255 + 0.5) : Math.round((1.055 * Math.pow(n, 1 / 2.4) - 0.055) * 255 + 0.5);
  }, e.sign = function(t) {
    return t < 0 ? -1 : 1;
  }, e.signPow = function(t, n) {
    return e.sign(t) * Math.pow(Math.abs(t), n);
  };
})(Cl);
Object.defineProperty(ri, "__esModule", { value: !0 });
var ar = ai, Pt = Cl, Yh = function(e) {
  var t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [Pt.sRGBToLinear(t), Pt.sRGBToLinear(n), Pt.sRGBToLinear(r)];
}, Xh = function(e, t) {
  var n = e >> 8, r = e >> 4 & 15, a = e & 15, i = [
    Pt.signPow((n - 8) / 8, 3) * t * 2,
    Pt.signPow((r - 8) / 8, 3) * t * 2,
    Pt.signPow((a - 8) / 8, 3) * t * 2
  ];
  return i;
}, Kh = function(e, t, n, r) {
  if (r = r | 1, e.length < 6)
    return null;
  var a = ar.decode64(e[0]), i = (a >> 3) + 1, o = (a & 7) + 1, s = ar.decode64(e[1]), l = (s + 1) / 128;
  if (e.length !== 4 + 2 * o * i)
    return null;
  for (var u = new Array(o * i), c = 0; c < u.length; c++)
    if (c === 0) {
      var d = ar.decode64(e.substring(2, 6));
      u[c] = Yh(d);
    } else {
      var d = ar.decode64(e.substring(4 + c * 2, 6 + c * 2));
      u[c] = Xh(d, l * r);
    }
  for (var f = t * 4, g = new Uint8ClampedArray(f * n), v = 0; v < n; v++)
    for (var C = 0; C < t; C++) {
      for (var A = 0, k = 0, R = 0, y = 0; y < i; y++)
        for (var c = 0; c < o; c++) {
          var w = Math.cos(Math.PI * C * c / t) * Math.cos(Math.PI * v * y / n), p = u[c + y * o];
          A += p[0] * w, k += p[1] * w, R += p[2] * w;
        }
      var B = Pt.linearTosRGB(A), b = Pt.linearTosRGB(k), S = Pt.linearTosRGB(R);
      g[4 * C + 0 + v * f] = B, g[4 * C + 1 + v * f] = b, g[4 * C + 2 + v * f] = S, g[4 * C + 3 + v * f] = 255;
    }
  return g;
};
ri.default = Kh;
Object.defineProperty(wl, "__esModule", { value: !0 });
var Zh = ri, Qh = wl.decode = Zh.default;
const Co = 16, Jh = /* @__PURE__ */ M("canvas")({
  name: "Canvas",
  class: "support-layer-BlurHashImage_Canvas_c1njdiw3",
  propsAsIs: !1
}), ep = ({
  alt: e = "",
  blurhash: t,
  resolutionX: n = Co,
  resolutionY: r = Co,
  ...a
}) => {
  const i = ne((o) => {
    if (!o || !t)
      return;
    const s = o.getContext("2d"), l = Qh(t, n, r);
    if (l && s) {
      const u = s.createImageData(n, r);
      u.data.set(l), s.putImageData(u, 0, 0);
    }
  }, [t, n, r]);
  return /* @__PURE__ */ h(Jh, {
    ...a,
    role: e === "" ? "presentation" : "img",
    "aria-label": e === "" ? void 0 : e,
    width: n,
    height: r,
    ref: i
  });
}, tp = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-ImageWithBlurHashTransition_Root_r1yqgjbh",
  propsAsIs: !1
}), Io = "support-layer-ImageWithBlurHashTransition_coverContainerCss_cehv92q", np = () => Be(ni), Ro = /* @__PURE__ */ M(np())({
  name: "StyledImage",
  class: "support-layer-ImageWithBlurHashTransition_StyledImage_s1k6sgq5",
  propsAsIs: !0
}), rp = Be.span, Ia = (e = "") => typeof e == "string" ? e : e.map(({
  intrinsicWidth: t,
  viewportMinWidth: n
}) => `${n}${t}`).join(""), Ra = /* @__PURE__ */ new Set(), ko = (e, t, n, r, {
  markLoadedImmediately: a
} = {}) => {
  if (!(!e || e["data-loaded-src"] === t)) {
    if (e["data-loaded-src"] = t, a) {
      Ra.add(`${t}${Ia(n)}`), r(!0);
      return;
    }
    e.decode().catch(() => {
    }).then(() => {
      !e.parentNode || !e.isConnected || (Ra.add(`${t}${Ia(n)}`), r(!0));
    });
  }
}, Il = Qe(({
  alt: e,
  blurhash: t,
  className: n,
  draggable: r = !0,
  imageUrl: a,
  loadingStrategy: i,
  sizes: o,
  style: s
}, l) => {
  const [u, c] = Ae(() => Ra.has(`${a}${Ia(o)}`));
  return /* @__PURE__ */ V(tp, {
    className: n,
    style: s,
    ref: l,
    children: [/* @__PURE__ */ h(Ro, {
      className: Io,
      alt: e,
      loadingStrategy: i,
      src: a,
      sizes: o,
      ref: ne((d) => {
        d != null && d.complete && ko(d, a, o, c, {
          markLoadedImmediately: !0
        });
      }, [a, o]),
      onLoad: (d) => {
        ko(d.currentTarget, a, o, c);
      },
      onError: () => {
        c(!0);
      },
      draggable: r
    }), /* @__PURE__ */ h(It, {
      initial: !1,
      children: !u && t !== null && /* @__PURE__ */ h(rp, {
        className: Io,
        initial: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          bounce: 0,
          duration: 0.2
        },
        children: /* @__PURE__ */ h(ep, {
          blurhash: t,
          alt: ""
        })
      }, "placeholder")
    }), /* @__PURE__ */ h("noscript", {
      children: /* @__PURE__ */ h(Ro, {
        alt: e,
        src: a,
        sizes: o,
        loadingStrategy: i
      })
    })]
  });
});
Il.displayName = "ImageWithBlurHashTransition";
const ap = (e) => /* @__PURE__ */ V("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ h("circle", { cx: "12", cy: "12", r: "12" }),
  /* @__PURE__ */ h(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
    }
  )
] }), ip = (e) => /* @__PURE__ */ V("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ h("circle", { cx: "12", cy: "12", r: "12" }),
  /* @__PURE__ */ h(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12C4 12.5523 4.44772 13 5 13H10.8333C10.9254 13 11 13.0746 11 13.1667V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.1667C13 13.0746 13.0746 13 13.1667 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13.1667C13.0746 11 13 10.9254 13 10.8333V5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V10.8333C11 10.9254 10.9254 11 10.8333 11H5C4.44772 11 4 11.4477 4 12Z"
    }
  )
] }), op = (e) => new Promise((t) => setTimeout(t, e)), sp = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-StepperInput_Root_rjq0jlk",
  propsAsIs: !1
}), lp = {
  large: "support-layer-StepperInput_large_lo4tqsv",
  medium: "support-layer-StepperInput_medium_m124aer7"
}, up = /* @__PURE__ */ M("div")({
  name: "VisibleInput",
  class: "support-layer-StepperInput_VisibleInput_vbcf7rx",
  propsAsIs: !1
}), Ao = /* @__PURE__ */ M("button")({
  name: "ValueButton",
  class: "support-layer-StepperInput_ValueButton_vpl4u3i",
  propsAsIs: !1
}), cp = /* @__PURE__ */ M("span")({
  name: "ValueLabel",
  class: "support-layer-StepperInput_ValueLabel_vcrtl9k",
  propsAsIs: !1
}), dp = /* @__PURE__ */ M("label")({
  name: "HiddenLabel",
  class: "support-layer-StepperInput_HiddenLabel_hewkc33",
  propsAsIs: !1
}), fp = /* @__PURE__ */ M("input")({
  name: "HiddenInput",
  class: "support-layer-StepperInput_HiddenInput_h14wy2lk",
  propsAsIs: !1
}), hp = /* @__PURE__ */ M("div")({
  name: "CenteredValueContainer",
  class: "support-layer-StepperInput_CenteredValueContainer_cz4ktoc",
  propsAsIs: !1
}), pp = "data-animate-bubble", mp = "data-animate-counter-value", gp = "data-animate-long-press", bp = /* @__PURE__ */ M("div")({
  name: "AnimatedQuantityBubbleWrapper",
  class: "support-layer-StepperInput_AnimatedQuantityBubbleWrapper_ae15q1w",
  propsAsIs: !1
}), vp = /* @__PURE__ */ M("div")({
  name: "QuantityBubble",
  class: "support-layer-StepperInput_QuantityBubble_q1e2d7zm",
  propsAsIs: !1
}), yp = /* @__PURE__ */ M("div")({
  name: "LabelWrapper",
  class: "support-layer-StepperInput_LabelWrapper_l2vr2wm",
  propsAsIs: !1
}), Lo = {
  firstLongPressDelay: 200,
  firstLongPressDuration: 1500,
  firstLongPressTimeInterval: 400,
  secondLongPressTimeInterval: 100
}, Rl = Qe((e, t) => {
  const {
    className: n,
    "data-test-id": r,
    decrementAriaLabel: a,
    formatValue: i = (G) => G,
    incrementAriaLabel: o,
    label: s,
    max: l,
    min: u,
    onChange: c,
    onClickDisabledIncrement: d,
    size: f = "large",
    step: g = 1,
    value: v,
    ...C
  } = e, A = q.useRef(null), k = q.useMemo(() => Cs([t, A]), [t]), R = ae(v);
  de(() => {
    R.current = v;
  }, [v]);
  const y = ne((G) => l !== void 0 && typeof l == "number" && G >= l, [l]), w = ae(null), p = ae(null), B = jr(w, pp, !0), b = jr(p, mp, !0), S = jr(w, gp, !1), O = ne(() => {
    y(R.current) || (S.animate(), c(R.current + g));
  }, [y, S, c, g]), I = ne(() => {
    const G = R.current - g;
    if (Wt(u) && typeof u == "number" && G < u) {
      S.reset();
      return;
    }
    S.animate(), c(R.current - g);
  }, [u, S, c, g]), P = ne((G) => {
    var Ce;
    if (y(R.current))
      return;
    const we = R.current + g;
    we === l && G.detail === 0 && ((Ce = A.current) == null || Ce.focus()), B.animate(), b.animate(), c(we);
  }, [y, B, b, c, g, l]), $ = ne((G) => {
    var Ce;
    const we = R.current - g;
    Wt(u) && typeof u == "number" && we < u || (we === u && G.detail === 0 && ((Ce = A.current) == null || Ce.focus()), B.animate(), b.animate(), c(we));
  }, [u, g, B, b, c]), Q = ne(async () => {
    await op(50), S.reset(), B.reset(), b.reset();
  }, [B, b, S]), Y = qi({
    onClick: P,
    onPress: O,
    onStop: Q,
    timings: Lo
  }), he = qi({
    onClick: $,
    onPress: I,
    onStop: Q,
    timings: Lo
  });
  return /* @__PURE__ */ V(sp, {
    className: n,
    children: [/* @__PURE__ */ V(dp, {
      htmlFor: "stepper",
      children: [s, /* @__PURE__ */ h("span", {
        "aria-live": "polite",
        children: v || 0
      })]
    }), /* @__PURE__ */ h(fp, {
      id: "stepper",
      type: "number",
      max: l,
      min: u,
      step: g,
      value: v,
      onChange: (G) => c(Number(G == null ? void 0 : G.target.value)),
      ref: k,
      "data-test-id": r,
      ...C
    }), /* @__PURE__ */ V(up, {
      className: lp[f],
      children: [/* @__PURE__ */ h(Ao, {
        type: "button",
        onClick: (G) => he.handleClick(G),
        "aria-disabled": u === void 0 || typeof u != "number" ? !1 : v <= u,
        "aria-label": a,
        "data-test-id": `${r}.decrement`,
        onMouseDown: (G) => he.handleMouseDown(G),
        onMouseLeave: he.handleMouseLeave,
        children: /* @__PURE__ */ h(ap, {
          "aria-hidden": !0
        })
      }), /* @__PURE__ */ V(hp, {
        "aria-hidden": !0,
        children: [/* @__PURE__ */ h(bp, {
          ref: w,
          onAnimationEnd: B.reset,
          children: /* @__PURE__ */ h(vp, {
            children: i(v ?? 0)
          })
        }), /* @__PURE__ */ h(yp, {
          ref: p,
          children: /* @__PURE__ */ h(cp, {
            "data-test-id": `${r}.value`,
            "aria-hidden": !0,
            children: i(v || 0)
          })
        })]
      }), /* @__PURE__ */ h(Ao, {
        type: "button",
        onClick: (G) => {
          y(v) ? d == null || d() : Y.handleClick(G);
        },
        className: y(v) ? "disabled" : void 0,
        "aria-disabled": !d && y(v),
        "aria-label": o,
        "data-test-id": `${r}.increment`,
        onMouseDown: (G) => {
          y(v) || Y.handleMouseDown(G);
        },
        onMouseLeave: Y.handleMouseLeave,
        children: /* @__PURE__ */ h(ip, {
          "aria-hidden": !0
        })
      })]
    })]
  });
});
Rl.displayName = "StepperInput";
const _p = ({ animationData: e, container: t }) => {
  if (!t)
    return;
  const n = Ku.loadAnimation({
    animationData: e,
    autoplay: !1,
    container: t,
    loop: !1,
    renderer: "svg"
  });
  return n.addEventListener("complete", () => {
    n.stop();
  }), n;
}, ka = [], Ep = (e, t) => {
  t && (ka[e] = t);
}, Sp = ({
  lottieFiles: e,
  lottiePlayers: t,
  setLottiePlayer: n
}) => (de(() => {
  t.length || e.forEach((r, a) => {
    const i = _p({
      animationData: r,
      container: ka[a]
    });
    i && n(a, i);
  });
}, [e]), {
  lottieContainers: ka,
  setLottieContainer: Ep
}), Tp = () => {
  const [e, t] = Ae([]);
  return {
    lottiePlayers: e,
    setLottiePlayer: (r, a) => {
      t((i) => [...i].toSpliced(r, 1, a));
    }
  };
}, wp = ["disgusted", "sad", "meh", "happy", "excited"], Cp = 100, Ip = ({
  lottieFiles: e,
  onSelect: t
}) => {
  const { lottiePlayers: n, setLottiePlayer: r } = Tp(), a = xt(() => Fa(t, Cp), [t]), { lottieContainers: i, setLottieContainer: o } = Sp({
    lottieFiles: e,
    lottiePlayers: n,
    setLottiePlayer: r
  });
  return {
    makeHandleClick: (u) => () => {
      const c = n[u], d = i[u];
      !c || !d || a({
        lottieContainer: d,
        lottiePlayer: c,
        rating: u + 1
      });
    },
    makeHandleHover: (u) => () => {
      const c = n[u];
      c && c.play();
    },
    ratings: wp,
    setLottieContainer: o
  };
}, Rp = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-CsatRatingInput_Root_r1oiosgw",
  propsAsIs: !1
}), kp = () => Un, Ap = /* @__PURE__ */ M(kp())({
  name: "RatingButton",
  class: "support-layer-CsatRatingInput_RatingButton_rklnw30",
  propsAsIs: !0
}), Lp = /* @__PURE__ */ M("span")({
  name: "RatingLabel",
  class: "support-layer-CsatRatingInput_RatingLabel_r12jttm4",
  propsAsIs: !1
}), Op = /* @__PURE__ */ M("div")({
  name: "RatingLottieContainer",
  class: "support-layer-CsatRatingInput_RatingLottieContainer_r1kwmmur",
  propsAsIs: !1
}), kl = Qe(({
  labels: e,
  lottieFiles: t,
  onSelect: n,
  ...r
}, a) => {
  const {
    makeHandleClick: i,
    makeHandleHover: o,
    ratings: s,
    setLottieContainer: l
  } = Ip({
    lottieFiles: t,
    onSelect: n
  });
  return /* @__PURE__ */ h(Rp, {
    ...r,
    ref: a,
    children: s.map((u, c) => /* @__PURE__ */ V(Ap, {
      type: "button",
      onMouseEnter: o(c),
      onClick: i(c),
      children: [/* @__PURE__ */ h(Op, {
        "aria-hidden": "true",
        ref: (d) => l(c, d)
      }), /* @__PURE__ */ h(Lp, {
        children: e[u]
      })]
    }, u))
  });
});
kl.displayName = "CsatRatingInput";
const Mp = 16, Pp = 40, Oo = Mp * 2 + Pp, Np = /* @__PURE__ */ M("footer")({
  name: "Root",
  class: "support-layer-ModalCardFooter_Root_rddy57h",
  propsAsIs: !1
}), Al = Qe(({
  children: e,
  ...t
}, n) => /* @__PURE__ */ h(Np, {
  ref: n,
  ...t,
  children: e
}));
Al.displayName = "ModalCardFooter";
const ii = /* @__PURE__ */ M("div")({
  name: "HeaderButtonContainer",
  class: "support-layer-ModalCardHeader_HeaderButtonContainer_h192k0e9",
  propsAsIs: !1
}), xp = () => ii, Bp = /* @__PURE__ */ M(xp())({
  name: "BackButtonContainer",
  class: "support-layer-ModalCardHeader_BackButtonContainer_bfjdsvf",
  propsAsIs: !0
}), Hp = () => ii, Dp = /* @__PURE__ */ M(Hp())({
  name: "CloseButtonContainer",
  class: "support-layer-ModalCardHeader_CloseButtonContainer_c1jx68az",
  propsAsIs: !0
}), $p = () => ws, Fp = /* @__PURE__ */ M($p())({
  name: "BackIcon",
  class: "support-layer-ModalCardHeader_BackIcon_bemevla",
  propsAsIs: !0
}), Up = {
  animate: {
    opacity: 1,
    transition: {
      delay: 0.15,
      duration: 0.2,
      ease: "linear"
    }
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.15,
      duration: 0.2,
      ease: "linear"
    }
  },
  initial: {
    opacity: 0
  }
}, zp = ({
  backButtonRef: e,
  closeButtonRef: t,
  onBackClick: n,
  onCloseClick: r
}) => {
  const a = kr();
  return /* @__PURE__ */ V(Rr, {
    children: [/* @__PURE__ */ h(It, {
      children: !!n && /* @__PURE__ */ h(Bp, {
        children: /* @__PURE__ */ h(Be.div, {
          custom: {
            direction: a
          },
          variants: Up,
          initial: "initial",
          animate: "animate",
          exit: "exit",
          children: /* @__PURE__ */ h(sa, {
            ref: e,
            "aria-label": "Back",
            icon: Fp,
            onClick: n,
            variant: "neutral",
            "data-test-id": "BackButton"
          })
        })
      })
    }), !!r && /* @__PURE__ */ h(Dp, {
      children: /* @__PURE__ */ h(sa, {
        ref: t,
        "aria-label": "Close",
        icon: Zu,
        onClick: r,
        variant: "neutral",
        "data-test-id": "modal-close-button"
      })
    })]
  });
};
/*!
 * perfect-scrollbar v1.5.3
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function Tt(e) {
  return getComputedStyle(e);
}
function Ge(e, t) {
  for (var n in t) {
    var r = t[n];
    typeof r == "number" && (r = r + "px"), e.style[n] = r;
  }
  return e;
}
function ir(e) {
  var t = document.createElement("div");
  return t.className = e, t;
}
var Mo = typeof Element < "u" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function Ft(e, t) {
  if (!Mo)
    throw new Error("No element matching method supported");
  return Mo.call(e, t);
}
function bn(e) {
  e.remove ? e.remove() : e.parentNode && e.parentNode.removeChild(e);
}
function Po(e, t) {
  return Array.prototype.filter.call(
    e.children,
    function(n) {
      return Ft(n, t);
    }
  );
}
var Re = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(e) {
      return "ps__thumb-" + e;
    },
    rail: function(e) {
      return "ps__rail-" + e;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(e) {
      return "ps--active-" + e;
    },
    scrolling: function(e) {
      return "ps--scrolling-" + e;
    }
  }
}, Ll = { x: null, y: null };
function Ol(e, t) {
  var n = e.element.classList, r = Re.state.scrolling(t);
  n.contains(r) ? clearTimeout(Ll[t]) : n.add(r);
}
function Ml(e, t) {
  Ll[t] = setTimeout(
    function() {
      return e.isAlive && e.element.classList.remove(Re.state.scrolling(t));
    },
    e.settings.scrollingThreshold
  );
}
function Wp(e, t) {
  Ol(e, t), Ml(e, t);
}
var Wn = function(t) {
  this.element = t, this.handlers = {};
}, Pl = { isEmpty: { configurable: !0 } };
Wn.prototype.bind = function(t, n) {
  typeof this.handlers[t] > "u" && (this.handlers[t] = []), this.handlers[t].push(n), this.element.addEventListener(t, n, !1);
};
Wn.prototype.unbind = function(t, n) {
  var r = this;
  this.handlers[t] = this.handlers[t].filter(function(a) {
    return n && a !== n ? !0 : (r.element.removeEventListener(t, a, !1), !1);
  });
};
Wn.prototype.unbindAll = function() {
  for (var t in this.handlers)
    this.unbind(t);
};
Pl.isEmpty.get = function() {
  var e = this;
  return Object.keys(this.handlers).every(
    function(t) {
      return e.handlers[t].length === 0;
    }
  );
};
Object.defineProperties(Wn.prototype, Pl);
var Sn = function() {
  this.eventElements = [];
};
Sn.prototype.eventElement = function(t) {
  var n = this.eventElements.filter(function(r) {
    return r.element === t;
  })[0];
  return n || (n = new Wn(t), this.eventElements.push(n)), n;
};
Sn.prototype.bind = function(t, n, r) {
  this.eventElement(t).bind(n, r);
};
Sn.prototype.unbind = function(t, n, r) {
  var a = this.eventElement(t);
  a.unbind(n, r), a.isEmpty && this.eventElements.splice(this.eventElements.indexOf(a), 1);
};
Sn.prototype.unbindAll = function() {
  this.eventElements.forEach(function(t) {
    return t.unbindAll();
  }), this.eventElements = [];
};
Sn.prototype.once = function(t, n, r) {
  var a = this.eventElement(t), i = function(o) {
    a.unbind(n, i), r(o);
  };
  a.bind(n, i);
};
function or(e) {
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(e);
  var t = document.createEvent("CustomEvent");
  return t.initCustomEvent(e, !1, !1, void 0), t;
}
function yr(e, t, n, r, a) {
  r === void 0 && (r = !0), a === void 0 && (a = !1);
  var i;
  if (t === "top")
    i = [
      "contentHeight",
      "containerHeight",
      "scrollTop",
      "y",
      "up",
      "down"
    ];
  else if (t === "left")
    i = [
      "contentWidth",
      "containerWidth",
      "scrollLeft",
      "x",
      "left",
      "right"
    ];
  else
    throw new Error("A proper axis should be provided");
  jp(e, n, i, r, a);
}
function jp(e, t, n, r, a) {
  var i = n[0], o = n[1], s = n[2], l = n[3], u = n[4], c = n[5];
  r === void 0 && (r = !0), a === void 0 && (a = !1);
  var d = e.element;
  e.reach[l] = null, d[s] < 1 && (e.reach[l] = "start"), d[s] > e[i] - e[o] - 1 && (e.reach[l] = "end"), t && (d.dispatchEvent(or("ps-scroll-" + l)), t < 0 ? d.dispatchEvent(or("ps-scroll-" + u)) : t > 0 && d.dispatchEvent(or("ps-scroll-" + c)), r && Wp(e, l)), e.reach[l] && (t || a) && d.dispatchEvent(or("ps-" + l + "-reach-" + e.reach[l]));
}
function Se(e) {
  return parseInt(e, 10) || 0;
}
function qp(e) {
  return Ft(e, "input,[contenteditable]") || Ft(e, "select,[contenteditable]") || Ft(e, "textarea,[contenteditable]") || Ft(e, "button,[contenteditable]");
}
function Vp(e) {
  var t = Tt(e);
  return Se(t.width) + Se(t.paddingLeft) + Se(t.paddingRight) + Se(t.borderLeftWidth) + Se(t.borderRightWidth);
}
var gn = {
  isWebKit: typeof document < "u" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window < "u" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator < "u" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator < "u" && /Chrome/i.test(navigator && navigator.userAgent)
};
function Nt(e) {
  var t = e.element, n = Math.floor(t.scrollTop), r = t.getBoundingClientRect();
  e.containerWidth = Math.round(r.width), e.containerHeight = Math.round(r.height), e.contentWidth = t.scrollWidth, e.contentHeight = t.scrollHeight, t.contains(e.scrollbarXRail) || (Po(t, Re.element.rail("x")).forEach(
    function(a) {
      return bn(a);
    }
  ), t.appendChild(e.scrollbarXRail)), t.contains(e.scrollbarYRail) || (Po(t, Re.element.rail("y")).forEach(
    function(a) {
      return bn(a);
    }
  ), t.appendChild(e.scrollbarYRail)), !e.settings.suppressScrollX && e.containerWidth + e.settings.scrollXMarginOffset < e.contentWidth ? (e.scrollbarXActive = !0, e.railXWidth = e.containerWidth - e.railXMarginWidth, e.railXRatio = e.containerWidth / e.railXWidth, e.scrollbarXWidth = No(
    e,
    Se(e.railXWidth * e.containerWidth / e.contentWidth)
  ), e.scrollbarXLeft = Se(
    (e.negativeScrollAdjustment + t.scrollLeft) * (e.railXWidth - e.scrollbarXWidth) / (e.contentWidth - e.containerWidth)
  )) : e.scrollbarXActive = !1, !e.settings.suppressScrollY && e.containerHeight + e.settings.scrollYMarginOffset < e.contentHeight ? (e.scrollbarYActive = !0, e.railYHeight = e.containerHeight - e.railYMarginHeight, e.railYRatio = e.containerHeight / e.railYHeight, e.scrollbarYHeight = No(
    e,
    Se(e.railYHeight * e.containerHeight / e.contentHeight)
  ), e.scrollbarYTop = Se(
    n * (e.railYHeight - e.scrollbarYHeight) / (e.contentHeight - e.containerHeight)
  )) : e.scrollbarYActive = !1, e.scrollbarXLeft >= e.railXWidth - e.scrollbarXWidth && (e.scrollbarXLeft = e.railXWidth - e.scrollbarXWidth), e.scrollbarYTop >= e.railYHeight - e.scrollbarYHeight && (e.scrollbarYTop = e.railYHeight - e.scrollbarYHeight), Gp(t, e), e.scrollbarXActive ? t.classList.add(Re.state.active("x")) : (t.classList.remove(Re.state.active("x")), e.scrollbarXWidth = 0, e.scrollbarXLeft = 0, t.scrollLeft = e.isRtl === !0 ? e.contentWidth : 0), e.scrollbarYActive ? t.classList.add(Re.state.active("y")) : (t.classList.remove(Re.state.active("y")), e.scrollbarYHeight = 0, e.scrollbarYTop = 0, t.scrollTop = 0);
}
function No(e, t) {
  return e.settings.minScrollbarLength && (t = Math.max(t, e.settings.minScrollbarLength)), e.settings.maxScrollbarLength && (t = Math.min(t, e.settings.maxScrollbarLength)), t;
}
function Gp(e, t) {
  var n = { width: t.railXWidth }, r = Math.floor(e.scrollTop);
  t.isRtl ? n.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth - t.contentWidth : n.left = e.scrollLeft, t.isScrollbarXUsingBottom ? n.bottom = t.scrollbarXBottom - r : n.top = t.scrollbarXTop + r, Ge(t.scrollbarXRail, n);
  var a = { top: r, height: t.railYHeight };
  t.isScrollbarYUsingRight ? t.isRtl ? a.right = t.contentWidth - (t.negativeScrollAdjustment + e.scrollLeft) - t.scrollbarYRight - t.scrollbarYOuterWidth - 9 : a.right = t.scrollbarYRight - e.scrollLeft : t.isRtl ? a.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth * 2 - t.contentWidth - t.scrollbarYLeft - t.scrollbarYOuterWidth : a.left = t.scrollbarYLeft + e.scrollLeft, Ge(t.scrollbarYRail, a), Ge(t.scrollbarX, {
    left: t.scrollbarXLeft,
    width: t.scrollbarXWidth - t.railBorderXWidth
  }), Ge(t.scrollbarY, {
    top: t.scrollbarYTop,
    height: t.scrollbarYHeight - t.railBorderYWidth
  });
}
function Yp(e) {
  e.element, e.event.bind(e.scrollbarY, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarYRail, "mousedown", function(t) {
    var n = t.pageY - window.pageYOffset - e.scrollbarYRail.getBoundingClientRect().top, r = n > e.scrollbarYTop ? 1 : -1;
    e.element.scrollTop += r * e.containerHeight, Nt(e), t.stopPropagation();
  }), e.event.bind(e.scrollbarX, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarXRail, "mousedown", function(t) {
    var n = t.pageX - window.pageXOffset - e.scrollbarXRail.getBoundingClientRect().left, r = n > e.scrollbarXLeft ? 1 : -1;
    e.element.scrollLeft += r * e.containerWidth, Nt(e), t.stopPropagation();
  });
}
function Xp(e) {
  xo(e, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]), xo(e, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]);
}
function xo(e, t) {
  var n = t[0], r = t[1], a = t[2], i = t[3], o = t[4], s = t[5], l = t[6], u = t[7], c = t[8], d = e.element, f = null, g = null, v = null;
  function C(R) {
    R.touches && R.touches[0] && (R[a] = R.touches[0].pageY), d[l] = f + v * (R[a] - g), Ol(e, u), Nt(e), R.stopPropagation(), R.type.startsWith("touch") && R.changedTouches.length > 1 && R.preventDefault();
  }
  function A() {
    Ml(e, u), e[c].classList.remove(Re.state.clicking), e.event.unbind(e.ownerDocument, "mousemove", C);
  }
  function k(R, y) {
    f = d[l], y && R.touches && (R[a] = R.touches[0].pageY), g = R[a], v = (e[r] - e[n]) / (e[i] - e[s]), y ? e.event.bind(e.ownerDocument, "touchmove", C) : (e.event.bind(e.ownerDocument, "mousemove", C), e.event.once(e.ownerDocument, "mouseup", A), R.preventDefault()), e[c].classList.add(Re.state.clicking), R.stopPropagation();
  }
  e.event.bind(e[o], "mousedown", function(R) {
    k(R);
  }), e.event.bind(e[o], "touchstart", function(R) {
    k(R, !0);
  });
}
function Kp(e) {
  var t = e.element, n = function() {
    return Ft(t, ":hover");
  }, r = function() {
    return Ft(e.scrollbarX, ":focus") || Ft(e.scrollbarY, ":focus");
  };
  function a(i, o) {
    var s = Math.floor(t.scrollTop);
    if (i === 0) {
      if (!e.scrollbarYActive)
        return !1;
      if (s === 0 && o > 0 || s >= e.contentHeight - e.containerHeight && o < 0)
        return !e.settings.wheelPropagation;
    }
    var l = t.scrollLeft;
    if (o === 0) {
      if (!e.scrollbarXActive)
        return !1;
      if (l === 0 && i < 0 || l >= e.contentWidth - e.containerWidth && i > 0)
        return !e.settings.wheelPropagation;
    }
    return !0;
  }
  e.event.bind(e.ownerDocument, "keydown", function(i) {
    if (!(i.isDefaultPrevented && i.isDefaultPrevented() || i.defaultPrevented) && !(!n() && !r())) {
      var o = document.activeElement ? document.activeElement : e.ownerDocument.activeElement;
      if (o) {
        if (o.tagName === "IFRAME")
          o = o.contentDocument.activeElement;
        else
          for (; o.shadowRoot; )
            o = o.shadowRoot.activeElement;
        if (qp(o))
          return;
      }
      var s = 0, l = 0;
      switch (i.which) {
        case 37:
          i.metaKey ? s = -e.contentWidth : i.altKey ? s = -e.containerWidth : s = -30;
          break;
        case 38:
          i.metaKey ? l = e.contentHeight : i.altKey ? l = e.containerHeight : l = 30;
          break;
        case 39:
          i.metaKey ? s = e.contentWidth : i.altKey ? s = e.containerWidth : s = 30;
          break;
        case 40:
          i.metaKey ? l = -e.contentHeight : i.altKey ? l = -e.containerHeight : l = -30;
          break;
        case 32:
          i.shiftKey ? l = e.containerHeight : l = -e.containerHeight;
          break;
        case 33:
          l = e.containerHeight;
          break;
        case 34:
          l = -e.containerHeight;
          break;
        case 36:
          l = e.contentHeight;
          break;
        case 35:
          l = -e.contentHeight;
          break;
        default:
          return;
      }
      e.settings.suppressScrollX && s !== 0 || e.settings.suppressScrollY && l !== 0 || (t.scrollTop -= l, t.scrollLeft += s, Nt(e), a(s, l) && i.preventDefault());
    }
  });
}
function Zp(e) {
  var t = e.element;
  function n(o, s) {
    var l = Math.floor(t.scrollTop), u = t.scrollTop === 0, c = l + t.offsetHeight === t.scrollHeight, d = t.scrollLeft === 0, f = t.scrollLeft + t.offsetWidth === t.scrollWidth, g;
    return Math.abs(s) > Math.abs(o) ? g = u || c : g = d || f, g ? !e.settings.wheelPropagation : !0;
  }
  function r(o) {
    var s = o.deltaX, l = -1 * o.deltaY;
    return (typeof s > "u" || typeof l > "u") && (s = -1 * o.wheelDeltaX / 6, l = o.wheelDeltaY / 6), o.deltaMode && o.deltaMode === 1 && (s *= 10, l *= 10), s !== s && l !== l && (s = 0, l = o.wheelDelta), o.shiftKey ? [-l, -s] : [s, l];
  }
  function a(o, s, l) {
    if (!gn.isWebKit && t.querySelector("select:focus"))
      return !0;
    if (!t.contains(o))
      return !1;
    for (var u = o; u && u !== t; ) {
      if (u.classList.contains(Re.element.consuming))
        return !0;
      var c = Tt(u);
      if (l && c.overflowY.match(/(scroll|auto)/)) {
        var d = u.scrollHeight - u.clientHeight;
        if (d > 0 && (u.scrollTop > 0 && l < 0 || u.scrollTop < d && l > 0))
          return !0;
      }
      if (s && c.overflowX.match(/(scroll|auto)/)) {
        var f = u.scrollWidth - u.clientWidth;
        if (f > 0 && (u.scrollLeft > 0 && s < 0 || u.scrollLeft < f && s > 0))
          return !0;
      }
      u = u.parentNode;
    }
    return !1;
  }
  function i(o) {
    var s = r(o), l = s[0], u = s[1];
    if (!a(o.target, l, u)) {
      var c = !1;
      e.settings.useBothWheelAxes ? e.scrollbarYActive && !e.scrollbarXActive ? (u ? t.scrollTop -= u * e.settings.wheelSpeed : t.scrollTop += l * e.settings.wheelSpeed, c = !0) : e.scrollbarXActive && !e.scrollbarYActive && (l ? t.scrollLeft += l * e.settings.wheelSpeed : t.scrollLeft -= u * e.settings.wheelSpeed, c = !0) : (t.scrollTop -= u * e.settings.wheelSpeed, t.scrollLeft += l * e.settings.wheelSpeed), Nt(e), c = c || n(l, u), c && !o.ctrlKey && (o.stopPropagation(), o.preventDefault());
    }
  }
  typeof window.onwheel < "u" ? e.event.bind(t, "wheel", i) : typeof window.onmousewheel < "u" && e.event.bind(t, "mousewheel", i);
}
function Qp(e) {
  if (!gn.supportsTouch && !gn.supportsIePointer)
    return;
  var t = e.element;
  function n(v, C) {
    var A = Math.floor(t.scrollTop), k = t.scrollLeft, R = Math.abs(v), y = Math.abs(C);
    if (y > R) {
      if (C < 0 && A === e.contentHeight - e.containerHeight || C > 0 && A === 0)
        return window.scrollY === 0 && C > 0 && gn.isChrome;
    } else if (R > y && (v < 0 && k === e.contentWidth - e.containerWidth || v > 0 && k === 0))
      return !0;
    return !0;
  }
  function r(v, C) {
    t.scrollTop -= C, t.scrollLeft -= v, Nt(e);
  }
  var a = {}, i = 0, o = {}, s = null;
  function l(v) {
    return v.targetTouches ? v.targetTouches[0] : v;
  }
  function u(v) {
    return v.pointerType && v.pointerType === "pen" && v.buttons === 0 ? !1 : !!(v.targetTouches && v.targetTouches.length === 1 || v.pointerType && v.pointerType !== "mouse" && v.pointerType !== v.MSPOINTER_TYPE_MOUSE);
  }
  function c(v) {
    if (u(v)) {
      var C = l(v);
      a.pageX = C.pageX, a.pageY = C.pageY, i = (/* @__PURE__ */ new Date()).getTime(), s !== null && clearInterval(s);
    }
  }
  function d(v, C, A) {
    if (!t.contains(v))
      return !1;
    for (var k = v; k && k !== t; ) {
      if (k.classList.contains(Re.element.consuming))
        return !0;
      var R = Tt(k);
      if (A && R.overflowY.match(/(scroll|auto)/)) {
        var y = k.scrollHeight - k.clientHeight;
        if (y > 0 && (k.scrollTop > 0 && A < 0 || k.scrollTop < y && A > 0))
          return !0;
      }
      if (C && R.overflowX.match(/(scroll|auto)/)) {
        var w = k.scrollWidth - k.clientWidth;
        if (w > 0 && (k.scrollLeft > 0 && C < 0 || k.scrollLeft < w && C > 0))
          return !0;
      }
      k = k.parentNode;
    }
    return !1;
  }
  function f(v) {
    if (u(v)) {
      var C = l(v), A = { pageX: C.pageX, pageY: C.pageY }, k = A.pageX - a.pageX, R = A.pageY - a.pageY;
      if (d(v.target, k, R))
        return;
      r(k, R), a = A;
      var y = (/* @__PURE__ */ new Date()).getTime(), w = y - i;
      w > 0 && (o.x = k / w, o.y = R / w, i = y), n(k, R) && v.cancelable && v.preventDefault();
    }
  }
  function g() {
    e.settings.swipeEasing && (clearInterval(s), s = setInterval(function() {
      if (e.isInitialized) {
        clearInterval(s);
        return;
      }
      if (!o.x && !o.y) {
        clearInterval(s);
        return;
      }
      if (Math.abs(o.x) < 0.01 && Math.abs(o.y) < 0.01) {
        clearInterval(s);
        return;
      }
      if (!e.element) {
        clearInterval(s);
        return;
      }
      r(o.x * 30, o.y * 30), o.x *= 0.8, o.y *= 0.8;
    }, 10));
  }
  gn.supportsTouch ? (e.event.bind(t, "touchstart", c), e.event.bind(t, "touchmove", f), e.event.bind(t, "touchend", g)) : gn.supportsIePointer && (window.PointerEvent ? (e.event.bind(t, "pointerdown", c), e.event.bind(t, "pointermove", f), e.event.bind(t, "pointerup", g)) : window.MSPointerEvent && (e.event.bind(t, "MSPointerDown", c), e.event.bind(t, "MSPointerMove", f), e.event.bind(t, "MSPointerUp", g)));
}
var Jp = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: !1,
    suppressScrollY: !1,
    swipeEasing: !0,
    useBothWheelAxes: !1,
    wheelPropagation: !0,
    wheelSpeed: 1
  };
}, e0 = {
  "click-rail": Yp,
  "drag-thumb": Xp,
  keyboard: Kp,
  wheel: Zp,
  touch: Qp
}, jn = function(t, n) {
  var r = this;
  if (n === void 0 && (n = {}), typeof t == "string" && (t = document.querySelector(t)), !t || !t.nodeName)
    throw new Error("no element is specified to initialize PerfectScrollbar");
  this.element = t, t.classList.add(Re.main), this.settings = Jp();
  for (var a in n)
    this.settings[a] = n[a];
  this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
  var i = function() {
    return t.classList.add(Re.state.focus);
  }, o = function() {
    return t.classList.remove(Re.state.focus);
  };
  this.isRtl = Tt(t).direction === "rtl", this.isRtl === !0 && t.classList.add(Re.rtl), this.isNegativeScroll = function() {
    var u = t.scrollLeft, c = null;
    return t.scrollLeft = -1, c = t.scrollLeft < 0, t.scrollLeft = u, c;
  }(), this.negativeScrollAdjustment = this.isNegativeScroll ? t.scrollWidth - t.clientWidth : 0, this.event = new Sn(), this.ownerDocument = t.ownerDocument || document, this.scrollbarXRail = ir(Re.element.rail("x")), t.appendChild(this.scrollbarXRail), this.scrollbarX = ir(Re.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", i), this.event.bind(this.scrollbarX, "blur", o), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
  var s = Tt(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(s.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = Se(s.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = Se(s.borderLeftWidth) + Se(s.borderRightWidth), Ge(this.scrollbarXRail, { display: "block" }), this.railXMarginWidth = Se(s.marginLeft) + Se(s.marginRight), Ge(this.scrollbarXRail, { display: "" }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = ir(Re.element.rail("y")), t.appendChild(this.scrollbarYRail), this.scrollbarY = ir(Re.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", i), this.event.bind(this.scrollbarY, "blur", o), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
  var l = Tt(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(l.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = Se(l.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? Vp(this.scrollbarY) : null, this.railBorderYWidth = Se(l.borderTopWidth) + Se(l.borderBottomWidth), Ge(this.scrollbarYRail, { display: "block" }), this.railYMarginHeight = Se(l.marginTop) + Se(l.marginBottom), Ge(this.scrollbarYRail, { display: "" }), this.railYHeight = null, this.railYRatio = null, this.reach = {
    x: t.scrollLeft <= 0 ? "start" : t.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: t.scrollTop <= 0 ? "start" : t.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  }, this.isAlive = !0, this.settings.handlers.forEach(function(u) {
    return e0[u](r);
  }), this.lastScrollTop = Math.floor(t.scrollTop), this.lastScrollLeft = t.scrollLeft, this.event.bind(this.element, "scroll", function(u) {
    return r.onScroll(u);
  }), Nt(this);
};
jn.prototype.update = function() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, Ge(this.scrollbarXRail, { display: "block" }), Ge(this.scrollbarYRail, { display: "block" }), this.railXMarginWidth = Se(Tt(this.scrollbarXRail).marginLeft) + Se(Tt(this.scrollbarXRail).marginRight), this.railYMarginHeight = Se(Tt(this.scrollbarYRail).marginTop) + Se(Tt(this.scrollbarYRail).marginBottom), Ge(this.scrollbarXRail, { display: "none" }), Ge(this.scrollbarYRail, { display: "none" }), Nt(this), yr(this, "top", 0, !1, !0), yr(this, "left", 0, !1, !0), Ge(this.scrollbarXRail, { display: "" }), Ge(this.scrollbarYRail, { display: "" }));
};
jn.prototype.onScroll = function(t) {
  this.isAlive && (Nt(this), yr(this, "top", this.element.scrollTop - this.lastScrollTop), yr(
    this,
    "left",
    this.element.scrollLeft - this.lastScrollLeft
  ), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
};
jn.prototype.destroy = function() {
  this.isAlive && (this.event.unbindAll(), bn(this.scrollbarX), bn(this.scrollbarY), bn(this.scrollbarXRail), bn(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
};
jn.prototype.removePsClasses = function() {
  this.element.className = this.element.className.split(" ").filter(function(t) {
    return !t.match(/^ps([-_].+|)$/);
  }).join(" ");
};
const Xt = `
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-variant-ligatures: common-ligatures;

  [data-cb-heading-font='${pn.Omnes}'] && {
    font-feature-settings: 'kern', 'ss01', 'ss05', 'ss07';
    font-family: ${pn.Omnes}, -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', Arimo, 'Open Sans', sans-serif;
  }

  [data-cb-heading-font='${pn.October}'] && {
    font-feature-settings: 'kern';
    font-family: ${pn.October}, -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', Arimo, 'Open Sans', sans-serif;
  }

  [data-cb-heading-font='${pn.MPlus}'] && {
    font-feature-settings: 'kern', 'ss01', 'ss05', 'ss07';
    font-family: ${pn.MPlus}, -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', Arimo, 'Open Sans', sans-serif;
  }
`, He = `
  font-feature-settings: 'kern';
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', Arimo, 'Open Sans', sans-serif;
`, t0 = {
  inherit: "inherit",
  normal: "400",
  semiBold: "500",
  bold: "700"
};
function kn(e) {
  return ({ disableNestedWeightTags: t, weight: n = "normal" } = {}) => `
      ${e}
      font-weight: ${t0[n]};

      ${t ? "" : `
        b, strong {
          font-weight: ${n === "bold" || n === "semiBold" ? "700" : "600"};
        }
      `}
    `;
}
kn(`
    ${He}
    font-size: ${z(18)};
    line-height: ${z(24)};
    font-style: normal;
    font-stretch: normal;
  `), kn(`
    ${He}
    font-size: ${z(16)};
    line-height: ${z(20)};
    font-style: normal;
    font-stretch: normal;
  `), kn(`
    ${He}
    font-size: ${z(14)};
    line-height: ${z(20)};
    font-style: normal;
    font-stretch: normal;
  `), kn(`
    ${He}
    font-size: ${z(12)};
    line-height: ${z(16)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `), kn(`
    ${He}
    font-size: ${z(10)};
    line-height: ${z(12)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `);
const Tn = "cb_typographyClassName_headingBase_h12y", _e = "cb_typographyClassName_bodyBase_b1fq";
re(Tn, "cb_typographyClassName_Heading1_hgk2");
re(Tn, "cb_typographyClassName_Heading2_h2wt");
re(Tn, "cb_typographyClassName_Heading3_h1m1");
re(Tn, "cb_typographyClassName_Heading4_h1ho");
re(Tn, "cb_typographyClassName_Heading5_h1mw");
re(Tn, "cb_typographyClassName_Heading6_h1um");
re(_e, "cb_typographyClassName_Title1_twf9");
re(_e, "cb_typographyClassName_Title2_t71u");
re(_e, "cb_typographyClassName_Subtitle_shpc");
re(_e, "cb_typographyClassName_Body1_b1rw");
re(_e, "cb_typographyClassName_Body1SemiBold_b1ni");
re(_e, "cb_typographyClassName_Body1Bold_bp0d");
re(_e, "cb_typographyClassName_Body2_b1c4");
re(_e, "cb_typographyClassName_Body2SemiBold_buez");
re(_e, "cb_typographyClassName_Body2Bold_b1hh");
re(_e, "cb_typographyClassName_Body3_b1dm");
re(_e, "cb_typographyClassName_Body3SemiBold_b5z0");
re(_e, "cb_typographyClassName_Body3Bold_b1mt");
re(_e, "cb_typographyClassName_Small_sltz");
re(_e, "cb_typographyClassName_SmallSemiBold_s1sf");
re(_e, "cb_typographyClassName_SmallBold_sltg");
re(_e, "cb_typographyClassName_Tiny_t1ux");
re(_e, "cb_typographyClassName_TinySemiBold_t1yr");
re(_e, "cb_typographyClassName_TinyBold_t1q9");
re(_e, "cb_typographyClassName_Overline1_o7bb");
re(_e, "cb_typographyClassName_Overline2_o1mk");
re(_e, "cb_typographyClassName_Overline3_o1yg");
re(_e, "cb_typographyClassName_Overline4_o5u0");
re(_e, "cb_typographyClassName_Quote1_qkdg");
re(_e, "cb_typographyClassName_Quote2_qqny");
const Ee = {
  wolt100: "rgba(0, 157, 224, 1)",
  wolt96: "rgba(0, 157, 224, 0.96)",
  wolt92: "rgba(0, 157, 224, 0.92)",
  wolt88: "rgba(0, 157, 224, 0.88)",
  wolt84: "rgba(0, 157, 224, 0.84)",
  wolt80: "rgba(0, 157, 224, 0.80)",
  wolt76: "rgba(0, 157, 224, 0.76)",
  wolt72: "rgba(0, 157, 224, 0.72)",
  wolt68: "rgba(0, 157, 224, 0.68)",
  wolt64: "rgba(0, 157, 224, 0.64)",
  wolt60: "rgba(0, 157, 224, 0.60)",
  wolt56: "rgba(0, 157, 224, 0.56)",
  wolt52: "rgba(0, 157, 224, 0.52)",
  wolt48: "rgba(0, 157, 224, 0.48)",
  wolt44: "rgba(0, 157, 224, 0.44)",
  wolt40: "rgba(0, 157, 224, 0.40)",
  wolt36: "rgba(0, 157, 224, 0.36)",
  wolt32: "rgba(0, 157, 224, 0.32)",
  wolt28: "rgba(0, 157, 224, 0.28)",
  wolt24: "rgba(0, 157, 224, 0.24)",
  wolt20: "rgba(0, 157, 224, 0.20)",
  wolt16: "rgba(0, 157, 224, 0.16)",
  wolt12: "rgba(0, 157, 224, 0.12)",
  wolt8: "rgba(0, 157, 224, 0.08)",
  wolt4: "rgba(0, 157, 224, 0.04)",
  pepper100: "rgba(32, 33, 37, 1)",
  pepper96: "rgba(32, 33, 37, 0.96)",
  pepper92: "rgba(32, 33, 37, 0.92)",
  pepper88: "rgba(32, 33, 37, 0.88)",
  pepper84: "rgba(32, 33, 37, 0.84)",
  pepper80: "rgba(32, 33, 37, 0.80)",
  pepper76: "rgba(32, 33, 37, 0.76)",
  pepper72: "rgba(32, 33, 37, 0.72)",
  pepper68: "rgba(32, 33, 37, 0.68)",
  pepper64: "rgba(32, 33, 37, 0.64)",
  pepper60: "rgba(32, 33, 37, 0.60)",
  pepper56: "rgba(32, 33, 37, 0.56)",
  pepper52: "rgba(32, 33, 37, 0.52)",
  pepper48: "rgba(32, 33, 37, 0.48)",
  pepper44: "rgba(32, 33, 37, 0.44)",
  pepper40: "rgba(32, 33, 37, 0.40)",
  pepper36: "rgba(32, 33, 37, 0.36)",
  pepper32: "rgba(32, 33, 37, 0.32)",
  pepper28: "rgba(32, 33, 37, 0.28)",
  pepper24: "rgba(32, 33, 37, 0.24)",
  pepper20: "rgba(32, 33, 37, 0.20)",
  pepper16: "rgba(32, 33, 37, 0.16)",
  pepper12: "rgba(32, 33, 37, 0.12)",
  pepper8: "rgba(32, 33, 37, 0.08)",
  pepper4: "rgba(32, 33, 37, 0.04)",
  pepper2: "rgba(32, 33, 37, 0.02)",
  salt100: "rgba(255, 255, 255, 1)",
  salt96: "rgba(255, 255, 255, 0.96)",
  salt92: "rgba(255, 255, 255, 0.92)",
  salt88: "rgba(255, 255, 255, 0.88)",
  salt84: "rgba(255, 255, 255, 0.84)",
  salt80: "rgba(255, 255, 255, 0.80)",
  salt76: "rgba(255, 255, 255, 0.76)",
  salt72: "rgba(255, 255, 255, 0.72)",
  salt68: "rgba(255, 255, 255, 0.68)",
  salt64: "rgba(255, 255, 255, 0.64)",
  salt60: "rgba(255, 255, 255, 0.60)",
  salt56: "rgba(255, 255, 255, 0.56)",
  salt52: "rgba(255, 255, 255, 0.52)",
  salt48: "rgba(255, 255, 255, 0.48)",
  salt44: "rgba(255, 255, 255, 0.44)",
  salt40: "rgba(255, 255, 255, 0.40)",
  salt36: "rgba(255, 255, 255, 0.36)",
  salt32: "rgba(255, 255, 255, 0.32)",
  salt28: "rgba(255, 255, 255, 0.28)",
  salt24: "rgba(255, 255, 255, 0.24)",
  salt20: "rgba(255, 255, 255, 0.20)",
  salt16: "rgba(255, 255, 255, 0.16)",
  salt12: "rgba(255, 255, 255, 0.12)",
  salt8: "rgba(255, 255, 255, 0.08)",
  salt4: "rgba(255, 255, 255, 0.04)",
  darkSky100: "rgba(0, 120, 212, 1)",
  darkSky96: "rgba(0, 120, 212, 0.96)",
  darkSky92: "rgba(0, 120, 212, 0.92)",
  darkSky88: "rgba(0, 120, 212, 0.88)",
  darkSky84: "rgba(0, 120, 212, 0.84)",
  darkSky80: "rgba(0, 120, 212, 0.80)",
  darkSky76: "rgba(0, 120, 212, 0.76)",
  darkSky72: "rgba(0, 120, 212, 0.72)",
  darkSky68: "rgba(0, 120, 212, 0.68)",
  darkSky64: "rgba(0, 120, 212, 0.64)",
  darkSky60: "rgba(0, 120, 212, 0.60)",
  darkSky56: "rgba(0, 120, 212, 0.56)",
  darkSky52: "rgba(0, 120, 212, 0.52)",
  darkSky48: "rgba(0, 120, 212, 0.48)",
  darkSky44: "rgba(0, 120, 212, 0.44)",
  darkSky40: "rgba(0, 120, 212, 0.40)",
  darkSky36: "rgba(0, 120, 212, 0.36)",
  darkSky32: "rgba(0, 120, 212, 0.32)",
  darkSky28: "rgba(0, 120, 212, 0.28)",
  darkSky24: "rgba(0, 120, 212, 0.24)",
  darkSky20: "rgba(0, 120, 212, 0.20)",
  darkSky16: "rgba(0, 120, 212, 0.16)",
  darkSky12: "rgba(0, 120, 212, 0.12)",
  darkSky8: "rgba(0, 120, 212, 0.08)",
  darkSky4: "rgba(0, 120, 212, 0.04)",
  nightSky100: "rgba(15, 37, 148, 1)",
  nightSky96: "rgba(15, 37, 148, 0.96)",
  nightSky92: "rgba(15, 37, 148, 0.92)",
  nightSky88: "rgba(15, 37, 148, 0.88)",
  nightSky84: "rgba(15, 37, 148, 0.84)",
  nightSky80: "rgba(15, 37, 148, 0.80)",
  nightSky76: "rgba(15, 37, 148, 0.76)",
  nightSky72: "rgba(15, 37, 148, 0.72)",
  nightSky68: "rgba(15, 37, 148, 0.68)",
  nightSky64: "rgba(15, 37, 148, 0.64)",
  nightSky60: "rgba(15, 37, 148, 0.60)",
  nightSky56: "rgba(15, 37, 148, 0.56)",
  nightSky52: "rgba(15, 37, 148, 0.52)",
  nightSky48: "rgba(15, 37, 148, 0.48)",
  nightSky44: "rgba(15, 37, 148, 0.44)",
  nightSky40: "rgba(15, 37, 148, 0.40)",
  nightSky36: "rgba(15, 37, 148, 0.36)",
  nightSky32: "rgba(15, 37, 148, 0.32)",
  nightSky28: "rgba(15, 37, 148, 0.28)",
  nightSky24: "rgba(15, 37, 148, 0.24)",
  nightSky20: "rgba(15, 37, 148, 0.20)",
  nightSky16: "rgba(15, 37, 148, 0.16)",
  nightSky12: "rgba(15, 37, 148, 0.12)",
  nightSky8: "rgba(15, 37, 148, 0.08)",
  nightSky4: "rgba(15, 37, 148, 0.04)",
  space100: "rgba(0,0,0, 1)",
  space96: "rgba(0,0,0, 0.96)",
  space92: "rgba(0,0,0, 0.92)",
  space88: "rgba(0,0,0, 0.88)",
  space84: "rgba(0,0,0, 0.84)",
  space80: "rgba(0,0,0, 0.80)",
  space76: "rgba(0,0,0, 0.76)",
  space72: "rgba(0,0,0, 0.72)",
  space68: "rgba(0,0,0, 0.68)",
  space64: "rgba(0,0,0, 0.64)",
  space60: "rgba(0,0,0, 0.60)",
  space56: "rgba(0,0,0, 0.56)",
  space52: "rgba(0,0,0, 0.52)",
  space48: "rgba(0,0,0, 0.48)",
  space44: "rgba(0,0,0, 0.44)",
  space40: "rgba(0,0,0, 0.40)",
  space36: "rgba(0,0,0, 0.36)",
  space32: "rgba(0,0,0, 0.32)",
  space28: "rgba(0,0,0, 0.28)",
  space24: "rgba(0,0,0, 0.24)",
  space20: "rgba(0,0,0, 0.20)",
  space16: "rgba(0,0,0, 0.16)",
  space12: "rgba(0,0,0, 0.12)",
  space8: "rgba(0,0,0, 0.08)",
  space4: "rgba(0,0,0, 0.04)",
  lime100: "rgba(31, 199, 10, 1)",
  lime96: "rgba(31, 199, 10, 0.96)",
  lime92: "rgba(31, 199, 10, 0.92)",
  lime88: "rgba(31, 199, 10, 0.88)",
  lime84: "rgba(31, 199, 10, 0.84)",
  lime80: "rgba(31, 199, 10, 0.80)",
  lime76: "rgba(31, 199, 10, 0.76)",
  lime72: "rgba(31, 199, 10, 0.72)",
  lime68: "rgba(31, 199, 10, 0.68)",
  lime64: "rgba(31, 199, 10, 0.64)",
  lime60: "rgba(31, 199, 10, 0.60)",
  lime56: "rgba(31, 199, 10, 0.56)",
  lime52: "rgba(31, 199, 10, 0.52)",
  lime48: "rgba(31, 199, 10, 0.48)",
  lime44: "rgba(31, 199, 10, 0.44)",
  lime40: "rgba(31, 199, 10, 0.40)",
  lime36: "rgba(31, 199, 10, 0.36)",
  lime32: "rgba(31, 199, 10, 0.32)",
  lime28: "rgba(31, 199, 10, 0.28)",
  lime24: "rgba(31, 199, 10, 0.24)",
  lime20: "rgba(31, 199, 10, 0.20)",
  lime16: "rgba(31, 199, 10, 0.16)",
  lime12: "rgba(31, 199, 10, 0.12)",
  lime8: "rgba(31, 199, 10, 0.08)",
  lime4: "rgba(31, 199, 10, 0.04)",
  banana100: "rgba(254, 169, 13, 1)",
  banana96: "rgba(254, 169, 13, 0.96)",
  banana92: "rgba(254, 169, 13, 0.92)",
  banana88: "rgba(254, 169, 13, 0.88)",
  banana84: "rgba(254, 169, 13, 0.84)",
  banana80: "rgba(254, 169, 13, 0.80)",
  banana76: "rgba(254, 169, 13, 0.76)",
  banana72: "rgba(254, 169, 13, 0.72)",
  banana68: "rgba(254, 169, 13, 0.68)",
  banana64: "rgba(254, 169, 13, 0.64)",
  banana60: "rgba(254, 169, 13, 0.60)",
  banana56: "rgba(254, 169, 13, 0.56)",
  banana52: "rgba(254, 169, 13, 0.52)",
  banana48: "rgba(254, 169, 13, 0.48)",
  banana44: "rgba(254, 169, 13, 0.44)",
  banana40: "rgba(254, 169, 13, 0.40)",
  banana36: "rgba(254, 169, 13, 0.36)",
  banana32: "rgba(254, 169, 13, 0.32)",
  banana28: "rgba(254, 169, 13, 0.28)",
  banana24: "rgba(254, 169, 13, 0.24)",
  banana20: "rgba(254, 169, 13, 0.20)",
  banana16: "rgba(254, 169, 13, 0.16)",
  banana12: "rgba(254, 169, 13, 0.12)",
  banana8: "rgba(254, 169, 13, 0.08)",
  banana4: "rgba(254, 169, 13, 0.04)",
  orange100: "rgba(252, 98, 0, 1)",
  orange96: "rgba(252, 98, 0, 0.96)",
  orange92: "rgba(252, 98, 0, 0.92)",
  orange88: "rgba(252, 98, 0, 0.88)",
  orange84: "rgba(252, 98, 0, 0.84)",
  orange80: "rgba(252, 98, 0, 0.80)",
  orange76: "rgba(252, 98, 0, 0.76)",
  orange72: "rgba(252, 98, 0, 0.72)",
  orange68: "rgba(252, 98, 0, 0.68)",
  orange64: "rgba(252, 98, 0, 0.64)",
  orange60: "rgba(252, 98, 0, 0.60)",
  orange56: "rgba(252, 98, 0, 0.56)",
  orange52: "rgba(252, 98, 0, 0.52)",
  orange48: "rgba(252, 98, 0, 0.48)",
  orange44: "rgba(252, 98, 0, 0.44)",
  orange40: "rgba(252, 98, 0, 0.40)",
  orange36: "rgba(252, 98, 0, 0.36)",
  orange32: "rgba(252, 98, 0, 0.32)",
  orange28: "rgba(252, 98, 0, 0.28)",
  orange24: "rgba(252, 98, 0, 0.24)",
  orange20: "rgba(252, 98, 0, 0.20)",
  orange16: "rgba(252, 98, 0, 0.16)",
  orange12: "rgba(252, 98, 0, 0.12)",
  orange8: "rgba(252, 98, 0, 0.08)",
  orange4: "rgba(252, 98, 0, 0.04)",
  strawberry100: "rgba(249, 58, 37, 1)",
  strawberry96: "rgba(249, 58, 37, 0.96)",
  strawberry92: "rgba(249, 58, 37, 0.92)",
  strawberry88: "rgba(249, 58, 37, 0.88)",
  strawberry84: "rgba(249, 58, 37, 0.84)",
  strawberry80: "rgba(249, 58, 37, 0.80)",
  strawberry76: "rgba(249, 58, 37, 0.76)",
  strawberry72: "rgba(249, 58, 37, 0.72)",
  strawberry68: "rgba(249, 58, 37, 0.68)",
  strawberry64: "rgba(249, 58, 37, 0.64)",
  strawberry60: "rgba(249, 58, 37, 0.60)",
  strawberry56: "rgba(249, 58, 37, 0.56)",
  strawberry52: "rgba(249, 58, 37, 0.52)",
  strawberry48: "rgba(249, 58, 37, 0.48)",
  strawberry44: "rgba(249, 58, 37, 0.44)",
  strawberry40: "rgba(249, 58, 37, 0.40)",
  strawberry36: "rgba(249, 58, 37, 0.36)",
  strawberry32: "rgba(249, 58, 37, 0.32)",
  strawberry28: "rgba(249, 58, 37, 0.28)",
  strawberry24: "rgba(249, 58, 37, 0.24)",
  strawberry20: "rgba(249, 58, 37, 0.20)",
  strawberry16: "rgba(249, 58, 37, 0.16)",
  strawberry12: "rgba(249, 58, 37, 0.12)",
  strawberry8: "rgba(249, 58, 37, 0.08)",
  strawberry4: "rgba(249, 58, 37, 0.04)",
  plum100: "rgba(135, 29, 196, 1)",
  plum96: "rgba(135, 29, 196, 0.96)",
  plum92: "rgba(135, 29, 196, 0.92)",
  plum88: "rgba(135, 29, 196, 0.88)",
  plum84: "rgba(135, 29, 196, 0.84)",
  plum80: "rgba(135, 29, 196, 0.80)",
  plum76: "rgba(135, 29, 196, 0.76)",
  plum72: "rgba(135, 29, 196, 0.72)",
  plum68: "rgba(135, 29, 196, 0.68)",
  plum64: "rgba(135, 29, 196, 0.64)",
  plum60: "rgba(135, 29, 196, 0.60)",
  plum56: "rgba(135, 29, 196, 0.56)",
  plum52: "rgba(135, 29, 196, 0.52)",
  plum48: "rgba(135, 29, 196, 0.48)",
  plum44: "rgba(135, 29, 196, 0.44)",
  plum40: "rgba(135, 29, 196, 0.40)",
  plum36: "rgba(135, 29, 196, 0.36)",
  plum32: "rgba(135, 29, 196, 0.32)",
  plum28: "rgba(135, 29, 196, 0.28)",
  plum24: "rgba(135, 29, 196, 0.24)",
  plum20: "rgba(135, 29, 196, 0.20)",
  plum16: "rgba(135, 29, 196, 0.16)",
  plum12: "rgba(135, 29, 196, 0.12)",
  plum8: "rgba(135, 29, 196, 0.08)",
  plum4: "rgba(135, 29, 196, 0.04)"
};
Object.freeze(Ee);
const Nl = {
  light: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: Ee.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: Ee.pepper64,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: Ee.pepper40,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: Ee.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: Ee.pepper12,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: Ee.pepper12,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: Ee.nightSky100
  },
  lightHighContrast: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: Ee.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: Ee.pepper80,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: Ee.pepper80,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: Ee.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: Ee.pepper80,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: Ee.pepper80,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: Ee.nightSky100
  },
  dark: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: Ee.salt100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: Ee.salt72,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: Ee.salt48,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: "#141414",
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: Ee.salt16,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: Ee.salt16,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: Ee.banana100
  }
};
Object.freeze(Nl);
const n0 = {
  borderLight: "borderPrimary",
  borderPrimary: "borderLight"
}, Bo = (e) => `--cb-color-${e}`;
Object.fromEntries(
  Object.keys(Nl.light).map((e) => {
    const t = n0[e];
    return [
      e,
      `var(${Bo(e)}${t ? `, var(${Bo(t)})` : ""})`
    ];
  })
);
const r0 = "cb_elevation_elevationXsmall_equ2", a0 = "cb_elevation_elevationSmall_e1vr", i0 = "cb_elevation_elevationMedium_e16y", o0 = "cb_elevation_elevationLarge_eg61", sr = "cb-elevated", s0 = {
  xsmall: `${sr} ${r0}`,
  small: `${sr} ${a0}`,
  medium: `${sr} ${i0}`,
  large: `${sr} ${o0}`
};
q.forwardRef((e, t) => /* @__PURE__ */ h("svg", { viewBox: "0 0 720 262", ...e, ref: t, children: /* @__PURE__ */ h("path", { d: "M411.996 159.402c-12.655-9.343-18.116-26.236-13.633-52.765.14-.84.502-2.324.98-4.138-2.635-1.049-5.617-1.498-8.976-1.498-29.86 0-46.485 50.303-46.485 97.062 0 24.374 9.528 36.655 23.763 36.655 19.738 0 37.879-34.26 44.351-75.316m246.149-47.158s-14.268 68.612-14.268 93.99c0 17.638 8.218 23.682 18.37 23.682 12.837 0 24.623-8.102 35.6-28.21 2.52-4.615 11.736-1.727 16.57 3.835 2.106 2.426-.318 7.317-3.638 12.913C694.144 246.502 670.643 262 646.225 262c-26.6 0-42.953-12.398-47.05-43.758C583.917 242.244 559.498 262 531.516 262c-34.02 0-48.5-18.827-48.5-52.607 0-22.281 7.505-60.23 7.505-60.23-9.966 8.981-21.522 15.475-34.824 18.172C442.624 228.594 407.632 262 360.613 262c-39.819 0-67.176-20.926-67.176-71.113 0-61.952 39.45-117.15 101.346-117.15 35.243 0 60.825 18.91 63.078 62.92 14.492-2.446 27.884-12.369 39.545-26.498 5.248-33.237 12.748-71.145 17.325-92.536.953-4.45 2.579-12.797 10.504-15.267 8.87-2.768 21.537-3.256 34.857-.608 7.384 1.467 9.261 8.367 9.261 14.533 0 16.397-7.769 52.57-21.278 85.1-9.574 36.262-16.142 72.442-16.142 101.05 0 20.673 6.84 27.485 18.309 27.485 18.72 0 40.466-26.001 50.939-61.226 1.626-16.944 5.916-44.198 8.068-54.357-11.597.557-19.01.894-19.01.894-6.034.221-11.883-2.323-11.586-7.71.394-7.096 1.37-13.925 2.565-18.734 1.196-4.809 3.938-7.793 9.768-7.896 6.255-.11 15.25-.037 24.516.185 3.122-17.875 5.746-31.825 8.266-43.421 1.007-4.641 5.35-7.313 9.82-7.815 5.35-.6 21.291-.487 28.23 1.196 6.986 1.698 9.913 7.185 8.702 12.735-2.472 11.303-7.526 39.04-7.526 39.04a6147.07 6147.07 0 0 1 46.66 2.252c7.475.335 11.327 4.544 10.131 11.125-2.016 11.055-10.246 14.608-21.875 14.875-13.262.304-27.21.731-39.765 1.185M299.32 23.772c0 77.229-41.424 237.729-105.603 237.729-48.42 0-58.144-54.148-60.644-123.13-24.267 52.943-37.112 80.43-53.148 107.952C72.35 259.32 63.246 262 53.302 262c-8.757 0-31.342-2.926-36.603-6.19-5.261-3.262-8.153-6.21-10.73-18.68-11.925-57.698-4.212-132.317 7.642-191.802 2.071-10.393 4.737-15.415 11.917-20.121 7.659-5.019 24.632-5.373 35.686-5.566 5.868-.103 9.279 4.121 7.803 11.274-10.677 51.94-23.21 123.105-13.445 196.466 0 0 36.936-73.192 75.224-164.314 7.685-18.291 9.405-24.297 16.715-25.917 9.568-2.12 16.467-2.13 26.102-.959 6.357.774 9.553 2.432 9.309 11.24-.667 23.745-2.257 50.615-2.257 78.511 0 47.204 5.064 100.27 23.246 100.27 24.419 0 45.87-113.537 38.294-211.097-.524-6.738 1.912-13.583 9.113-14.33C254.925.412 262.227 0 270.457 0c18.748 0 28.864 3.343 28.864 23.772" }) }));
const xl = (e, t, n) => {
  const r = ae(n);
  r.current = n;
  const a = ne(() => {
    const s = e.current;
    if (!s)
      return;
    const l = s.scrollTop, u = s.scrollHeight - s.clientHeight - s.scrollTop;
    r.current && r.current({ scrollPositionBottom: u, scrollPositionTop: l });
  }, [e]), i = xt(() => Bu(a, 64), [a]), o = e.current;
  de(() => (o && o.addEventListener("scroll", i, { passive: !0 }), () => {
    o && o.removeEventListener("scroll", i);
  }), [o, i]), br(e, a), br(t, a), de(() => {
    a();
  }, [a]);
}, Ho = 8, l0 = () => Be.div, u0 = /* @__PURE__ */ M(l0())({
  name: "Root",
  class: "support-layer-ModalCardPage_Root_r1j4tof1",
  propsAsIs: !0
}), c0 = () => Be.div, d0 = /* @__PURE__ */ M(c0())({
  name: "HeaderBackground",
  class: "support-layer-ModalCardPage_HeaderBackground_h1n23los",
  propsAsIs: !0
}), f0 = () => ({
  $height: e
}) => z(e), h0 = /* @__PURE__ */ M("header")({
  name: "ModalCardHeader",
  class: "support-layer-ModalCardPage_ModalCardHeader_mqsa3o6",
  propsAsIs: !1,
  vars: {
    "mqsa3o6-0": [f0()]
  }
}), p0 = () => Be.h2, Do = /* @__PURE__ */ M(p0())({
  name: "HeaderTitle",
  class: "support-layer-ModalCardPage_HeaderTitle_hde3pam",
  propsAsIs: !0
}), m0 = {
  animate: {
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: "easeOut"
    },
    y: 0
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: "easeIn"
    },
    y: -16
  },
  initial: {
    opacity: 0,
    y: -16
  }
}, g0 = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.05,
      duration: 0.1,
      ease: "linear"
    }
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.05,
      duration: 0.1,
      ease: "linear"
    }
  }
}, b0 = "support-layer-ModalCardPage_scrollContainerCss_s1tn04dr", v0 = /* @__PURE__ */ M("div")({
  name: "AspectRatioContainer",
  class: "support-layer-ModalCardPage_AspectRatioContainer_a2lnhfb",
  propsAsIs: !1
}), y0 = () => Be.div, _0 = /* @__PURE__ */ M(y0())({
  name: "ImageHeightConstraint",
  class: "support-layer-ModalCardPage_ImageHeightConstraint_ihiguvb",
  propsAsIs: !0
}), E0 = () => ({
  $headerHeight: e,
  $heightFit: t
}) => t === "fill" ? `
        display: flex;
        flex-direction: column;
        min-height: calc(100% - ${e ?? 0}px);
      ` : "", S0 = /* @__PURE__ */ M("div")({
  name: "ContentContainer",
  class: "support-layer-ModalCardPage_ContentContainer_c1glz8p7",
  propsAsIs: !1,
  vars: {
    "c1glz8p7-0": [E0()]
  }
}), T0 = q.createRef(), w0 = q.createRef(), C0 = typeof window == "object", I0 = C0 && (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document), R0 = (e, t) => {
  const n = ae(null);
  sd(() => (t && e.current && (n.current = new jn(e.current, {
    suppressScrollX: !0
  })), () => {
    var a;
    (a = n.current) == null || a.destroy();
  }), [t, e]);
  const r = ne(() => {
    var a;
    return (a = n.current) == null ? void 0 : a.update();
  }, []);
  return br(e, r), {
    update: r
  };
}, oi = q.forwardRef(({
  children: e,
  className: t,
  contentHeightFit: n,
  contentRef: r = w0,
  disableHeaderImageScaling: a,
  disablePerfectScrollbar: i = !1,
  headerBarHeight: o = 72,
  headerImage: s,
  headerImageAspectRatio: l = 2 / 3,
  headerImageHeight: u = 340,
  headerTitle: c,
  headerTitleAriaHidden: d = !1,
  headerTitleVisibility: f = "always",
  isInitialModalCardRender: g = !1,
  scrollRef: v = T0,
  showHeader: C = !0,
  style: A,
  thumbnails: k,
  ...R
}, y) => {
  const p = !Lu() && !a, B = !I0 && !i, {
    update: b
  } = R0(v, B), {
    scrollY: S
  } = bs({
    container: v
  });
  br(r, b);
  const [O, I] = Ae(!1), P = hn(S, s ? [u - o + 8, u - o + 20] : [0, 12], [0, 1]), $ = hn(S, s ? [u - o + 8, u - o + 50] : [0, 12], [z(o - Ho), z(o)]), Q = hn(S, s ? [u - o + 30, u - o + 60] : [0, 12], [z(-12), z(0)]), Y = hn(S, s ? [u - o + 30, u - o + 60] : [0, 12], [0, 1]), he = hn(S, [0, 0.4 * u, u], [u, 0.7 * u, 0.4 * u]), G = hn(S, [0.4 * u, u - o], [1, 0]), we = !s || !!u, Ce = Ou();
  return xl(v, r, ({
    scrollPositionTop: ie
  }) => {
    I(ie >= Ho);
  }), /* @__PURE__ */ V(u0, {
    className: t,
    ref: y,
    style: A,
    ...R,
    children: [C && /* @__PURE__ */ V(Rr, {
      children: [/* @__PURE__ */ h(It, {
        children: O && /* @__PURE__ */ h(Be.div, {
          style: {
            height: z(o),
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
            zIndex: 15
          },
          variants: m0,
          initial: "initial",
          animate: "animate",
          exit: "exit",
          children: /* @__PURE__ */ h(d0, {
            className: s0.small,
            style: {
              height: O ? $ : 0,
              opacity: P
            }
          })
        })
      }), /* @__PURE__ */ V(h0, {
        $height: o,
        ...d ? {
          "aria-hidden": "true"
        } : {},
        children: [f === "onScroll" && O && we && /* @__PURE__ */ h(Be.div, {
          animate: {
            opacity: Ce ? 1 : 0
          },
          transition: {
            duration: 0.2,
            ease: Ce ? "easeOut" : "easeIn"
          },
          children: /* @__PURE__ */ h(Do, {
            style: {
              opacity: Y,
              translateY: Q
            },
            children: c
          })
        }), /* @__PURE__ */ h(It, {
          initial: (
            /* The animation is desired only when changing between pages and not for the first render.
            initial={false} will effectively disable the animation.
                   */
            !g
          ),
          children: f === "always" && Ce && /* @__PURE__ */ h(Do, {
            variants: g0,
            initial: "hidden",
            animate: "visible",
            exit: "hidden",
            children: c
          })
        })]
      })]
    }), /* @__PURE__ */ V(Be.div, {
      ref: v,
      className: b0,
      style: {
        // @ts-expect-error todo
        "--overflow-y": B ? "auto" : "hidden",
        "--padding-top": s ? 0 : z(o)
      },
      layoutScroll: !0,
      children: [!!s && /* @__PURE__ */ h(v0, {
        "aria-hidden": !0,
        style: {
          aspectRatio: `calc(1 / ${l})`
        },
        children: /* @__PURE__ */ h(_0, {
          style: {
            // height 100% as fallback until JS has calculated the height.
            // We avoid parallax animation if the user prefers reduced
            // motion, but keep opacity.
            height: p && u ? he : "100%",
            opacity: G
          },
          children: /* @__PURE__ */ h(s, {
            style: {
              height: "100%",
              objectFit: "cover",
              objectPosition: "50% 50%",
              width: "100%"
            }
          })
        })
      }), k, /* @__PURE__ */ h(S0, {
        ref: r,
        $heightFit: n,
        $headerHeight: s ? u : 0,
        "data-modal-content-container": !0,
        children: e
      })]
    })]
  });
});
oi.displayName = "ModalCardPage";
const k0 = () => {
  const e = q.useRef(/* @__PURE__ */ new Map()), { current: t } = e, n = ne(
    (i) => {
      i || console.warn("useDynamicRefs: Cannot set ref without key ");
      const o = t.get(i);
      if (o)
        return o;
      const s = q.createRef();
      return t.set(i, s), s;
    },
    [t]
  ), r = ne(
    (i) => n(i),
    [n]
  ), a = ne(
    (i) => n(i),
    [n]
  );
  return [r, a];
}, A0 = (e) => {
  const [, t] = Ae(0), n = ne(() => t((r) => r + 1), [t]);
  return de(() => {
    const r = setTimeout(n, 0);
    return () => {
      clearTimeout(r);
    };
  }, [
    n,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ...e || []
  ]), { forceUpdate: n };
}, Zr = 2 / 3, L0 = (e) => e > 16;
Be(oi);
const O0 = "support-layer-ModalCard_modalCardFooterCss_myv8l0r", M0 = "support-layer-ModalCard_positionAbsoluteCss_phyckm4", P0 = "support-layer-ModalCard_positionRelativeCss_p1fa9nhx", N0 = Be(Al), x0 = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: "easeIn"
    },
    y: 8
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.2,
      duration: 0.3,
      ease: "easeOut"
    },
    y: 0
  }
}, Aa = q.forwardRef(({
  children: e,
  pageKey: t,
  position: n = "absolute"
}, r) => /* @__PURE__ */ h(It, {
  mode: "wait",
  children: e && /* @__PURE__ */ h(N0, {
    className: re(O0, n === "absolute" ? M0 : P0),
    ref: r,
    variants: x0,
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    children: e
  }, t)
}));
Aa.displayName = "FooterWrapper";
const lr = {
  easeOutCubic: [0.2, 0.6, 0.4, 1],
  inSine: [0.5, 0, 0.9, 0.7],
  secretEase: [0.5, 0.1, 0.25, 0.1]
}, B0 = () => ({
  $height: e
}) => e && e !== "auto" ? `${e}px` : "auto", H0 = () => ({
  $disableAnimation: e
}) => e ? "" : "height 500ms cubic-bezier(0.33, 1, 0.68, 1)", D0 = /* @__PURE__ */ M("aside")({
  name: "Root",
  class: "support-layer-modalStack_Root_rrczx2g",
  propsAsIs: !1,
  vars: {
    "rrczx2g-0": [B0()],
    "rrczx2g-1": [H0()]
  }
}), $0 = () => ii, F0 = /* @__PURE__ */ M($0())({
  name: "ZoomButtonContainer",
  class: "support-layer-modalStack_ZoomButtonContainer_z1w7sw8d",
  propsAsIs: !0
}), $o = {
  animate: ({
    direction: e,
    isActivePage: t
  }) => ({
    opacity: t ? 1 : 0,
    transition: {
      opacity: {
        delay: t ? 0.15 : 0.05,
        duration: t ? 0.2 : 0.1
      },
      x: {
        delay: 0.05,
        duration: 0.35,
        ease: t ? lr.easeOutCubic : lr.inSine
      }
    },
    // eslint-disable-next-line no-nested-ternary
    x: t ? "0%" : e === "ltr" ? "-30%" : "30%"
  }),
  exit: ({
    direction: e,
    isActivePage: t
  }) => ({
    opacity: 0,
    transition: {
      opacity: {
        delay: t ? 0.05 : 0.15,
        duration: t ? 0.1 : 0.2
      },
      x: {
        delay: 0.05,
        duration: 0.35,
        ease: t ? lr.inSine : lr.easeOutCubic
      }
    },
    x: e === "ltr" ? "30%" : "-30%"
  }),
  initial: ({
    direction: e,
    isActivePage: t
  }) => ({
    opacity: t ? 0 : 1,
    transition: {
      opacity: {
        delay: 0.15,
        duration: 0.2
      },
      x: {
        delay: 0.05,
        duration: 0.35
      }
    },
    x: e === "ltr" ? "30%" : "-30%"
  })
}, U0 = (e) => {
  if (!e.index)
    throw new Error("modal stack must have configuration for key `index`");
  return (n) => {
    var H, et, Pe, tt;
    const [r, a] = q.useState(!0);
    q.useEffect(() => {
      a(!1);
    }, []);
    const i = kr(), [o, s] = q.useState([{
      name: n.initialScreen ?? "index",
      state: void 0
    }]), [l, u] = k0(), [c, d] = [(j) => l(`scroll-${j}`), (j) => u(`scroll-${j}`)], [f, g] = [(j) => l(`content-${j}`), (j) => u(`content-${j}`)], v = q.useRef(null), C = q.useRef(null), A = q.useRef(null), k = o.length - 1, R = ((H = o[k]) == null ? void 0 : H.name) ?? "index", y = e[R], w = c(k), p = f(k), B = xd(p), b = (B == null ? void 0 : B.scrollHeight) ?? 0, S = (et = o[k]) == null ? void 0 : et.state, [O, I] = q.useState();
    Ur(() => {
      var j;
      if (!O) {
        const J = ((j = w.current) == null ? void 0 : j.clientHeight) ?? 0;
        I(J);
      }
    }, [w, O]);
    const P = q.useMemo(() => ({
      goBack: (j) => {
        var J, X;
        (X = (J = e[R]).onBack) == null || X.call(J, n), s((nt) => {
          const ft = nt.length > 1 ? nt.slice(0, -1) : nt, ht = ft.length - 1;
          return ft.map((je, Ye) => Ye === ht ? {
            name: je.name,
            state: j
          } : je);
        });
      },
      goTo: (j, J) => {
        s((X) => [...X, {
          name: j,
          state: J
        }]);
      },
      reset: () => s([{
        name: "index",
        state: void 0
      }])
    }), [s, R, n]), $ = Fn(o ?? []), {
      isGoBackDisabled: Q
    } = y, Y = q.useMemo(() => o.length > 1 && (!Q || typeof Q == "function" && !Q(n, S)) ? () => {
      var j;
      P.goBack(S), (j = n == null ? void 0 : n.onBackButtonClick) == null || j.call(n, R);
    } : void 0, [o, Q, P, n, S, R]), he = q.useMemo(() => () => {
      var j;
      return (j = n.onClose) == null ? void 0 : j.call(n, R);
    }, [n, R]);
    q.useEffect(() => {
      var j, J;
      $ !== void 0 && $.length < o.length && (Y ? (j = v.current) == null || j.focus() : (J = C.current) == null || J.focus());
    }, [$, o, Y]);
    const G = ((Pe = w == null ? void 0 : w.current) == null ? void 0 : Pe.querySelector("[data-thumbnails]")) ?? null, [we, Ce] = q.useState(0);
    Ur(() => {
      if (!G)
        return;
      const j = getComputedStyle(G), J = parseInt(j.marginTop) + parseInt(j.marginBottom);
      Ce(J + (G == null ? void 0 : G.clientHeight));
    }, [G]), ha(G, (j) => {
      var nt;
      const J = getComputedStyle(j.target), X = parseInt(J.marginTop) + parseInt(J.marginBottom);
      Ce(X + (((nt = j.contentBoxSize[0]) == null ? void 0 : nt.blockSize) ?? 0));
    });
    const ie = (tt = y.headerImage) == null ? void 0 : tt.call(y, n), [ct, be] = q.useState(0);
    Ur(() => {
      if (!w.current || !ie)
        return;
      const j = ie ? Zr * w.current.clientHeight : 0;
      be(j);
    }, [w, ie]), ha(w, (j) => {
      var X;
      const J = ie ? Zr * (((X = j.contentBoxSize[0]) == null ? void 0 : X.inlineSize) ?? 0) : 0;
      be(J);
    });
    const Ht = ie ? G ? ct + we + b : ct + b : Oo + b, pe = n.autoResize ? Ht : O, [Je, At] = q.useState(!1), Dt = y.shouldShowFooterBackground ?? L0;
    xl(w, p, ({
      scrollPositionBottom: j
    }) => {
      At(Dt(j));
    });
    const bt = q.useMemo(() => ({
      ...n,
      navigation: P
    }), [n, P]), dt = n.footerPosition ?? "absolute", {
      scrollY: Lt
    } = bs({
      container: w.current === null ? void 0 : w
    }), Me = q.useCallback(() => {
      var j, J;
      return (J = w.current) == null ? void 0 : J.scrollTo(0, ((j = p.current) == null ? void 0 : j.offsetHeight) ?? 0);
    }, [w, p]), {
      forceUpdate: We
    } = A0();
    return /* @__PURE__ */ V(D0, {
      $disableAnimation: r,
      $height: r ? "auto" : pe,
      "data-modal-scroll-root": !0,
      "data-test-id": n["data-test-id"],
      children: [/* @__PURE__ */ h(It, {
        initial: !1,
        mode: "sync",
        children: y.customHeader ? /* @__PURE__ */ ys(y.customHeader, {
          ...n,
          key: `custom-header-${k}`,
          backButtonRef: v,
          closeButtonRef: C,
          contentRef: p,
          headerTitle: typeof y.title == "string" ? y.title : y.title(n),
          onBackClick: Y,
          onCloseClick: he,
          scrollRef: w,
          scrollY: Lt
        }) : /* @__PURE__ */ h(zp, {
          onBackClick: Y,
          onCloseClick: he,
          backButtonRef: v,
          closeButtonRef: C
        })
      }), n.onZoomClick && ie && /* @__PURE__ */ h(F0, {
        children: /* @__PURE__ */ h(sa, {
          "aria-label": "Zoom in",
          icon: ac,
          onClick: n.onZoomClick,
          variant: "neutral"
        })
      }), /* @__PURE__ */ h(It, {
        initial: !1,
        children: o.map((j, J) => {
          var je, Ye, Vt;
          const X = e[j.name], nt = (je = X.headerImage) == null ? void 0 : je.call(X, n), ft = (Ye = X.thumbnails) == null ? void 0 : Ye.call(X, n), ht = (Vt = X.screenBackground) == null ? void 0 : Vt.call(X, n);
          return /* @__PURE__ */ h(Qf, {
            autofocus: !1,
            captureRef: d(J),
            focusAllowedElementRefsBefore: [Y ? v : void 0, n.onClose ? C : void 0].filter(Wt),
            focusAllowedElementRefsAfter: [X.footer ? A : void 0].filter(Wt),
            children: /* @__PURE__ */ V(oi, {
              showHeader: X.customHeader === void 0,
              scrollRef: d(J),
              contentRef: g(J),
              contentHeightFit: n.contentHeightFit,
              disablePerfectScrollbar: n.disablePerfectScrollbar,
              disableHeaderImageScaling: n.disableHeaderImageScaling,
              headerBarHeight: X.headerBarHeight ?? Oo,
              headerImage: nt,
              thumbnails: ft,
              headerImageHeight: ct,
              headerImageAspectRatio: Zr,
              headerTitle: typeof X.title == "string" ? X.title : X.title(n),
              headerTitleVisibility: X.titleVisibility,
              isInitialModalCardRender: r,
              variants: $o,
              initial: "initial",
              animate: "animate",
              exit: "exit",
              custom: {
                direction: i,
                isActivePage: J === o.length - 1
              },
              onAnimationStart: We,
              style: {
                background: ht,
                zIndex: J,
                ...J > 0 && {
                  inset: 0,
                  position: "absolute"
                }
              },
              transition: {
                bounce: 0,
                duration: 0.5,
                type: "spring"
              },
              children: [/* @__PURE__ */ h(X.screen, {
                ...n,
                isVisible: J === o.length - 1,
                navigation: P,
                onCloseClick: he,
                navigationState: S,
                scrollRef: w,
                contentRef: p,
                scrollY: Lt
              }), dt === "sticky" && /* @__PURE__ */ h(Aa, {
                pageKey: R,
                position: dt,
                ref: A,
                children: !!X.footer && /* @__PURE__ */ h(X.footer, {
                  ...bt,
                  showBackground: Je,
                  scrollToBottom: Me,
                  onCloseClick: he
                })
              })]
            })
          }, j.name);
        })
      }), /* @__PURE__ */ h(It, {
        initial: !1,
        children: dt === "absolute" && o.map((j, J) => {
          const X = e[j.name];
          return /* @__PURE__ */ h(Be.div, {
            variants: $o,
            initial: "initial",
            animate: "animate",
            exit: "exit",
            custom: {
              direction: i,
              isActivePage: J === o.length - 1
            },
            style: {
              zIndex: J
            },
            children: /* @__PURE__ */ h(Aa, {
              pageKey: j.name,
              position: dt,
              ref: A,
              children: !!X.footer && /* @__PURE__ */ h(X.footer, {
                ...bt,
                showBackground: Je,
                scrollToBottom: Me,
                onCloseClick: he
              })
            })
          }, j.name);
        })
      })]
    });
  };
}, z0 = (e) => [...Array.from({ length: e }, (n, r) => r / e), 1], Fo = {
  config: {
    root: null,
    rootMargin: "0px",
    threshold: z0(4)
  },
  // 50%
  errorMargin: 0.05,
  // 20%
  minTimeVisible: 250,
  // 5%
  percentCompensation: 0.2,
  visibilityRatio: 0.5
};
let Kt = null;
class _r {
  constructor(t = {}) {
    this.reportVisibilityStates = () => {
      this.elements.forEach(({ visible: n }, r) => {
        n && this.onVisibilityChange(r, n);
      });
    }, this.watchElements = (n) => {
      const r = window.innerHeight || document.documentElement.clientHeight;
      n.filter((a) => a.isIntersecting).forEach((a) => {
        const i = a.target || a.entry, o = this.elements.get(i);
        if (!o)
          return;
        const l = (a.boundingClientRect || i.getBoundingClientRect()).height, u = this.isElementHeightSimilarToContainer(l, r) ? this.options.errorMargin : 0.025, c = r / l > 1 ? this.options.visibilityRatio - u : r / l - u, d = a.intersectionRatio >= c;
        if (!(d && o.timeoutSet))
          if (d)
            o.timeoutSet = !0, this.timeouts.set(
              i,
              setTimeout(() => {
                this.onVisibilityChange(i, !0);
              }, this.options.minTimeVisible)
            );
          else {
            const f = this.timeouts.get(i);
            this.onVisibilityChange(i, !1), f && clearTimeout(f), this.timeouts.delete(i), o.timeoutSet = !1;
          }
      });
    }, this.observe = (n, r) => {
      !n || !r || (this.elements.set(n, {
        callback: r,
        entry: n,
        visible: !1
      }), this.observer.observe(n));
    }, this.unobserve = (n) => {
      n && this.elements.get(n) && (this.observer && this.observer.unobserve(n), this.elements.delete(n), this.elements.size === 0 && this.destroy());
    }, this.options = { ...Fo, ...t }, (isNaN(this.options.minTimeVisible) || this.options.minTimeVisible < 0) && (this.options.minTimeVisible = Fo.minTimeVisible), this.elements = /* @__PURE__ */ new Map(), this.timeouts = /* @__PURE__ */ new Map(), this.observer = new IntersectionObserver(this.watchElements, this.options.config), window.addEventListener("focus", this.reportVisibilityStates), window.addEventListener("orientationchange", this.reportVisibilityStates);
  }
  /**
   * Return the single instance of the IntersectionObserver if one exists already,
   * otherwise create an instance
   * @param {Object} options - ViewObserver instantiation options
   * @return {ViewObserver} return instance of the class
   */
  static get(t = {}) {
    return Kt && Kt instanceof _r || (Kt = new _r(t)), Kt;
  }
  /**
   * Remove window event listeners to avoid memory leaks
   */
  removeEventListeners() {
    window.removeEventListener("focus", this.reportVisibilityStates), window.removeEventListener("orientationchange", this.reportVisibilityStates);
  }
  /**
   * Detroy all Maps and event listeners.
   * @returns {null} returns instance
   */
  destroy() {
    return this.elements.clear(), this.timeouts.clear(), this.observer && typeof this.observer.disconnect == "function" && this.observer.disconnect(), this.removeEventListeners(), Kt = null, Kt;
  }
  isElementHeightSimilarToContainer(t, n) {
    return t >= n - n * this.options.percentCompensation && t <= n + n * this.options.percentCompensation;
  }
  /**
   * Handle DOM element visibility state change
   * @param  {HTMLElement} element - the DOM node
   * @param  {Boolean} visible - the visibility state of the entry
   */
  onVisibilityChange(t, n) {
    if (!t)
      return;
    const r = this.elements.get(t);
    if (!r)
      return;
    r.visible = n;
    const { callback: a } = r;
    typeof a == "function" && a(n);
  }
}
const _i = class _i extends q.PureComponent {
  constructor() {
    super(...arguments), this.observer = null, this.getRef = (t) => {
      if (t instanceof q.Component)
        if ("exposedImpressionRef" in t)
          this.container = t.exposedImpressionRef;
        else if ("observedElementRef" in t)
          this.container = t.observedElementRef;
        else
          throw new Error(
            "ImpressionTracker can only wrap native components or component classes with exposedImpressionRef property"
          );
      else
        this.container = t;
    }, this.handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        this.observe();
        return;
      }
      this.unobserve();
    }, this.trackEvent = (t) => {
      var n, r, a, i, o, s;
      (r = (n = this.props).onChange) == null || r.call(n, t), t ? ((i = (a = this.props).onView) == null || i.call(a, t), this.props.once && this.unobserve()) : (s = (o = this.props).onHide) == null || s.call(o, t);
    };
  }
  /**
   * Create the event listener on mount
   */
  componentDidMount() {
    this.observe(), document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }
  observe() {
    this.observer = _r.get(this.props.options), typeof this.container < "u" && this.container && this.observer.observe(this.container, this.trackEvent);
  }
  unobserve() {
    typeof this.container < "u" && this.observer && this.container && this.observer.unobserve(this.container), this.observer = null;
  }
  /**
   * Remove the observe listener on unmount
   */
  componentWillUnmount() {
    this.unobserve(), document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
  render() {
    return this.props.children && q.isValidElement(this.props.children) && q.cloneElement(q.Children.only(this.props.children), {
      ref: this.getRef
    });
  }
};
_i.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange() {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide() {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onView() {
  },
  once: !1,
  options: {}
};
let xn = _i;
const rn = (e) => E.union([e, E.null]);
function Bl(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
var an;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(an || (an = {}));
var qn = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a) {
      var i = this, o = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(n, "] ").concat(r, `
`).concat(o ? `
`.concat(o.message, `
`).concat(o.stack) : "")) || this, i.code = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error)
), W0 = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r) {
      return e.call(this, an.UNSUPPORTED_FORMATTER, n, r) || this;
    }
    return t;
  }(qn)
), j0 = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r) {
      return e.call(this, an.INVALID_CONFIG, n, r) || this;
    }
    return t;
  }(qn)
), Uo = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r) {
      return e.call(this, an.MISSING_DATA, n, r) || this;
    }
    return t;
  }(qn)
), ut = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a) {
      var i = e.call(this, an.FORMAT_ERROR, "".concat(n, `
Locale: `).concat(r, `
`), a) || this;
      return i.locale = r, i;
    }
    return t;
  }(qn)
), Qr = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r, a, i) {
      var o = e.call(this, "".concat(n, `
MessageID: `).concat(a == null ? void 0 : a.id, `
Default Message: `).concat(a == null ? void 0 : a.defaultMessage, `
Description: `).concat(a == null ? void 0 : a.description, `
`), r, i) || this;
      return o.descriptor = a, o.locale = r, o;
    }
    return t;
  }(ut)
), q0 = (
  /** @class */
  function(e) {
    lt(t, e);
    function t(n, r) {
      var a = e.call(this, an.MISSING_TRANSLATION, 'Missing message: "'.concat(n.id, '" for locale "').concat(r, '", using ').concat(n.defaultMessage ? "default message (".concat(typeof n.defaultMessage == "string" ? n.defaultMessage : n.defaultMessage.map(function(i) {
        var o;
        return (o = i.value) !== null && o !== void 0 ? o : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = n, a;
    }
    return t;
  }(qn)
);
function ln(e, t, n) {
  return n === void 0 && (n = {}), t.reduce(function(r, a) {
    return a in e ? r[a] = e[a] : a in n && (r[a] = n[a]), r;
  }, {});
}
var V0 = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, G0 = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, Hl = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: V0,
  onWarn: G0
};
function Dl() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function Zt(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Y0(e) {
  e === void 0 && (e = Dl());
  var t = Intl.RelativeTimeFormat, n = Intl.ListFormat, r = Intl.DisplayNames, a = _t(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.DateTimeFormat).bind.apply(s, St([void 0], l, !1)))();
  }, {
    cache: Zt(e.dateTime),
    strategy: Et.variadic
  }), i = _t(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.NumberFormat).bind.apply(s, St([void 0], l, !1)))();
  }, {
    cache: Zt(e.number),
    strategy: Et.variadic
  }), o = _t(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.PluralRules).bind.apply(s, St([void 0], l, !1)))();
  }, {
    cache: Zt(e.pluralRules),
    strategy: Et.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: _t(function(s, l, u, c) {
      return new ll(s, l, u, D({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: a,
        getPluralRules: o
      } }, c || {}));
    }, {
      cache: Zt(e.message),
      strategy: Et.variadic
    }),
    getRelativeTimeFormat: _t(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (t.bind.apply(t, St([void 0], s, !1)))();
    }, {
      cache: Zt(e.relativeTime),
      strategy: Et.variadic
    }),
    getPluralRules: o,
    getListFormat: _t(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (n.bind.apply(n, St([void 0], s, !1)))();
    }, {
      cache: Zt(e.list),
      strategy: Et.variadic
    }),
    getDisplayNames: _t(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (r.bind.apply(r, St([void 0], s, !1)))();
    }, {
      cache: Zt(e.displayNames),
      strategy: Et.variadic
    })
  };
}
function si(e, t, n, r) {
  var a = e && e[t], i;
  if (a && (i = a[n]), i)
    return i;
  r(new W0("No ".concat(t, " format named: ").concat(n)));
}
function ur(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = D({ timeZone: t }, e[r]), n;
  }, {});
}
function zo(e, t) {
  var n = Object.keys(D(D({}, e), t));
  return n.reduce(function(r, a) {
    return r[a] = D(D({}, e[a] || {}), t[a] || {}), r;
  }, {});
}
function Wo(e, t) {
  if (!t)
    return e;
  var n = ll.formats;
  return D(D(D({}, n), e), { date: zo(ur(n.date, t), ur(e.date || {}, t)), time: zo(ur(n.time, t), ur(e.time || {}, t)) });
}
var La = function(e, t, n, r, a) {
  var i = e.locale, o = e.formats, s = e.messages, l = e.defaultLocale, u = e.defaultFormats, c = e.fallbackOnEmptyString, d = e.onError, f = e.timeZone, g = e.defaultRichTextElements;
  n === void 0 && (n = { id: "" });
  var v = n.id, C = n.defaultMessage;
  Bl(!!v, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var A = String(v), k = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    s && Object.prototype.hasOwnProperty.call(s, A) && s[A]
  );
  if (Array.isArray(k) && k.length === 1 && k[0].type === ye.literal)
    return k[0].value;
  if (!r && k && typeof k == "string" && !g)
    return k.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (r = D(D({}, g), r || {}), o = Wo(o, f), u = Wo(u, f), !k) {
    if (c === !1 && k === "")
      return k;
    if ((!C || i && i.toLowerCase() !== l.toLowerCase()) && d(new q0(n, i)), C)
      try {
        var R = t.getMessageFormat(C, l, u, a);
        return R.format(r);
      } catch (y) {
        return d(new Qr('Error formatting default message for: "'.concat(A, '", rendering default message verbatim'), i, n, y)), typeof C == "string" ? C : A;
      }
    return A;
  }
  try {
    var R = t.getMessageFormat(k, i, o, D({ formatters: t }, a || {}));
    return R.format(r);
  } catch (y) {
    d(new Qr('Error formatting message: "'.concat(A, '", using ').concat(C ? "default message" : "id", " as fallback."), i, n, y));
  }
  if (C)
    try {
      var R = t.getMessageFormat(C, l, u, a);
      return R.format(r);
    } catch (y) {
      d(new Qr('Error formatting the default message for: "'.concat(A, '", rendering message verbatim'), i, n, y));
    }
  return typeof k == "string" ? k : typeof C == "string" ? C : A;
}, $l = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function Pr(e, t, n, r) {
  var a = e.locale, i = e.formats, o = e.onError, s = e.timeZone;
  r === void 0 && (r = {});
  var l = r.format, u = D(D({}, s && { timeZone: s }), l && si(i, t, l, o)), c = ln(r, $l, u);
  return t === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = D(D({}, c), { hour: "numeric", minute: "numeric" })), n(a, c);
}
function X0(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return Pr(e, "date", t, o).format(s);
  } catch (l) {
    e.onError(new ut("Error formatting date.", e.locale, l));
  }
  return String(s);
}
function K0(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return Pr(e, "time", t, o).format(s);
  } catch (l) {
    e.onError(new ut("Error formatting time.", e.locale, l));
  }
  return String(s);
}
function Z0(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], o = n[2], s = o === void 0 ? {} : o, l = e.timeZone, u = e.locale, c = e.onError, d = ln(s, $l, l ? { timeZone: l } : {});
  try {
    return t(u, d).formatRange(a, i);
  } catch (f) {
    c(new ut("Error formatting date time range.", e.locale, f));
  }
  return String(a);
}
function Q0(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return Pr(e, "date", t, o).formatToParts(s);
  } catch (l) {
    e.onError(new ut("Error formatting date.", e.locale, l));
  }
  return [];
}
function J0(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return Pr(e, "time", t, o).formatToParts(s);
  } catch (l) {
    e.onError(new ut("Error formatting time.", e.locale, l));
  }
  return [];
}
var em = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function tm(e, t, n, r) {
  var a = e.locale, i = e.onError, o = Intl.DisplayNames;
  o || i(new qt(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, Rt.MISSING_INTL_API));
  var s = ln(r, em);
  try {
    return t(a, s).of(n);
  } catch (l) {
    i(new ut("Error formatting display name.", a, l));
  }
}
var nm = [
  "type",
  "style"
], jo = Date.now();
function rm(e) {
  return "".concat(jo, "_").concat(e, "_").concat(jo);
}
function am(e, t, n, r) {
  r === void 0 && (r = {});
  var a = Fl(e, t, n, r).reduce(function(i, o) {
    var s = o.value;
    return typeof s != "string" ? i.push(s) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += s : i.push(s), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function Fl(e, t, n, r) {
  var a = e.locale, i = e.onError;
  r === void 0 && (r = {});
  var o = Intl.ListFormat;
  o || i(new qt(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, Rt.MISSING_INTL_API));
  var s = ln(r, nm);
  try {
    var l = {}, u = n.map(function(c, d) {
      if (typeof c == "object") {
        var f = rm(d);
        return l[f] = c, f;
      }
      return String(c);
    });
    return t(a, s).formatToParts(u).map(function(c) {
      return c.type === "literal" ? c : D(D({}, c), { value: l[c.value] || c.value });
    });
  } catch (c) {
    i(new ut("Error formatting list.", a, c));
  }
  return n;
}
var im = ["type"];
function om(e, t, n, r) {
  var a = e.locale, i = e.onError;
  r === void 0 && (r = {}), Intl.PluralRules || i(new qt(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, Rt.MISSING_INTL_API));
  var o = ln(r, im);
  try {
    return t(a, o).select(n);
  } catch (s) {
    i(new ut("Error formatting plural.", a, s));
  }
  return "other";
}
var sm = ["numeric", "style"];
function lm(e, t, n) {
  var r = e.locale, a = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var o = n.format, s = !!o && si(a, "relative", o, i) || {}, l = ln(n, sm, s);
  return t(r, l);
}
function um(e, t, n, r, a) {
  a === void 0 && (a = {}), r || (r = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new qt(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, Rt.MISSING_INTL_API));
  try {
    return lm(e, t, a).format(n, r);
  } catch (o) {
    e.onError(new ut("Error formatting relative time.", e.locale, o));
  }
  return String(n);
}
var cm = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function Ul(e, t, n) {
  var r = e.locale, a = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var o = n.format, s = o && si(a, "number", o, i) || {}, l = ln(n, cm, s);
  return t(r, l);
}
function dm(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Ul(e, t, r).format(n);
  } catch (a) {
    e.onError(new ut("Error formatting number.", e.locale, a));
  }
  return String(n);
}
function fm(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Ul(e, t, r).formatToParts(n);
  } catch (a) {
    e.onError(new ut("Error formatting number.", e.locale, a));
  }
  return [];
}
function hm(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function pm(e) {
  e.onWarn && e.defaultRichTextElements && hm(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function mm(e, t) {
  var n = Y0(t), r = D(D({}, Hl), e), a = r.locale, i = r.defaultLocale, o = r.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && o ? o(new Uo('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && o && o(new Uo('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (o && o(new j0('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), r.locale = r.defaultLocale || "en"), pm(r), D(D({}, r), {
    formatters: n,
    formatNumber: dm.bind(null, r, n.getNumberFormat),
    formatNumberToParts: fm.bind(null, r, n.getNumberFormat),
    formatRelativeTime: um.bind(null, r, n.getRelativeTimeFormat),
    formatDate: X0.bind(null, r, n.getDateTimeFormat),
    formatDateToParts: Q0.bind(null, r, n.getDateTimeFormat),
    formatTime: K0.bind(null, r, n.getDateTimeFormat),
    formatDateTimeRange: Z0.bind(null, r, n.getDateTimeFormat),
    formatTimeToParts: J0.bind(null, r, n.getDateTimeFormat),
    formatPlural: om.bind(null, r, n.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: La.bind(null, r, n),
    // @ts-expect-error TODO: will get to this later
    $t: La.bind(null, r, n),
    formatList: am.bind(null, r, n.getListFormat),
    formatListToParts: Fl.bind(null, r, n.getListFormat),
    formatDisplayName: tm.bind(null, r, n.getDisplayNames)
  });
}
function zl(e) {
  Bl(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var Wl = D(D({}, Hl), { textComponent: q.Fragment });
function gm(e) {
  return function(t) {
    return e(q.Children.toArray(t));
  };
}
function bm(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var n = Object.keys(e), r = Object.keys(t), a = n.length;
  if (r.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = n[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
var li = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = q.createContext(null)) : q.createContext(null);
li.Consumer;
var vm = li.Provider, ym = vm, _m = li;
function ui() {
  var e = q.useContext(_m);
  return zl(e), e;
}
var Oa;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(Oa || (Oa = {}));
var Ma;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(Ma || (Ma = {}));
function jl(e) {
  var t = function(n) {
    var r = ui(), a = n.value, i = n.children, o = Mr(n, ["value", "children"]), s = typeof a == "string" ? new Date(a || 0) : a, l = e === "formatDate" ? r.formatDateToParts(s, o) : r.formatTimeToParts(s, o);
    return i(l);
  };
  return t.displayName = Ma[e], t;
}
function Vn(e) {
  var t = function(n) {
    var r = ui(), a = n.value, i = n.children, o = Mr(
      n,
      ["value", "children"]
    ), s = r[e](a, o);
    if (typeof i == "function")
      return i(s);
    var l = r.textComponent || q.Fragment;
    return q.createElement(l, null, s);
  };
  return t.displayName = Oa[e], t;
}
function ql(e) {
  return e && Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return t[n] = sl(r) ? gm(r) : r, t;
  }, {});
}
var qo = function(e, t, n, r) {
  for (var a = [], i = 4; i < arguments.length; i++)
    a[i - 4] = arguments[i];
  var o = ql(r), s = La.apply(void 0, St([
    e,
    t,
    n,
    o
  ], a, !1));
  return Array.isArray(s) ? q.Children.toArray(s) : s;
}, Vo = function(e, t) {
  var n = e.defaultRichTextElements, r = Mr(e, ["defaultRichTextElements"]), a = ql(n), i = mm(D(D(D({}, Wl), r), { defaultRichTextElements: a }), t), o = {
    locale: i.locale,
    timeZone: i.timeZone,
    fallbackOnEmptyString: i.fallbackOnEmptyString,
    formats: i.formats,
    defaultLocale: i.defaultLocale,
    defaultFormats: i.defaultFormats,
    messages: i.messages,
    onError: i.onError,
    defaultRichTextElements: a
  };
  return D(D({}, i), {
    formatMessage: qo.bind(
      null,
      o,
      // @ts-expect-error fix this
      i.formatters
    ),
    // @ts-expect-error fix this
    $t: qo.bind(null, o, i.formatters)
  });
};
function Jr(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
var Em = (
  /** @class */
  function(e) {
    lt(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.cache = Dl(), n.state = {
        cache: n.cache,
        intl: Vo(Jr(n.props), n.cache),
        prevConfig: Jr(n.props)
      }, n;
    }
    return t.getDerivedStateFromProps = function(n, r) {
      var a = r.prevConfig, i = r.cache, o = Jr(n);
      return bm(a, o) ? null : {
        intl: Vo(o, i),
        prevConfig: o
      };
    }, t.prototype.render = function() {
      return zl(this.state.intl), q.createElement(ym, { value: this.state.intl }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = Wl, t;
  }(q.PureComponent)
);
const Sm = Em;
Vn("formatDate");
Vn("formatTime");
Vn("formatNumber");
Vn("formatList");
Vn("formatDisplayName");
jl("formatDate");
jl("formatTime");
const Bt = ui, ea = ({ id: e, values: t }) => {
  const { formatMessage: n } = Bt();
  return /* @__PURE__ */ h(Rr, { children: n({ id: e }, t) });
}, Pa = {
  "csat-modal": {
    labels: {
      disgusted: "Terrible",
      excited: "Excited",
      happy: "Happy",
      meh: "Meh",
      sad: "Sad"
    },
    screens: {
      index: {
        body: "Your feedback helps us do better next time.",
        title: "How did we do today?"
      },
      thank_you: {
        body: "We've got your feedback.",
        "done-button": "Done",
        title: "Thank you!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Contact Support",
    title: "Something went wrong",
    "try-again-button": "Try again"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "You have {quantity} of these selected. Change the quantity.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Remove one",
      "increment-aria-label": "Add one more",
      label: "Quantity"
    }
  }
}, ci = (e) => {
  const t = {};
  for (const n in e) {
    if (!e.hasOwnProperty(n))
      continue;
    const r = e[n];
    if (typeof r == "object" && r !== null) {
      const a = ci(r);
      for (const i in a) {
        if (!a.hasOwnProperty(i))
          continue;
        const o = a[i];
        o && (t[`${n}.${i}`] = o);
      }
    } else
      typeof r == "string" && (t[n] = r);
  }
  return t;
};
ci(Pa);
const Tm = {}, Go = {
  "csat-modal": {
    labels: {
      disgusted: "رديء",
      excited: "متحمّس",
      happy: "سعيد",
      meh: "دون المستوى المطلوب",
      sad: "حزين"
    },
    screens: {
      index: {
        body: "تقييمك يساعدنا على تحسين خدمتنا في المرّات القادمة.",
        title: "ما هو رأيك بنا اليوم؟"
      },
      thank_you: {
        body: "لقد حصلنا على تقييمك.",
        "done-button": "تم",
        title: "شكرًا لك!"
      }
    }
  },
  "error-page": {
    title: "همم... حدث خطأ ما",
    "try-again-button": "المحاولة مرة أخرى"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "لقد قمت باختيار {quantity} منه. تغيير الكمّية.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "إزالة واحد",
      "increment-aria-label": "إضافة واحد آخر",
      label: "كمية"
    }
  }
}, wm = {
  "csat-modal": {
    labels: {
      disgusted: "Çox pis",
      excited: "Məmnun",
      happy: "Xoşbəxt",
      meh: "Bilmirəm",
      sad: "Kədərli"
    },
    screens: {
      index: {
        body: "Rəyiniz daha da təkmilləşməyimizə kömək edir.",
        title: "Bugünkü işimizi bəyəndiniz?"
      },
      thank_you: {
        body: "Rəyinizi aldıq.",
        "done-button": "Hazırdır",
        title: "Təşəkkür edirik!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Dəstək xidməti ilə əlaqə saxlayın",
    title: "Xəta baş verdi",
    "try-again-button": "Yenidən cəhd et"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Bu seçilmişlərdən {quantity} varınızdır. Sayı dəyişdirin.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Birini silin",
      "increment-aria-label": "Daha birini əlavə edin",
      label: "Miqdarı"
    }
  }
}, Cm = {
  "csat-modal": {
    labels: {
      disgusted: "Strašné",
      excited: "Nadšení",
      happy: "Radost",
      meh: "Nic moc",
      sad: "Smutek"
    },
    screens: {
      index: {
        body: "Vaše zpětná vazba nám pomůže být příště lepší.",
        title: "Jak se nám dnes dařilo?"
      },
      thank_you: {
        body: "Máme vaši zpětnou vazbu.",
        "done-button": "Hotovo",
        title: "Děkujeme!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontaktovat zákaznickou podporu",
    title: "Něco se pokazilo",
    "try-again-button": "Zkusit znovu"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Vybrali jste {quantity} z nich. Změňte množství.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Odebrat jedna",
      "increment-aria-label": "Přidat ještě jeden kus",
      label: "Množství"
    }
  }
}, Im = {
  "csat-modal": {
    labels: {
      disgusted: "Forfærdelig",
      excited: "Begejstret",
      happy: "Glad",
      meh: "Middel",
      sad: "Ked af det"
    },
    screens: {
      index: {
        body: "Din feedback hjælper os med at gøre det bedre næste gang.",
        title: "Hvordan klarede vi det i dag?"
      },
      thank_you: {
        body: "Vi har fået din feedback.",
        "done-button": "Færdig",
        title: "Tak!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontakt Support",
    title: "Der gik noget galt",
    "try-again-button": "Prøv igen"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Du har valgt {quantity} af disse. Ændr antallet.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Fjern en",
      "increment-aria-label": "Tilføj en til",
      label: "Antal"
    }
  }
}, Rm = {}, Yo = {
  "csat-modal": {
    labels: {
      disgusted: "Furchtbar",
      excited: "Super",
      happy: "Zufrieden",
      meh: "Geht so",
      sad: "Schlecht"
    },
    screens: {
      index: {
        body: "Dein Feedback hilft uns, es nächstes Mal besser zu machen.",
        title: "Wie haben wir uns heute geschlagen?"
      },
      thank_you: {
        body: "Wir haben dein Feedback erhalten.",
        "done-button": "Fertig",
        title: "Danke!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kundensupport kontaktieren",
    title: "Irgendwas ist schief gegangen",
    "try-again-button": "Nochmal versuchen"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Du hast {quantity} davon ausgewählt. Ändere die Menge.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Entferne eins",
      "increment-aria-label": "Füge ein weiteres hinzu",
      label: "Menge"
    }
  }
}, km = {
  "csat-modal": {
    labels: {
      disgusted: "Απαίσια",
      excited: "Ενθουσιασμένος",
      happy: "Χαρούμενος",
      meh: "Έτσι κι έτσι",
      sad: "Λυπημένος"
    },
    screens: {
      index: {
        body: "Τα σχόλιά σου μάς βοηθούν να γίνουμε καλύτερα για την επόμενη φορά.",
        title: "Πώς τα πήγαμε σήμερα;"
      },
      thank_you: {
        body: "Λάβαμε τα σχόλιά σου.",
        "done-button": "Τέλος",
        title: "Ευχαριστούμε!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Επικοινώνησε με την υποστήριξη",
    title: "Κάτι πήγε λάθος",
    "try-again-button": "Προσπάθησε ξανά"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Έχεις επιλέξει {quantity} από αυτά. Άλλαξε την ποσότητα.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Αφαίρεσε ένα",
      "increment-aria-label": "Πρόσθεσε ένα ακόμα",
      label: "Ποσότητα"
    }
  }
}, Am = {
  "csat-modal": {
    labels: {
      disgusted: "Kohutav",
      excited: "Elevil",
      happy: "Õnnelik",
      meh: "Käib kah",
      sad: "Kurb"
    },
    screens: {
      index: {
        body: "Sinu tagasisiside aitab meil järgmine kord paremat teenust osutada.",
        title: "Kuidas meil täna läks?"
      },
      thank_you: {
        body: "Saime sinu tagasiside kätte.",
        "done-button": "Valmis",
        title: "Aitäh!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Võta ühendust klienditoega",
    title: "Midagi läks valesti",
    "try-again-button": "Proovi uuesti"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Oled neist valinud {quantity}. Muuda kogust.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Eemalda üks",
      "increment-aria-label": "Lisa veel üks",
      label: "Kogus"
    }
  }
}, Lm = {
  "csat-modal": {
    labels: {
      disgusted: "Kamala",
      excited: "Innostunut",
      happy: "Iloinen",
      meh: "Nooh...",
      sad: "Surullinen"
    },
    screens: {
      index: {
        body: "Palautteesi auttaa meitä parantamaan palvelua.",
        title: "Kuinka onnistuimme tänään?"
      },
      thank_you: {
        body: "Saimme palautteesi.",
        "done-button": "Valmis",
        title: "Kiitos!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Ota yhteys asiakaspalveluun",
    title: "Jokin meni pieleen",
    "try-again-button": "Yritä uudelleen"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Olet valinnut {quantity} kappaletta näitä. Muuta määrää.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Poista yksi",
      "increment-aria-label": "Lisää yksi",
      label: "Määrä"
    }
  }
}, Om = {
  "csat-modal": {
    labels: {
      disgusted: "Terrible",
      excited: "Excité",
      happy: "Heureux",
      meh: "Bof",
      sad: "Triste"
    },
    screens: {
      index: {
        body: "Vos commentaires nous aident à faire mieux la prochaine fois.",
        title: "Comment nous en sommes-nous sortis aujourd’hui ?"
      },
      thank_you: {
        body: "Votre avis a été pris en compte.",
        "done-button": "Terminé",
        title: "Merci !"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Contacter l’assistance",
    title: "Un problème est survenu",
    "try-again-button": "Réessayer"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Vous en avez {quantity} de sélectionné(s). Modifier la quantité.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "En retirer un",
      "increment-aria-label": "En ajouter un de plus",
      label: "Quantité"
    }
  }
}, Mm = {
  "csat-modal": {
    labels: {
      disgusted: "לא משהו",
      excited: "מדהים",
      happy: "מרוצה",
      meh: "סביר",
      sad: "מבאס"
    },
    screens: {
      index: {
        body: "הפידבק שלך יעזור לנו להשתפר לפעמים הבאות.",
        title: "איך היינו היום?"
      },
      thank_you: {
        body: "קיבלנו את הפידבק שלך.",
        "done-button": "סיימתי",
        title: "תודה!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "לשיחה בצ'אט",
    title: "נראה שיש תקלה",
    "try-again-button": "כדאי לנסות שוב"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "יש לך {quantity} מהפריטים הנבחרים. צריך לשנות את quantity.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": `להסיר אחד
`,
      "increment-aria-label": "להוסיף עוד אחד",
      label: "כמות"
    }
  }
}, Pm = {
  "csat-modal": {
    labels: {
      disgusted: "Grozno",
      excited: "Oduševljeno",
      happy: "Sretno",
      meh: "Onako",
      sad: "Tužno"
    },
    screens: {
      index: {
        body: "Povratne informacije nam pomažu da sljedeći put budemo bolji.",
        title: "Kakvi smo danas bili?"
      },
      thank_you: {
        body: "Primili smo vaše povratne informacije.",
        "done-button": "Gotovo",
        title: "Hvala vam!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Obratite se podršci",
    title: "Nešto nije u redu",
    "try-again-button": "Pokušajte ponovno"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Odabrali ste {quantity}. Promijenite količinu.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Uklonite jedan",
      "increment-aria-label": "Dodajte još jedan",
      label: "Količina"
    }
  }
}, Nm = {
  "csat-modal": {
    labels: {
      disgusted: "Borzasztó",
      excited: "Remek",
      happy: "Csodás",
      meh: "Átl",
      sad: "Bús"
    },
    screens: {
      index: {
        body: "A visszajelzéseddel legközelebb jobban teljesíthetünk.",
        title: "Hogy teljesítettünk ma?"
      },
      thank_you: {
        body: "Megkaptuk a visszajelzésedet.",
        "done-button": "Kész",
        title: "Köszönjük!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kapcsolatfelvétel az ügyfélszolgálattal",
    title: "Valami hiba történt",
    "try-again-button": "Újra"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Ennyit választottál ki ezek közül: {quantity}. Módosítsd a mennyiséget.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Egy eltáv.",
      "increment-aria-label": "Egy hozzáad.",
      label: "Mennyiség"
    }
  }
}, xm = {
  "csat-modal": {
    labels: {
      disgusted: "Hræðilegt",
      excited: "Spennt/ur",
      happy: "Ánægð/ur",
      meh: "Meh",
      sad: "Leið/ur"
    },
    screens: {
      index: {
        body: "Endurgjöfin þín hjálpar okkur að gera betur næst.",
        title: "Hvernig stóðum við okkur í dag?"
      },
      thank_you: {
        body: "Við fengum endurgjöfina frá þér.",
        "done-button": "Búið",
        title: "Takk fyrir!"
      }
    }
  },
  "error-page": {
    title: "Eitthvað fór úrskeiðis",
    "try-again-button": "Reyndu aftur"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Þú ert með {quantity} af þessu valið. Breyta magni.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Fjarlægja eitt",
      "increment-aria-label": "Bæta við einu í viðbót",
      label: "Magn"
    }
  }
}, Bm = {
  "csat-modal": {
    labels: {
      disgusted: "最悪",
      excited: "すばらしい",
      happy: "満足",
      meh: "まぁまぁ",
      sad: "残念"
    },
    screens: {
      index: {
        body: "いただいたご意見は、次回以降のサービス向上に役立てさせていただきます。",
        title: "今回のサービスについて感想をお聞かせください。"
      },
      thank_you: {
        body: "フィードバックありがとうございました。",
        "done-button": "完了",
        title: "ありがとうございました。"
      }
    }
  },
  "error-page": {
    "contact-support-button": "サポートに連絡する",
    title: "問題が発生しました",
    "try-again-button": "もう一度試す"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "{quantity}点を選択済みです。点数を変更してください。",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "1点削除する",
      "increment-aria-label": "もう1点追加する",
      label: "点数"
    }
  }
}, Hm = {
  "csat-modal": {
    labels: {
      disgusted: "ძალიან ცუდი",
      excited: "აღტაცებული",
      happy: "ბედნიერი",
      meh: "არ ვიცი",
      sad: "მოწყენილი"
    },
    screens: {
      index: {
        body: "თქვენი გამოხმაურება გვეხმარება შემდეგ ჯერზე უკეთესი მომსახურების გაწევაში.",
        title: "დღეს როგორ ვიმუშავეთ?"
      },
      thank_you: {
        body: "ჩვენ მივიღეთ თქვენი უკუკავშირი.",
        "done-button": "შესრულებულია",
        title: "გმადლობთ!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "დაუკავშირდით მხარდაჭერის გუნდს",
    title: "დაფიქსირდა ხარვეზი",
    "try-again-button": "ხელახლა სცადეთ"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "თქვენ აირჩიეთ ერთ-ერთი {quantity}. შეცვალეთ რაოდენობა.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "ერთის წაშლა",
      "increment-aria-label": "კიდევ ერთის დამატება",
      label: "რაოდენობა"
    }
  }
}, Dm = {
  "csat-modal": {
    labels: {
      disgusted: "Өте нашар",
      excited: "Тамаша",
      happy: "Көңілді",
      meh: "Орташа",
      sad: "Нашар"
    },
    screens: {
      index: {
        body: "Пікіріңіз бізге жақсырақ жұмыс істеуге көмектеседі.",
        title: "Бүгін қалай жұмыс істедік?"
      },
      thank_you: {
        body: "Сіздің пікіріңізді алдық.",
        "done-button": "Дайын",
        title: "Рақмет!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Қолдау қызметіне хабарласыңыз",
    title: "Бірдеңе дұрыс болмады",
    "try-again-button": "Қайталау"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Сізде осы таңдалғандардың {quantity} данасы бар. Санын өзгертіңіз.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Біреуін алып тастау",
      "increment-aria-label": "Тағы бірін қосу",
      label: "Саны"
    }
  }
}, $m = {
  "csat-modal": {
    labels: {
      disgusted: "Siaubinga",
      excited: "Nuostabu",
      happy: "Gerai",
      meh: "Nelabai",
      sad: "Liūdnai"
    },
    screens: {
      index: {
        body: "Jūsų atsiliepimai padeda mums tobulėti.",
        title: "Kaip mums šiandien sekėsi?"
      },
      thank_you: {
        body: "Gavome jūsų atsiliepimą.",
        "done-button": "Atlikta",
        title: "Ačiū!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Pagalba",
    title: "Kažkas ne taip",
    "try-again-button": "Pabandykite dar kartą"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Esate pasirinkę {quantity}. Pakeiskite kiekį.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Pašalinti vieną",
      "increment-aria-label": "Pridėti dar vieną",
      label: "Kiekis"
    }
  }
}, Fm = {
  "csat-modal": {
    labels: {
      disgusted: "Briesmīgi",
      excited: "Sajūsmā",
      happy: "Priecīgi",
      meh: "Meh",
      sad: "Bēdīgi"
    },
    screens: {
      index: {
        body: "Tava atsauksme palīdzēs mums nākamreiz strādāt labāk.",
        title: "Kā mums šodien veicās?"
      },
      thank_you: {
        body: "Mēs esam saņēmuši tavas atsauksmes.",
        "done-button": "Gatavs",
        title: "Paldies!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Sazināties ar Klientu atbalstu",
    title: "Kaut kas nogāja greizi",
    "try-again-button": "Mēģināt vēlreiz"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Tu esi {quantity} no šiem atlasītajiem. Maini daudzumu.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Noņemt",
      "increment-aria-label": "Pievienot vēl vienu",
      label: "Daudzums"
    }
  }
}, Um = {
  "csat-modal": {
    labels: {
      disgusted: "Forferdelig",
      excited: "Spent",
      happy: "Glad",
      meh: "Tja",
      sad: "Trist"
    },
    screens: {
      index: {
        body: "Din tilbakemelding hjelper oss med å forbedre våre tjenester til neste gang.",
        title: "Hvordan var vi idag?"
      },
      thank_you: {
        body: "Vi har fått din tilbakemelding.",
        "done-button": "Klar",
        title: "Tusen skal du ha!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontakt support",
    title: "Noe gikk galt",
    "try-again-button": "Prøv på nytt"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Du har {quantity}av disse valgt. Endre antallet.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Fjern én",
      "increment-aria-label": "Legg til en",
      label: "Antall"
    }
  }
}, zm = {
  "csat-modal": {
    labels: {
      disgusted: "Okropnie",
      excited: "Podekscytowany",
      happy: "Szczęśliwy",
      meh: "Tak sobie",
      sad: "Smutny"
    },
    screens: {
      index: {
        body: "Twoja opinia pomoże nam poprawić poziom obsługi klientów.",
        title: "Jak nam dzisiaj poszło?"
      },
      thank_you: {
        body: "Otrzymaliśmy Twoją opinię.",
        "done-button": "Gotowe",
        title: "Dziękujemy!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Skontaktuj się z nami",
    title: "Coś poszło nie tak",
    "try-again-button": "Spróbuj ponownie"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Wybrano {quantity} z nich. Zmień ilość.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Usuń jedno",
      "increment-aria-label": "Dodaj jeszcze jedno",
      label: "Ilość"
    }
  }
}, Wm = {
  "csat-modal": {
    labels: {
      disgusted: "Ужасно",
      excited: "Замечательно",
      happy: "Отлично",
      meh: "Средне",
      sad: "Плохо"
    },
    screens: {
      index: {
        body: "Ваши отзывы помогают нам становиться лучше.",
        title: "Как мы справились сегодня?"
      },
      thank_you: {
        body: "Мы получили ваш отзыв.",
        "done-button": "Готово",
        title: "Спасибо!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Связаться с поддержкой",
    title: "Ой! Что-то пошло не так",
    "try-again-button": "Попробуйте еще раз"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "У вас есть {quantity} из них выбранных. Измените количество.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Убрать один",
      "increment-aria-label": "Добавить ещё",
      label: "Количество"
    }
  }
}, jm = {
  "csat-modal": {
    labels: {
      disgusted: "Strašné",
      excited: "Vzrušujúce",
      happy: "Šťastné",
      meh: "Nič moc",
      sad: "Smutné"
    },
    screens: {
      index: {
        body: "Vaša spätná väzba nám pomôže sa v budúcnosti zlepšiť.",
        title: "Ako sme na tom dnes?"
      },
      thank_you: {
        body: "Dostali sme vašu spätnú väzbu.",
        "done-button": "Hotovo",
        title: "Ďakujeme!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontaktujte podporu",
    title: "Niečo sa pokazilo",
    "try-again-button": "Skúste to znovu"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Vybrali ste {quantity}. Zmeňte množstvo.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Odobrať jednu",
      "increment-aria-label": "Pridať jednu",
      label: "Množstvo"
    }
  }
}, qm = {
  "csat-modal": {
    labels: {
      disgusted: "Grozovito",
      excited: "Navdušen",
      happy: "Srečno",
      meh: "Eh",
      sad: "Žalostno"
    },
    screens: {
      index: {
        body: "Zaradi povratnih informacij smo še boljši.",
        title: "Kako nam je šlo danes?"
      },
      thank_you: {
        body: "Pridobili smo vaše povratne informacije.",
        "done-button": "Končano",
        title: "Hvala!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontaktiraj podporo",
    title: "Prišlo je do napake.",
    "try-again-button": "Poskusi znova"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Izbrana je {quantity} od teh možnosti. Spremenite količino.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Odstrani eno",
      "increment-aria-label": "Dodajte še eno",
      label: "Količina"
    }
  }
}, Vm = {
  "csat-modal": {
    labels: {
      disgusted: "E tmerrshme",
      excited: "E emocionuar",
      happy: "E lumtur",
      meh: "Meh",
      sad: "E trishtuar"
    },
    screens: {
      index: {
        body: "Komentet e tua na ndihmojnë për t’u përmirësuar për herën tjetër.",
        title: "Si shkoi sot?"
      },
      thank_you: {
        body: "I morëm komentet e tua.",
        "done-button": "Përfunduar",
        title: "Faleminderit!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontakto mbështetjen",
    title: "Diçka shkoi gabim.",
    "try-again-button": "Provo përsëri"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Ke përzgjedhur {quantity} nga këto. Ndrysho sasinë.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Hiq një",
      "increment-aria-label": "Shto edhe një",
      label: "Sasia"
    }
  }
}, Gm = {
  "csat-modal": {
    labels: {
      disgusted: "Užasno",
      excited: "Uzbuđeno",
      happy: "Srećno",
      meh: "Onako",
      sad: "Tužno"
    },
    screens: {
      index: {
        body: "Povratne informacije nam pomažu da sledeći put budemo bolji.",
        title: "Kako smo prošli danas?"
      },
      thank_you: {
        body: "Dobili smo vaše povratne informacije.",
        "done-button": "Kraj",
        title: "Hvala!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontaktirajte podršku",
    title: "Nešto ne funkcioniše",
    "try-again-button": "Pokušajte ponovo"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Imate {quantity} od izabranih. Promenite količinu.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Uklonite jedan",
      "increment-aria-label": "Dodajte još jedan",
      label: "Količina"
    }
  }
}, Ym = {
  "csat-modal": {
    labels: {
      disgusted: "Dålig",
      excited: "Glad",
      happy: "Nöjd",
      meh: "Meh",
      sad: "Ledsen"
    },
    screens: {
      index: {
        body: "Din feedback hjälper oss att bli bättre!",
        title: "Hur gjorde vi ifrån oss idag?"
      },
      thank_you: {
        body: "Vi har tagit emot din feedback.",
        "done-button": "Klart",
        title: "Tack!"
      }
    }
  },
  "error-page": {
    "contact-support-button": "Kontakta supporten",
    title: "Något gick fel",
    "try-again-button": "Testa på nytt"
  },
  "order-items-selection-input": {
    "quantity-button-aria-label": "Du har valt {quantity} av dessa. Ändra antalet.",
    "quantity-button-aria-marker-label": "{quantity}",
    stepper: {
      "decrement-aria-label": "Ta bort en",
      "increment-aria-label": "Lägg till en ",
      label: "Antal"
    }
  }
}, Xm = {}, Na = {
  ar: Go,
  arIl: {
    ...Go,
    ...Tm
  },
  az: wm,
  cs: Cm,
  da: Im,
  de: Yo,
  deAt: {
    ...Yo,
    ...Rm
  },
  el: km,
  en: Pa,
  et: Am,
  fi: Lm,
  fr: Om,
  he: Mm,
  hr: Pm,
  hu: Nm,
  is: xm,
  ja: Bm,
  ka: Hm,
  kk: Dm,
  lt: $m,
  lv: Fm,
  no: Um,
  pl: zm,
  ru: Wm,
  sk: jm,
  sl: qm,
  sq: Vm,
  sr: Gm,
  sv: Ym,
  uk: {
    ...Xm,
    ...Pa
  }
}, Km = (e) => e in Na, xa = "en", Zm = vs({
  locale: xa,
  messages: {}
}), Qm = ({ children: e, locale: t }) => {
  const n = xt(() => {
    const r = !Ut(t) && Km(t);
    return {
      locale: t ?? xa,
      messages: ci(
        r ? Na[t] : Na[xa]
      )
    };
  }, [t]);
  return /* @__PURE__ */ h(Zm.Provider, { value: n, children: /* @__PURE__ */ h(Sm, { locale: n.locale, messages: n.messages, children: e }) });
}, Xo = /* @__PURE__ */ M("h2")({
  name: "Title",
  class: "support-layer-CsatModalNavigationStack_Title_t1hr9lkr",
  propsAsIs: !1
}), Ko = /* @__PURE__ */ M("p")({
  name: "Body",
  class: "support-layer-CsatModalNavigationStack_Body_b658dwf",
  propsAsIs: !1
}), Zo = /* @__PURE__ */ M("div")({
  name: "Content",
  class: "support-layer-CsatModalNavigationStack_Content_c1nyhwgr",
  propsAsIs: !1
}), Jm = /* @__PURE__ */ M("div")({
  name: "RatingContainer",
  class: "support-layer-CsatModalNavigationStack_RatingContainer_r1f8sgau",
  propsAsIs: !1
}), eg = () => kl, tg = /* @__PURE__ */ M(eg())({
  name: "CsatRatingInput",
  class: "support-layer-CsatModalNavigationStack_CsatRatingInput_cz4pwvl",
  propsAsIs: !0
}), ng = /* @__PURE__ */ M("div")({
  name: "ButtonFooter",
  class: "support-layer-CsatModalNavigationStack_ButtonFooter_b1natblj",
  propsAsIs: !1
}), rg = U0({
  index: {
    screen: ({
      csatRatingInputProps: {
        onSelect: e,
        ...t
      },
      labels: n,
      navigation: r,
      onRatingSelect: a
    }) => {
      const {
        body: i,
        title: o
      } = n.index;
      return /* @__PURE__ */ V(Zo, {
        children: [/* @__PURE__ */ h(Xo, {
          children: o
        }), /* @__PURE__ */ h(Ko, {
          children: i
        }), /* @__PURE__ */ h(Jm, {
          children: /* @__PURE__ */ h(tg, {
            ...t,
            onSelect: (l) => {
              e(l), a(l.rating), r.goTo("thankYou");
            }
          })
        })]
      });
    },
    title: ({
      labels: e
    }) => e.index.title,
    titleVisibility: "onScroll"
  },
  thankYou: {
    isGoBackDisabled: !0,
    screen: ({
      labels: e,
      onClose: t
    }) => {
      const {
        body: n,
        doneButton: r,
        title: a
      } = e.thankYou;
      return /* @__PURE__ */ V(Zo, {
        children: [/* @__PURE__ */ h(Xo, {
          children: a
        }), /* @__PURE__ */ h(Ko, {
          children: n
        }), /* @__PURE__ */ h(ng, {
          children: /* @__PURE__ */ h(Un, {
            variant: "brand",
            size: "large",
            onClick: t,
            children: r
          })
        })]
      });
    },
    title: ({
      labels: e
    }) => e.index.title,
    titleVisibility: "onScroll"
  }
}), di = Wa({
  onDisplayChat: null,
  onError: null,
  onTelemetryEvent: null
}), ag = () => kt(di, (e) => e.onTelemetryEvent), Vl = () => kt(di, (e) => e.onDisplayChat), ig = /* @__PURE__ */ M("div")({
  name: "Layout",
  class: "support-layer-ErrorPage_Layout_l1sdn3m",
  propsAsIs: !1
}), og = /* @__PURE__ */ M("div")({
  name: "ContentContainer",
  class: "support-layer-ErrorPage_ContentContainer_ch33hc2",
  propsAsIs: !1
}), sg = /* @__PURE__ */ M("h1")({
  name: "Title",
  class: "support-layer-ErrorPage_Title_tz74d4n",
  propsAsIs: !1
}), lg = /* @__PURE__ */ M("div")({
  name: "ButtonFooter",
  class: "support-layer-ErrorPage_ButtonFooter_b1bwgj7x",
  propsAsIs: !1
}), ug = ({
  handleTryAgainButtonClick: e
}) => {
  const t = Vl();
  return /* @__PURE__ */ h(ig, {
    children: /* @__PURE__ */ V(og, {
      children: [/* @__PURE__ */ h(ti, {
        src: ua.wide.girlWires,
        aspectRatio: "3/2"
      }), /* @__PURE__ */ h(sg, {
        children: /* @__PURE__ */ h(ea, {
          id: "error-page.title"
        })
      }), /* @__PURE__ */ V(lg, {
        children: [/* @__PURE__ */ h(la, {
          variant: "primary",
          size: "large",
          onClick: e,
          children: /* @__PURE__ */ h(ea, {
            id: "error-page.try-again-button"
          })
        }), /* @__PURE__ */ h(la, {
          variant: "secondary",
          size: "large",
          onClick: () => {
            t == null || t();
          },
          children: /* @__PURE__ */ h(ea, {
            id: "error-page.contact-support-button"
          })
        })]
      })]
    })
  });
}, cg = "v5", Gl = "api/support_layer", dg = `${Gl}/${cg}`, Er = ec(
  Is({
    baseURL: sn.API_URL
  })
), fg = ({
  appApiBaseUrl: e,
  appCountry: t,
  appLanguage: n,
  appType: r,
  appVersion: a,
  appWoltSessionId: i = "",
  clientContext: o,
  customApiHeaders: s,
  getAccessToken: l
}) => {
  Er.interceptors.request.clear(), Er.interceptors.request.use(async (u) => {
    var f;
    const c = await l(), d = !!((f = u.url) != null && f.endsWith("/start"));
    return ot(e) && (u.baseURL = e), u.headers.set("Authorization", `Bearer ${c}`), Ua(s) && Object.entries(s).forEach(([g, v]) => {
      u.headers.set(g, v);
    }), u.data = {
      ...u.data,
      appCountry: t,
      appLanguage: n,
      appPlatform: "web",
      appTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      appType: r,
      appVersion: a,
      appWoltSessionId: i,
      // Note: clientContext is only sent once for the start endpoint
      ...d && { clientContext: o }
    }, u;
  });
}, Qo = new Wu({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      retry: !1
    }
  }
}), Ky = ({
  children: e,
  onDisplayChat: t,
  onError: n,
  onTelemetryEvent: r,
  ...a
}) => {
  const { appLanguage: i } = a;
  return de(() => {
    Qo.resetQueries();
  }, [a.appType, a.appCountry, a.appLanguage]), fg(a), /* @__PURE__ */ h(
    di.Provider,
    {
      value: {
        onDisplayChat: t,
        onError: n,
        onTelemetryEvent: r
      },
      children: /* @__PURE__ */ h(Qm, { locale: i, children: /* @__PURE__ */ h(ju, { client: Qo, children: /* @__PURE__ */ h(Yf, { children: /* @__PURE__ */ h(
        rc,
        {
          onError: n,
          fallbackRender: ({ resetErrorBoundary: o }) => /* @__PURE__ */ h(ug, { handleTryAgainButtonClick: o }),
          children: e
        }
      ) }) }) })
    }
  );
}, un = Wa({
  csatModal: null,
  navigationDirection: null,
  pageStack: null,
  session: null,
  state: null,
  telemetry: null
}), Nr = () => kt(un, (e) => e.session), xr = () => kt(un, (e) => e.pageStack), fi = () => kt(un, (e) => e.state), Dn = () => kt(un, (e) => e.telemetry), hi = () => kt(un, (e) => e.csatModal), pi = () => kt(un, (e) => e.navigationDirection), Gn = E.literal("client"), hg = E.literal("server"), Yn = E.intersection([
  E.type({
    actionId: E.string
  }),
  E.partial({
    actionPayload: rn(E.UnknownRecord)
  })
]), pg = E.intersection([
  Yn,
  E.type({
    actionId: E.literal("exit__directive"),
    type: Gn
  })
]), mg = E.intersection([
  Yn,
  E.type({
    actionId: E.literal("go_back__directive"),
    type: Gn
  })
]), gg = E.intersection([
  Yn,
  E.type({
    actionId: E.literal("go_to_chat__directive"),
    type: Gn
  }),
  E.partial({
    actionPayload: E.type({
      initialMessage: E.string,
      orderId: E.string
    })
  })
]), bg = E.intersection([
  Yn,
  E.type({
    actionId: E.literal("go_to_csat_screen__directive"),
    type: Gn
  })
]), vg = E.intersection([
  Yn,
  E.type({
    actionId: E.literal("my-conversations"),
    type: Gn
  })
]), yg = E.union([
  pg,
  mg,
  gg,
  bg,
  vg
]), _g = E.type({
  actionId: E.string,
  type: hg
}), mi = E.union([yg, _g]), Eg = E.type({
  id: E.string
}), Ue = E.intersection([
  Eg,
  E.partial({
    action: mi,
    defaultValue: rn(E.any),
    inputKey: E.string
  })
]), Sg = E.literal("button"), Tg = E.intersection([
  E.type({
    props: E.type({
      content: E.string,
      variant: E.keyof({
        primary: null,
        secondary: null
      })
    }),
    type: Sg
  }),
  Ue
]), wg = E.literal("chat_with_support_button"), Cg = E.intersection([
  E.type({
    props: E.type({
      content: E.string
    }),
    type: wg
  }),
  Ue
]), Ig = E.literal("back_button"), Rg = E.intersection([
  E.type({
    props: E.type({
      content: E.string
    }),
    type: Ig
  }),
  Ue
]), gi = E.type({
  country: E.string,
  currency: E.string,
  date: E.string,
  formattedDate: E.string,
  formattedPrice: E.string,
  id: E.string,
  image: rn(
    E.type({
      blurhash: rn(E.string),
      url: E.string
    })
  ),
  price: E.number,
  venueName: E.string
}), kg = E.literal("order_selection_input"), Ag = E.intersection([
  E.type({
    action: mi,
    inputKey: E.string,
    props: E.type({
      sections: E.array(
        E.type({
          orders: E.array(gi),
          title: E.string
        })
      )
    }),
    type: kg
  }),
  Ue
]), Lg = E.literal("order_items_selection_input"), Og = E.intersection([
  E.type({
    inputKey: E.string,
    props: E.type({
      comment: E.type({
        placeholder: E.string
      }),
      order: E.type({
        ...Hu(gi.props, "image")
      }),
      orderItems: E.array(
        E.type({
          id: E.string,
          maxCount: E.number,
          name: E.string,
          price: E.number
        })
      )
    }),
    type: Lg
  }),
  Ue
]), Mg = E.literal("order_info_card"), Pg = E.intersection([
  E.type({
    props: E.type({
      order: gi
    }),
    type: Mg
  }),
  Ue
]), Ng = E.literal("notification_banner"), xg = E.intersection([
  E.type({
    props: E.type({
      message: E.string,
      title: E.string,
      variant: E.keyof({
        error: null,
        info: null,
        success: null,
        warning: null
      })
    }),
    type: Ng
  }),
  Ue
]), Bg = E.literal("embedded_image"), Hg = E.intersection([
  E.type({
    props: E.type({
      assetId: E.string
    }),
    type: Bg
  }),
  Ue
]), Dg = E.literal("embedded_animation"), $g = E.intersection([
  E.type({
    props: E.type({
      assetId: E.string
    }),
    type: Dg
  }),
  Ue
]), Fg = E.literal("image"), Ug = E.intersection([
  E.type({
    props: E.type({
      altText: E.string,
      url: E.string
    }),
    type: Fg
  }),
  Ue
]), zg = E.literal("text_block"), Wg = E.intersection([
  E.type({
    props: E.type({
      content: E.string
    }),
    type: zg
  }),
  Ue
]), jg = E.literal("heading"), qg = E.intersection([
  E.type({
    props: E.type({
      content: E.string,
      eyebrowText: rn(E.string)
    }),
    type: jg
  }),
  Ue
]), Vg = E.literal("csat_button"), Gg = E.intersection([
  E.type({
    props: E.type({
      content: E.string
    }),
    type: Vg
  }),
  Ue
]), Yg = E.literal("options_list_item"), Yl = E.intersection([
  E.type({
    props: E.type({
      content: E.string
    }),
    slug: E.string,
    type: Yg
  }),
  Ue
]), Xg = E.literal("options_list"), Kg = E.intersection([
  E.type({
    children: E.array(Yl),
    type: Xg
  }),
  Ue
]), Zg = E.union([
  Tg,
  Cg,
  Rg,
  Ag,
  Og,
  Pg,
  xg,
  Hg,
  $g,
  Ug,
  qg,
  Wg,
  Gg,
  Kg,
  Yl
]), Qg = E.type({
  directive: rn(mi),
  isLeafNode: E.boolean,
  main: E.array(Zg),
  slug: E.string
}), Jg = E.string, eb = E.string, tb = E.type({
  contextToken: Jg,
  metadata: E.UnknownRecord,
  pageId: E.string,
  slSessionId: eb,
  supportFlow: rn(E.string),
  uiData: Qg
}), nb = E.null, rb = ({
  contextToken: e,
  score: t,
  supportLayerSessionId: n
}) => {
  const r = Gl + "/csat";
  return Ga(
    nb,
    Er.post(
      r,
      {
        score: t,
        supportLayerSessionId: n
      },
      {
        headers: {
          "x-support-layer-context-token": e
        }
      }
    )
  ).then((a) => a.data);
}, ab = () => qu(rb), ib = ({
  contextToken: e,
  onRatingSelect: t,
  slSessionId: n
}) => {
  const { mutate: r } = ab(), { hasBeenShownBefore: a, hideCsatModal: i, isOpen: o, resetHasBeenShownBefore: s, showCsatModal: l } = gb(), { files: u, isLoaded: c } = Wd(), { formatMessage: d } = Bt(), f = ({ rating: v }) => {
    !ot(e) || !ot(n) || r({
      contextToken: e,
      score: v,
      supportLayerSessionId: n
    });
  };
  return {
    csatModalProps: {
      csatRatingInputProps: {
        labels: {
          disgusted: d({ id: "csat-modal.labels.disgusted" }),
          excited: d({ id: "csat-modal.labels.excited" }),
          happy: d({ id: "csat-modal.labels.happy" }),
          meh: d({ id: "csat-modal.labels.meh" }),
          sad: d({ id: "csat-modal.labels.sad" })
        },
        lottieFiles: u,
        onSelect: f
      },
      isOpen: o,
      labels: {
        index: {
          body: d({ id: "csat-modal.screens.index.body" }),
          title: d({ id: "csat-modal.screens.index.title" })
        },
        thankYou: {
          body: d({ id: "csat-modal.screens.thank_you.body" }),
          doneButton: d({ id: "csat-modal.screens.thank_you.done-button" }),
          title: d({ id: "csat-modal.screens.thank_you.title" })
        }
      },
      onClose: i,
      onRatingSelect: t
    },
    hasBeenShownBefore: a,
    isReady: c,
    resetHasBeenShownBefore: s,
    showCsatModal: l
  };
}, ob = () => {
  const [e, t] = Ae(null);
  return {
    direction: e,
    setDirection: (r) => {
      t(() => r);
    }
  };
}, Jo = [], sb = () => {
  const [e, t] = Ae(Jo);
  return {
    clear: () => {
      const [u] = e;
      u && t(() => [u]);
    },
    clearAll: () => {
      t(() => Jo);
    },
    first: () => e.at(0),
    peek: () => e.at(-1),
    pop: () => {
      t((u) => [...u].slice(0, -1));
    },
    push: (u) => {
      t((c) => [...c, u]);
    },
    size: () => e.length
  };
}, lb = () => {
  const e = ae(null), t = () => e.current, n = (a) => {
    e.current = a;
  };
  return {
    clearSession: () => {
      n(null);
    },
    getSessionId: t,
    setSessionId: n
  };
}, es = {}, ub = () => {
  const [e, t] = Ae(es);
  return {
    clearState: () => {
      t(() => es);
    },
    getState: (i, o) => {
      var s;
      return (s = e == null ? void 0 : e[i]) == null ? void 0 : s[o];
    },
    setState: (i, o, s) => {
      t((l) => {
        const u = l == null ? void 0 : l[i];
        return {
          ...l,
          [i]: {
            ...u,
            [o]: s
          }
        };
      });
    }
  };
}, cb = {
  leafNode: null,
  nodeDepth: 0,
  nodeId: null,
  nodeSlug: null,
  nodeStepCount: 0,
  supportLayerSessionId: null
}, db = () => {
  const e = ae(cb), t = ae(null), n = ag(), r = (y) => {
    t.current = e.current, e.current = {
      ...e.current,
      ...y
    };
  }, a = () => e.current, i = () => t.current, o = () => {
    const { leafNode: y, nodeDepth: w, nodeId: p, nodeSlug: B, nodeStepCount: b, supportLayerSessionId: S } = e.current;
    if (!(!xi(w) || !xi(b) || !ot(p) || !ot(B) || Du(y) || !ot(S)))
      return {
        leafNode: y,
        nodeDepth: w,
        nodeId: p,
        nodeSlug: B,
        nodeStepCount: b,
        supportLayerSessionId: S
      };
  }, s = () => {
    var w;
    const y = ((w = e.current) == null ? void 0 : w.nodeStepCount) ?? 0;
    r({
      nodeStepCount: y + 1
    });
  }, l = (y) => {
    r(y), s();
  }, u = (y) => (w) => {
    const p = o();
    Ut(p) || n == null || n({
      payload: { ...p, ...w },
      type: y
    });
  };
  return {
    getPopulatedProperties: o,
    getPreviousProperties: i,
    getProperties: a,
    increaseNodeStepCount: s,
    registerView: l,
    sendImpressionContactSupportEvent: (y) => u("support_layer_impression_contact_support")(y),
    sendImpressionSupportLayerOptionEvent: (y) => u("support_layer_impression_support_layer_option")(y),
    sendInteractionCloseEvent: (y) => u("support_layer_interaction_close_support_layer")(y),
    sendInteractionContactSupportEvent: () => u("support_layer_interaction_contact_support")(),
    sendInteractionGoToPreviousNodeEvent: () => u("support_layer_interaction_go_to_previous_node")(),
    sendInteractionRatingEvent: (y) => u("support_layer_interaction_rating")(y),
    sendInteractionSupportLayerOptionEvent: (y) => u("support_layer_interaction_support_layer_option")(y),
    sendMissingItemsAppliedEvent: (y) => u("support_layer_data_missing_items_applied")(y),
    sendViewEvent: (y) => u("support_layer_view")(y)
  };
}, fb = ({ children: e }) => {
  var l;
  const t = sb(), n = ub(), r = lb(), a = r.getSessionId() ?? void 0, i = ob(), o = db(), s = ib({
    contextToken: (l = t.peek()) == null ? void 0 : l.contextToken,
    onRatingSelect: (u) => {
      Ut(a) || o == null || o.sendInteractionRatingEvent({
        nodeDepth: t.size(),
        nodeId: "missing-items-csat-screen",
        nodeSlug: "missing-items-csat-screen",
        supportLayerRating: u
      });
    },
    slSessionId: a
  });
  return /* @__PURE__ */ h(
    un.Provider,
    {
      value: { csatModal: s, navigationDirection: i, pageStack: t, session: r, state: n, telemetry: o },
      children: e
    }
  );
}, hb = ({ isOpen: e }) => {
  const t = Fn(e), n = Dn(), r = Nr(), a = ae(null), { formatMessage: i } = Bt();
  return de(() => {
    e && !t && (a.current = Date.now());
  }, [e, t]), () => {
    const o = a.current, s = n == null ? void 0 : n.getPopulatedProperties(), l = r == null ? void 0 : r.getSessionId();
    !o || !s || !l || n == null || n.sendViewEvent({
      ...s,
      body: i({ id: "csat-modal.screens.index.body" }),
      duration: Date.now() - o,
      leafNode: !0,
      nodeDepth: s.nodeDepth + 1,
      nodeId: "missing-items-csat-screen",
      nodeSlug: "missing-items-csat-screen",
      renderedAt: o,
      supportLayerOptionCount: 0,
      supportLayerSessionId: l,
      title: i({ id: "csat-modal.screens.index.title" })
    });
  };
}, pb = {
  desktop: {
    maxWidth: "500px",
    type: "centered",
    width: "100%"
  },
  mobile: { type: "bottomSheet" }
}, mb = (e) => {
  const { isOpen: t = !1, onClose: n } = e, r = hb({
    isOpen: t
  });
  return ml(t ? r : Ss), /* @__PURE__ */ h(
    nc,
    {
      open: t,
      onUnmount: r,
      onDismiss: n,
      sizeConfig: pb,
      children: /* @__PURE__ */ h(rg, { ...e, autoResize: !0 })
    }
  );
}, gb = () => {
  const [e, t] = Ae(!1), n = Fn(e), r = ae(!1);
  return de(() => {
    !r.current && e && !n && (r.current = !0);
  }, [e, n]), {
    hasBeenShownBefore: () => r.current,
    hideCsatModal: () => t(!1),
    isOpen: e,
    resetHasBeenShownBefore: () => {
      r.current = !1;
    },
    showCsatModal: () => t(!0)
  };
}, Sr = (e) => (t) => [`support-layer-${e}`, t ?? "en"], bb = () => {
  const { locale: e } = Bt(), t = Ts(), n = Sr("start")(e), r = Sr("next")(e);
  return () => {
    t.resetQueries(n), t.resetQueries(r);
  };
}, Xl = () => {
  const e = fi(), t = xr(), n = Nr(), r = bb();
  return () => {
    e == null || e.clearState(), t == null || t.clearAll(), n == null || n.clearSession(), r();
  };
}, vb = (e) => {
  var a;
  const t = Xl(), n = Bi(e) && ((a = e.response) == null ? void 0 : a.status) === 418;
  if (Bi(e) && !n)
    throw e;
  de(() => {
    n && t();
  }, [n, t]);
}, yb = () => {
  const e = xr(), t = fi(), n = hi(), r = pi(), a = Dn(), i = Vl();
  return {
    handleClientAction: ({
      action: { actionId: s, actionPayload: l },
      metadata: u
    }) => {
      var d;
      const c = ((d = a == null ? void 0 : a.getProperties()) == null ? void 0 : d.nodeStepCount) ?? 1;
      if (s === "my-conversations") {
        i == null || i();
        return;
      }
      if (s === "go_to_chat__directive") {
        a == null || a.sendInteractionContactSupportEvent(), i == null || i(l == null ? void 0 : l.initialMessage, u);
        return;
      }
      if (s === "go_back__directive") {
        a == null || a.sendInteractionGoToPreviousNodeEvent(), a == null || a.increaseNodeStepCount(), r == null || r.setDirection("backwards"), e == null || e.pop();
        return;
      }
      if (s === "exit__directive") {
        a == null || a.sendInteractionCloseEvent({
          nodeStepCount: n != null && n.hasBeenShownBefore() ? c - 1 : c
        }), a == null || a.increaseNodeStepCount(), t == null || t.clearState(), e == null || e.clear(), r == null || r.setDirection("backwards"), window.scrollTo({ behavior: "smooth", left: 0, top: 0 });
        return;
      }
      s === "go_to_csat_screen__directive" && (n == null || n.showCsatModal());
    }
  };
}, Kl = (e) => (t) => {
  const n = t == null ? void 0 : t.payload, r = Ut(n) ? {} : n, a = Ua(n) && $u(n, "inputs") ? n.inputs : {}, i = dg + `/${e}`;
  return Ga(
    tb,
    Er.post(i, {
      ...r,
      inputs: a
    })
  ).then((o) => o.data);
}, _b = Kl("next"), Zl = {
  cacheTime: 0,
  keepPreviousData: !1,
  refetchOnMount: !1,
  refetchOnWindowFocus: !1
}, Ql = Sr("next"), Eb = (e) => {
  const { locale: t } = Bt(), n = Ql(t), { data: r, error: a, isLoading: i } = za(n, Ss, {
    ...Zl,
    enabled: !1,
    onSuccess: e
  });
  return { data: r, error: a, isReady: !i };
}, Sb = () => {
  const { locale: e } = Bt(), t = Ts(), n = Ql(e), r = pi();
  return {
    handleServerAction: ne(
      ({ action: i, contextToken: o, inputs: s = {} }) => {
        r == null || r.setDirection("forwards"), t.resetQueries(n), t.prefetchQuery({
          queryFn: () => _b({
            payload: {
              action: i.actionId,
              contextToken: o,
              inputs: s
            }
          }),
          queryKey: n
        });
      },
      [r, t, n]
    )
  };
}, Tb = () => {
  const { handleClientAction: e } = yb(), { handleServerAction: t } = Sb();
  return ({ contextToken: r, metadata: a }) => ({ action: i, inputs: o = {} }) => {
    if (i.type === "client") {
      e({
        action: i,
        metadata: a
      });
      return;
    }
    if (i.type === "server") {
      t({
        action: i,
        contextToken: r,
        inputs: o
      });
      return;
    }
  };
}, wb = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "cb_InputCheckbox_Root_r1hm",
  propsAsIs: !1
}), Cb = /* @__PURE__ */ M("div")({
  name: "Box",
  class: "cb_InputCheckbox_Box_b1xt",
  propsAsIs: !1
}), Ib = /* @__PURE__ */ M("input")({
  name: "HiddenInput",
  class: "cb_InputCheckbox_HiddenInput_hase",
  propsAsIs: !1
}), Rb = () => /* @__PURE__ */ h("svg", {
  viewBox: "0 0 24 24",
  children: /* @__PURE__ */ h("path", {
    d: "M18.741 6.243a1.25 1.25 0 0 0-1.748.265l-6.228 8.453-3.985-3.188a1.25 1.25 0 1 0-1.56 1.952l5 4c.221.177.497.272.78.269.396.001.769-.184 1.006-.5l7-9.5a1.249 1.249 0 0 0-.265-1.751Z"
  })
}), Jl = q.forwardRef(({
  className: e,
  style: t,
  styleParams: n,
  ...r
}, a) => {
  const {
    visuallyHiddenProps: i
  } = hl();
  return /* @__PURE__ */ V(wb, {
    className: e,
    style: n ? {
      ...t,
      ...ja({
        size: null,
        borderWidth: null,
        borderRadius: null
      }, n)
    } : t,
    children: [/* @__PURE__ */ h(Ib, {
      ...r,
      ...i,
      ref: a,
      type: "checkbox"
    }), /* @__PURE__ */ h(Cb, {
      "aria-hidden": !0,
      children: /* @__PURE__ */ h(Rb, {})
    })]
  });
});
Jl.displayName = "InputCheckbox";
const kb = /* @__PURE__ */ M("div")({
  name: "LabelText",
  class: "cb_Checkbox_LabelText_l1bk",
  propsAsIs: !1
}), Ab = /* @__PURE__ */ M("label")({
  name: "Root",
  class: "cb_Checkbox_Root_riqi",
  propsAsIs: !1
}), eu = mt.forwardRef(({
  className: e,
  disabled: t,
  inputClassName: n,
  label: r,
  rootRef: a,
  style: i,
  ...o
}, s) => /* @__PURE__ */ V(Ab, {
  "aria-disabled": t ? !0 : void 0,
  className: e,
  ref: a,
  style: i,
  children: [/* @__PURE__ */ h(Jl, {
    ...o,
    className: n,
    disabled: t,
    ref: s
  }), _s(r) ? r : /* @__PURE__ */ h(kb, {
    children: r
  })]
}));
eu.displayName = "Checkbox";
const Lb = "cubic-bezier(0.1, 0.8, 0.2, 1)";
function Ob({
  from: e = { transform: "scale(0)" },
  initialRender: t,
  options: n = { duration: 300, fill: "forwards", easing: Lb },
  ref: r,
  show: a,
  to: i = { transform: "scale(1)" }
}) {
  const [o, s] = Ae(!a), l = (u) => {
    var c;
    u && a && t && ((c = u.animate) == null || c.call(u, [e, i], n)), r.current = u;
  };
  return de(() => {
    var u, c;
    const d = r.current;
    if (!(typeof (d == null ? void 0 : d.animate) == "function")) {
      s(!a);
      return;
    }
    if (a)
      s(!1), (u = d == null ? void 0 : d.animate) == null || u.call(d, [e, i], n);
    else {
      if (!d)
        return;
      const g = (c = d.animate) == null ? void 0 : c.call(d, [i, e], n);
      g && (g.onfinish = () => {
        s(!0);
      });
    }
  }, [a, r]), [!o, l];
}
const Mb = (e) => /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", ...e, fill: Ee.strawberry100, children: /* @__PURE__ */ h("path", { d: "M11.984.003a12.205 12.205 0 00-8.51 3.652A11.8 11.8 0 00.002 12.21 11.778 11.778 0 0011.8 24h.214c6.677-.069 12.039-5.53 11.985-12.208A11.765 11.765 0 0011.984.003zM10.5 16.543a1.476 1.476 0 011.449-1.53h.027c.82.002 1.492.65 1.522 1.47a1.475 1.475 0 01-1.448 1.53h-.027a1.529 1.529 0 01-1.523-1.47zm.5-4.041v-6a1 1 0 112 0v6a1 1 0 01-2 0z" }) }), Pb = (e) => /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", ...e, fill: e.fill || Ee.lime100, children: /* @__PURE__ */ h("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c-.006 5.52-4.48 9.994-10 10zm6.48-15.551a1.25 1.25 0 00-1.747.265l-5.924 8.04-3.767-3.014a1.251 1.251 0 00-1.563 1.953l4.783 3.826a1.263 1.263 0 001.787-.235l6.7-9.087a1.25 1.25 0 00-.269-1.748z" }) }), Nb = {
  error: Mb,
  success: Pb
}, xb = () => ({
  hasIcon: e
}) => e ? z(50) : z(14), Bb = () => ({
  hasStatusIcon: e
}) => e ? z(50) : z(14), Hb = /* @__PURE__ */ M("input")({
  name: "InputComponent",
  class: "cb_Input_InputComponent_i1vu",
  propsAsIs: !1,
  vars: {
    "i1vu2dkt-0": [xb()],
    "i1vu2dkt-1": [Bb()]
  }
}), Db = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "cb_Input_Root_r145",
  propsAsIs: !1
}), $b = /* @__PURE__ */ M("div")({
  name: "IconWrapper",
  class: "cb_Input_IconWrapper_i1e5",
  propsAsIs: !1
});
function Fb(e) {
  const t = ae(), n = t.current;
  return t.current = e, n;
}
const Ub = /* @__PURE__ */ M("div")({
  name: "StatusIconWrapper",
  class: "cb_Input_StatusIconWrapper_s1es",
  propsAsIs: !1
}), zb = () => ({
  hasIcon: e
}) => e ? z(52) : z(16), Wb = /* @__PURE__ */ M("label")({
  name: "Label",
  class: "cb_Input_Label_l100",
  propsAsIs: !1,
  vars: {
    "l100we12-0": [zb()]
  }
}), jb = Qe(({
  autoComplete: e = "off",
  className: t,
  icon: n,
  id: r,
  invalid: a,
  label: i,
  nativeInvalid: o,
  rootRef: s,
  spellCheck: l = !1,
  statusIcon: u,
  style: c,
  ...d
}, f) => {
  const g = Ar(), v = r ?? g, C = u && Nb[u], A = Fb(C), k = C || A, R = ae(null), [y, w] = Ob({
    show: !!C,
    initialRender: !A || !R.current,
    ref: R
  });
  return /* @__PURE__ */ V(Db, {
    className: t,
    ref: s,
    style: c,
    children: [/* @__PURE__ */ h(Hb, {
      ...d,
      "aria-invalid": a || void 0,
      autoComplete: e,
      "data-native-invalid": o || void 0,
      hasIcon: !!n,
      hasStatusIcon: !!u,
      id: v,
      placeholder: " ",
      ref: f,
      spellCheck: l
    }), /* @__PURE__ */ h(Wb, {
      hasIcon: !!n,
      htmlFor: v,
      children: i
    }), n && /* @__PURE__ */ h($b, {
      children: /* @__PURE__ */ h(n, {
        "aria-hidden": !0
      })
    }), y && k && /* @__PURE__ */ h(Ub, {
      "aria-hidden": !0,
      ref: w,
      children: ys(k)
    })]
  });
});
jb.displayName = "Input";
const qb = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "cb_InputRadio_Root_r463",
  propsAsIs: !1
}), Vb = /* @__PURE__ */ M("div")({
  name: "VisibleInner",
  class: "cb_InputRadio_VisibleInner_v16w",
  propsAsIs: !1
}), Gb = /* @__PURE__ */ M("div")({
  name: "VisibleOuter",
  class: "cb_InputRadio_VisibleOuter_v5ha",
  propsAsIs: !1
}), Yb = /* @__PURE__ */ M("input")({
  name: "HiddenRadioButton",
  class: "cb_InputRadio_HiddenRadioButton_h17w",
  propsAsIs: !1
}), tu = Qe(({
  className: e,
  style: t,
  styleParams: n,
  ...r
}, a) => {
  const {
    visuallyHiddenProps: i
  } = hl();
  return /* @__PURE__ */ V(qb, {
    className: e,
    style: n ? {
      ...t,
      ...ja({
        size: null,
        borderWidth: null
      }, n)
    } : t,
    children: [/* @__PURE__ */ h(Yb, {
      ...i,
      ...r,
      ref: a,
      type: "radio"
    }), /* @__PURE__ */ h(Vb, {
      "aria-hidden": !0
    }), /* @__PURE__ */ h(Gb, {
      "aria-hidden": !0
    })]
  });
});
tu.displayName = "InputRadio";
const Xb = /* @__PURE__ */ M("label")({
  name: "Root",
  class: "cb_Radio_Root_raev",
  propsAsIs: !1
}), Kb = /* @__PURE__ */ M("div")({
  name: "LabelText",
  class: "cb_Radio_LabelText_l209",
  propsAsIs: !1
}), Zb = Qe(({
  className: e,
  disabled: t,
  inputClassName: n,
  label: r,
  rootRef: a,
  style: i,
  ...o
}, s) => /* @__PURE__ */ V(Xb, {
  "aria-disabled": t ? !0 : void 0,
  className: e,
  ref: a,
  style: i,
  children: [/* @__PURE__ */ h(tu, {
    ...o,
    className: n,
    disabled: t,
    ref: s
  }), _s(r) ? r : /* @__PURE__ */ h(Kb, {
    children: r
  })]
}));
Zb.displayName = "Radio";
const Qb = /* @__PURE__ */ M("textarea")({
  name: "ActualTextarea",
  class: "cb_Textarea_ActualTextarea_ae72",
  propsAsIs: !1
}), Jb = /* @__PURE__ */ M("div")({
  name: "GrowContainer",
  class: "cb_Textarea_GrowContainer_g7n9",
  propsAsIs: !1
}), e1 = /* @__PURE__ */ M("label")({
  name: "Label",
  class: "cb_Textarea_Label_l163",
  propsAsIs: !1
}), t1 = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "cb_Textarea_Root_r1wq",
  propsAsIs: !1
}), nu = Qe(({
  autoComplete: e = "off",
  className: t,
  id: n,
  invalid: r,
  label: a,
  rootRef: i,
  rows: o = 4,
  spellCheck: s = !1,
  style: l,
  ...u
}, c) => {
  const d = Ar(), f = n ?? d, g = ae(null);
  return /* @__PURE__ */ h(t1, {
    className: t,
    ref: i,
    style: l,
    children: /* @__PURE__ */ V(Jb, {
      ref: g,
      children: [/* @__PURE__ */ h(Qb, {
        ...u,
        "aria-invalid": r || void 0,
        autoComplete: e,
        id: f,
        onInput: (C) => {
          const A = g.current;
          A && (A.dataset.value = C.currentTarget.value);
        },
        placeholder: " ",
        ref: c,
        rows: o,
        spellCheck: s
      }), /* @__PURE__ */ h(e1, {
        htmlFor: f,
        children: a
      })]
    })
  });
});
nu.displayName = "Textarea";
const n1 = {
  decrementAriaLabel: "Remove one",
  incrementAriaLabel: "Add one more",
  label: "Quantity"
}, ru = "{quantity}", r1 = `You have ${ru} of these selected. Change the quantity.`, a1 = "OrderItemsSelectionInput: no items provided, nothing to render. You may not want to render this component at all.", i1 = "Add comment", o1 = (e, t) => {
  const { items: n, itemsChecked: r } = e;
  if (t.type === "SET_ITEM_HOVERED") {
    const { item: a } = t;
    return { ...e, itemHovered: a };
  }
  if (t.type === "SET_ITEM_QUANTITY") {
    const { id: a, quantity: i } = t, o = n.map((s) => s.id === a ? { ...s, quantity: i } : s);
    return { ...e, items: o };
  }
  if (t.type === "SET_ITEM_CHECKED") {
    const { checked: a } = t, i = a ? [.../* @__PURE__ */ new Set([...r, t.id])] : r.filter((l) => l !== t.id), o = a ? 1 : 0, s = n.map((l) => t.id === l.id ? { ...l, quantity: o } : l);
    return {
      ...e,
      items: s,
      itemsChecked: i
    };
  }
  if (t.type === "SET_COMMENT") {
    const { comment: a } = t;
    return { ...e, comment: a };
  }
  return { ...e };
}, s1 = ({
  comment: e,
  items: t
}) => Nu(o1, {
  comment: e,
  itemHovered: null,
  items: t,
  itemsChecked: []
}), l1 = 100, u1 = ({
  comment: e,
  items: t,
  onChange: n
}) => {
  const [r, a] = s1({
    comment: e,
    items: t
  }), i = xt(() => Fa(n, l1), [n]);
  od((C) => {
    C.key === "Escape" && r.itemHovered && a({ item: null, type: "SET_ITEM_HOVERED" });
  });
  const o = (C) => () => {
    a({ item: C, type: "SET_ITEM_HOVERED" });
  }, s = (C) => (A) => {
    a({ id: C.id, quantity: A, type: "SET_ITEM_QUANTITY" });
    const k = r.items.map((R) => R.id === C.id ? { ...R, quantity: A } : R);
    i({
      comment: r.comment,
      items: k
    });
  }, l = (C) => ({ target: { checked: A } }) => {
    a({ checked: A, id: C, type: "SET_ITEM_CHECKED" });
    const k = r.items.map((R) => C === R.id ? {
      ...R,
      quantity: A ? 1 : 0
    } : R);
    i({
      comment: r.comment,
      items: k
    });
  }, u = (C) => {
    a({ comment: C, type: "SET_COMMENT" }), i({
      comment: C,
      items: r.items
    });
  }, c = (C) => {
    var A;
    return ((A = r.itemHovered) == null ? void 0 : A.id) === C;
  }, d = (C) => {
    const { id: A, quantity: k } = C;
    return [c(A), k > 0];
  }, f = (C) => {
    const [A, k] = d(C);
    return !!(A && k);
  }, g = (C) => {
    const [A, k] = d(C);
    return !!(!A && k);
  }, v = () => {
    const { items: C } = r;
    return C.map((A) => ({
      ...A,
      hasStepperInput: Ut(A.maxQuantity) || A.maxQuantity > 1,
      isChecked: A.quantity > 0,
      isQuantityVisible: g(A),
      isStepperVisible: f(A)
    }));
  };
  return {
    comment: r.comment,
    items: v(),
    makeHandleCheckboxChange: l,
    makeHandleStepperChange: s,
    makeSetItemHovered: o,
    setComment: u
  };
};
var au = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(au);
var c1 = au.exports;
const d1 = /* @__PURE__ */ Rs(c1), f1 = "support-layer__", De = (e) => (t) => {
  const n = `${f1}${e}`;
  return ot(t) ? d1(n, t) : n;
}, h1 = {
  back_button: De("button"),
  button: De("button"),
  chat_with_support_button: De("chat_with_support_button"),
  csat_button: De("csat_button"),
  embedded_animation: De("embedded_animation"),
  embedded_image: De("embedded_image"),
  heading: De("heading"),
  image: De("image"),
  notification_banner: De("notification_banner"),
  options_list: De("options_list"),
  options_list_item: De("options_list_item"),
  order_info_card: De("order_info_card"),
  order_items_selection_input: De("order_items_selection_input"),
  order_selection_input: De("order_selection_input"),
  text_block: De("text_block")
}, ze = (e, t) => h1[e](t), p1 = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-OrderItemsSelectionInput_Root_rpdz2k5",
  propsAsIs: !1
}), m1 = /* @__PURE__ */ M("ul")({
  name: "CheckboxesContainer",
  class: "support-layer-OrderItemsSelectionInput_CheckboxesContainer_c1veimqu",
  propsAsIs: !1
}), g1 = /* @__PURE__ */ M("li")({
  name: "CheckboxContainer",
  class: "support-layer-OrderItemsSelectionInput_CheckboxContainer_cjba9qm",
  propsAsIs: !1
}), b1 = () => eu, v1 = /* @__PURE__ */ M(b1())({
  name: "Checkbox",
  class: "support-layer-OrderItemsSelectionInput_Checkbox_c67ml0x",
  propsAsIs: !0
}), y1 = () => Rl, _1 = /* @__PURE__ */ M(y1())({
  name: "StyledStepperInput",
  class: "support-layer-OrderItemsSelectionInput_StyledStepperInput_slrw6e9",
  propsAsIs: !0
}), E1 = /* @__PURE__ */ M("button")({
  name: "QuantityButton",
  class: "support-layer-OrderItemsSelectionInput_QuantityButton_qf80b4c",
  propsAsIs: !1
}), S1 = ({
  className: e,
  commentDefaultValue: t = "",
  commentInputLabel: n = i1,
  items: r,
  onChange: a,
  quantityButtonAriaLabel: i = r1,
  quantityButtonAriaMarkerLabel: o = ru,
  stepperLabels: s = n1,
  ...l
}) => {
  const {
    comment: u,
    items: c,
    makeHandleCheckboxChange: d,
    makeHandleStepperChange: f,
    makeSetItemHovered: g,
    setComment: v
  } = u1({
    comment: t,
    items: r,
    onChange: a
  }), C = `OrderItemsSelectionInput-Comment-${Ar()}`;
  return c.length ? /* @__PURE__ */ V(p1, {
    ...l,
    className: ze("order_items_selection_input", e),
    children: [/* @__PURE__ */ h(m1, {
      children: c.map((A) => {
        const {
          hasStepperInput: k,
          id: R,
          isChecked: y,
          isQuantityVisible: w,
          isStepperVisible: p,
          label: B,
          maxQuantity: b,
          quantity: S
        } = A, O = g(A), I = g(null);
        return /* @__PURE__ */ V(g1, {
          ...k && {
            onMouseEnter: O,
            onMouseLeave: I,
            onTouchStart: O
          },
          children: [/* @__PURE__ */ h(v1, {
            label: B,
            checked: y,
            onChange: d(R)
          }), /* @__PURE__ */ h(It, {
            children: /* @__PURE__ */ V(Be.div, {
              layout: !0,
              transition: {
                duration: 0.1,
                ease: "linear"
              },
              children: [p && /* @__PURE__ */ h(_1, {
                min: 1,
                max: b,
                value: S,
                onChange: f(A),
                size: "medium",
                ...s
              }), w && /* @__PURE__ */ h(E1, {
                type: "button",
                onClick: O,
                "aria-label": i.replace(o, S.toString()),
                disabled: b === 1,
                children: S
              })]
            })
          })]
        }, R);
      })
    }), /* @__PURE__ */ h(nu, {
      id: C,
      label: n,
      value: u,
      rows: 1,
      onChange: (A) => v(A.target.value)
    })]
  }) : (console.warn(a1), null);
};
`${sn.CDN_URL}`;
const T1 = /* @__PURE__ */ M("ul")({
  name: "Root",
  class: "support-layer-OptionsList_Root_r192rdpf",
  propsAsIs: !1
}), iu = ({
  className: e,
  items: t,
  renderItem: n,
  ...r
}) => /* @__PURE__ */ h(T1, {
  ...r,
  className: ze("options_list", e),
  children: t.map(n)
}), w1 = () => Il, C1 = /* @__PURE__ */ M(w1())({
  name: "StyledImageWithBlurHashTransition",
  class: "support-layer-OrderInfoCardImage_StyledImageWithBlurHashTransition_s106xzgs",
  propsAsIs: !0
}), I1 = /* @__PURE__ */ M("img")({
  name: "Image",
  class: "support-layer-OrderInfoCardImage_Image_i1rvkox0",
  propsAsIs: !1
}), ts = /* @__PURE__ */ M("div")({
  name: "ImageContainer",
  class: "support-layer-OrderInfoCardImage_ImageContainer_i1corqx4",
  propsAsIs: !1
}), R1 = `${sn.CDN_URL}/placeholder-images/product-placeholder-2.png`, k1 = ({
  image: {
    blurhash: e,
    url: t
  } = {},
  title: n = ""
}) => ot(t) && ot(e) ? /* @__PURE__ */ h(ts, {
  children: /* @__PURE__ */ h(C1, {
    alt: n,
    blurhash: e,
    imageUrl: t
  })
}) : /* @__PURE__ */ h(ts, {
  children: /* @__PURE__ */ h(I1, {
    src: t ?? R1,
    alt: n
  })
}), A1 = /* @__PURE__ */ M("article")({
  name: "Root",
  class: "support-layer-OrderInfoCard_Root_r5rok27",
  propsAsIs: !1
}), L1 = /* @__PURE__ */ M("div")({
  name: "Details",
  class: "support-layer-OrderInfoCard_Details_d12pzpth",
  propsAsIs: !1
}), O1 = /* @__PURE__ */ M("h3")({
  name: "Title",
  class: "support-layer-OrderInfoCard_Title_t1lbrddl",
  propsAsIs: !1
}), M1 = /* @__PURE__ */ M("p")({
  name: "Date",
  class: "support-layer-OrderInfoCard_Date_dvdnozr",
  propsAsIs: !1
}), P1 = /* @__PURE__ */ M("p")({
  name: "Price",
  class: "support-layer-OrderInfoCard_Price_picdk9f",
  propsAsIs: !1
}), ou = ({
  className: e,
  date: t,
  id: n,
  image: r,
  price: a,
  title: i,
  ...o
}) => {
  const s = `order-info-card-title-${n}`, l = `order-info-card-details-${n}`;
  return /* @__PURE__ */ V(A1, {
    ...o,
    "aria-labelledby": s,
    "aria-describedby": l,
    className: ze("order_info_card", e),
    children: [/* @__PURE__ */ h(k1, {
      image: r,
      title: i
    }), /* @__PURE__ */ V(L1, {
      id: l,
      children: [/* @__PURE__ */ h(O1, {
        id: s,
        children: i
      }), /* @__PURE__ */ h(M1, {
        children: t
      }), /* @__PURE__ */ h(P1, {
        children: a
      })]
    })]
  });
}, N1 = /* @__PURE__ */ M("li")({
  name: "Root",
  class: "support-layer-OptionsListItem_Root_rfmmp76",
  propsAsIs: !1
}), x1 = () => Un, B1 = /* @__PURE__ */ M(x1())({
  name: "Button",
  class: "support-layer-OptionsListItem_Button_bbarv3c",
  propsAsIs: !0
}), H1 = () => Qu, D1 = /* @__PURE__ */ M(H1())({
  name: "Caret",
  class: "support-layer-OptionsListItem_Caret_c1ratfte",
  propsAsIs: !0
}), Br = Qe((e, t) => {
  const {
    caretPosition: n,
    className: r,
    isList: a = !0,
    label: i,
    ...o
  } = e, s = ze("options_list_item", r), l = /* @__PURE__ */ h(B1, {
    ...o,
    variant: "neutral",
    icon: D1,
    iconPosition: "end",
    size: "medium",
    style: {
      // @ts-expect-error fix this
      "--caret-position": n === "center" ? "auto" : "0"
    },
    className: s,
    children: i
  });
  return a ? /* @__PURE__ */ h(N1, {
    ref: t,
    className: s,
    children: l
  }) : l;
});
Br.displayName = "OptionsListItem";
const $1 = /* @__PURE__ */ M("div")({
  name: "Section",
  class: "support-layer-OrderSelectionInput_Section_s13backv",
  propsAsIs: !1
}), F1 = /* @__PURE__ */ M("h3")({
  name: "SectionTitle",
  class: "support-layer-OrderSelectionInput_SectionTitle_s1n6yu8b",
  propsAsIs: !1
}), U1 = () => iu, z1 = /* @__PURE__ */ M(U1())({
  name: "OptionsList",
  class: "support-layer-OrderSelectionInput_OptionsList_o1lw69jv",
  propsAsIs: !0
}), W1 = ({
  onOrderSelect: e,
  sections: t
}) => /* @__PURE__ */ h("div", {
  className: ze("order_selection_input"),
  children: t.map(({
    orders: n,
    title: r
  }) => /* @__PURE__ */ V($1, {
    children: [/* @__PURE__ */ h(F1, {
      children: r
    }), /* @__PURE__ */ h(z1, {
      items: n,
      renderItem: (a) => {
        const {
          id: i,
          venueName: o,
          ...s
        } = a;
        return /* @__PURE__ */ h(Br, {
          id: i,
          label: /* @__PURE__ */ h(ou, {
            id: i,
            title: o,
            ...s
          }),
          onClick: () => e(i),
          caretPosition: "center"
        }, i);
      }
    })]
  }, r))
}), j1 = () => Un, q1 = /* @__PURE__ */ M(j1())({
  name: "TextButton",
  class: "support-layer-BackButton_TextButton_trsfeix",
  propsAsIs: !0
}), V1 = ({
  className: e,
  content: t,
  ...n
}) => {
  const a = kr() === "rtl" ? Ju : ws;
  return /* @__PURE__ */ h(q1, {
    ...n,
    className: ze("back_button", e),
    variant: "brand",
    type: "button",
    icon: a,
    children: t
  });
}, su = Qe(
  ({ className: e, content: t, variant: n = "primary", ...r }, a) => /* @__PURE__ */ h(
    la,
    {
      ref: a,
      stretch: !0,
      ...r,
      variant: n,
      size: "large",
      className: ze("button", e),
      children: t
    }
  )
);
su.displayName = "Button";
const G1 = {
  bottom: "support-layer-ChatWithSupportButton_bottom_b1tkcejx",
  top: "support-layer-ChatWithSupportButton_top_tthl27z"
}, lu = Qe((e, t) => {
  const {
    borderPosition: n = "top",
    className: r,
    content: a,
    ...i
  } = e;
  return /* @__PURE__ */ h("div", {
    ref: t,
    className: ze("chat_with_support_button", r),
    "data-testid": "SupportLayerChatWithSupportButton",
    children: /* @__PURE__ */ h(Br, {
      ...i,
      className: G1[n],
      id: Ar(),
      isList: !1,
      label: a
    })
  });
});
lu.displayName = "ChatWithSupportButton";
const Y1 = (e) => /* @__PURE__ */ V(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "support-layer-csat-button-smiley1",
    ...e,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
          fill: "#FEA90D"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.04004 9.84008C5.10004 7.86009 6.78004 6.66009 8.52004 7.20009C9.60004 7.56009 10.44 8.94008 10.32 10.0801C10.26 10.5001 9.90004 10.8601 9.48004 10.8601C9.06004 10.9201 8.64004 10.6201 8.46004 10.2001L8.28004 9.48009C8.16004 9.18009 7.98004 8.94008 7.62004 8.94008C7.26004 8.94008 7.08004 9.18008 6.96004 9.54008C6.90004 9.72008 6.90004 9.84009 6.90004 10.0201C6.78004 10.5601 6.36004 10.9201 5.82004 10.8601C5.40004 10.8001 5.04004 10.3801 5.04004 9.84008ZM12.0001 19.1399C9.84006 19.1399 8.04006 17.7599 7.56006 15.6599C7.38006 14.9999 7.68006 14.5799 8.40006 14.5799C9.01314 14.5799 9.62995 14.5762 10.2486 14.5725L10.2488 14.5725C12.1125 14.5612 13.9932 14.5499 15.8401 14.6399C16.5601 14.6399 16.6801 14.8799 16.5601 15.5999C16.1401 17.6999 14.2201 19.1399 12.0001 19.1399ZM17.22 7.26008C15.48 6.60008 13.8 7.80008 13.68 9.78008C13.62 10.3801 13.92 10.8001 14.52 10.9801C15.06 11.0401 15.48 10.6801 15.6 10.0801C15.6275 9.97001 15.6424 9.87256 15.6563 9.78195C15.6726 9.67498 15.6875 9.57753 15.72 9.48008C15.84 9.18008 16.02 9.00008 16.32 9.00008C16.62 9.00008 16.8 9.18008 16.92 9.42008C16.95 9.54008 16.98 9.67508 17.01 9.81008C17.04 9.94508 17.07 10.0801 17.1 10.2001C17.22 10.6201 17.64 10.9201 18.06 10.9201C18.54 10.9201 18.9 10.5601 18.96 10.1401C19.14 9.00008 18.3 7.62008 17.22 7.26008Z",
          fill: "#202125"
        }
      )
    ]
  }
), X1 = (e) => /* @__PURE__ */ V(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "support-layer-csat-button-smiley2",
    ...e,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
          fill: "#FEC864"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M12.0001 18.4799C9.84008 18.3599 8.22008 17.4599 7.20008 15.5399C7.02008 15.1799 7.02008 14.7599 7.26008 14.3999C7.50008 14.0999 7.86008 13.9799 8.22008 14.0999C8.58008 14.1599 8.76008 14.5199 8.94008 14.8199C9.66008 16.0799 10.8001 16.6799 12.2401 16.5599C13.4401 16.4999 14.2801 15.8399 15.0001 14.9399C15.1201 14.7599 15.2401 14.5799 15.3601 14.4599C15.7201 13.9799 16.2001 13.8599 16.6801 14.1599C17.1001 14.4599 17.2801 14.9399 16.9801 15.4199C15.7801 17.3399 14.2201 18.4199 12.0001 18.4799Z",
          fill: "#202125"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M6.12012 8.88002C6.12012 7.80002 6.96012 7.02002 8.04012 7.02002C9.06012 7.02002 9.90012 7.86002 9.90012 8.88002C9.90012 9.90002 9.06012 10.74 8.04012 10.74C6.96012 10.74 6.12012 9.90002 6.12012 8.88002Z",
          fill: "#202125"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M15.96 7.02002C16.98 7.02002 17.82 7.86002 17.82 8.88002C17.82 9.90002 16.98 10.8 15.9 10.8C14.88 10.8 14.04 9.96002 14.04 8.94002C14.1 7.80002 14.94 7.02002 15.96 7.02002Z",
          fill: "#202125"
        }
      )
    ]
  }
), K1 = (e) => /* @__PURE__ */ V(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "support-layer-csat-button-smiley3",
    ...e,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
          fill: "#FFD68B"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.92 9.00002C13.92 10.08 14.82 10.98 15.9 10.98C16.98 11.04 17.88 10.14 17.94 9.06002C17.94 7.92002 17.04 7.02002 15.96 7.02002C14.82 7.02002 13.92 7.92002 13.92 9.00002ZM10.0201 9.05998C10.0201 10.14 9.12006 11.04 8.04006 11.04C6.96006 11.04 6.06006 10.14 6.06006 9.05998C6.06006 7.97998 6.96006 7.07998 8.04006 7.07998C9.12006 7.01998 10.0201 7.91998 10.0201 9.05998ZM12.0601 15.0601H15.4801C16.1401 15.0601 16.5601 15.4201 16.6201 16.0201C16.6201 16.5601 16.2001 16.9801 15.5401 16.9801H8.58008C7.98008 16.9801 7.62008 16.6801 7.50008 16.2001C7.44008 15.7801 7.62008 15.3601 8.04008 15.1801C8.17275 15.0916 8.30541 15.1009 8.4621 15.112H8.46211C8.51801 15.1159 8.57697 15.1201 8.64008 15.1201C9.72008 15.0601 10.8601 15.0601 12.0601 15.0601Z",
          fill: "#202125"
        }
      )
    ]
  }
), Z1 = (e) => /* @__PURE__ */ V(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "support-layer-csat-button-smiley4",
    ...e,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
          fill: "#FFE7BB",
          stroke: "#FFE0A8"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 9.00002C6 7.92002 6.84 7.02002 7.92 7.02002C9 7.02002 9.9 7.92002 9.9 9.00002C9.9 10.08 9 10.98 7.98 10.98C6.9 11.04 6 10.14 6 9.00002ZM15.9 18.36C15.42 18.36 15.18 18.06 15 17.7C14.4 16.74 13.62 16.14 12.48 16.02C11.16 15.9 10.08 16.26 9.24002 17.34C9.18003 17.42 9.1267 17.5 9.07337 17.58L9.07335 17.58C8.96669 17.74 8.86002 17.9 8.70002 18.06C8.34002 18.42 7.86002 18.48 7.44002 18.24C7.02002 17.94 6.90002 17.46 7.14002 16.98C8.16002 15.18 9.66002 14.1 11.82 14.04C13.98 14.04 15.6 15.06 16.68 16.92C17.1 17.64 16.68 18.42 15.9 18.36ZM15.96 7.02002C14.88 7.02002 13.98 7.92002 13.98 9.00002C13.98 10.14 14.88 10.98 15.96 10.98C17.04 10.98 17.94 10.08 17.94 9.00002C17.94 7.92002 17.04 7.02002 15.96 7.02002Z",
          fill: "#202125"
        }
      )
    ]
  }
), Q1 = (e) => /* @__PURE__ */ V(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "support-layer-csat-button-smiley5",
    ...e,
    children: [
      /* @__PURE__ */ V("g", { clipPath: "url(#clip0_3983_28796)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M0.5 12C0.5 5.64881 5.64858 0.500143 11.9997 0.5C18.3483 0.507015 23.4931 5.65191 23.5 12.0005C23.4997 18.3516 18.3511 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z",
            fill: "#FFF5E2",
            stroke: "#FFEAC5"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0001 14.0001C14.0504 14.0399 15.9166 15.1925 16.8701 17.0081C17.1205 17.4862 16.9463 18.0768 16.4765 18.3425C16.0067 18.6082 15.4108 18.4531 15.1301 17.9921C14.5262 16.8087 13.3279 16.0461 12.0001 16.0001C10.6723 16.0461 9.474 16.8087 8.87011 17.9921C8.70078 18.3154 8.36879 18.5208 8.00391 18.5279C7.63904 18.5351 7.29923 18.3429 7.11733 18.0266C6.93543 17.7102 6.94033 17.3198 7.13011 17.0081C8.08361 15.1925 9.94977 14.0399 12.0001 14.0001ZM16.2931 6.79311C16.5442 6.53315 16.916 6.42889 17.2656 6.52041C17.6152 6.61192 17.8883 6.88497 17.9798 7.2346C18.0713 7.58423 17.9671 7.95603 17.7071 8.20711L16.4751 9.43911C16.4077 9.50596 16.384 9.60521 16.4139 9.6953C16.4438 9.78539 16.5221 9.85079 16.6161 9.86411L17.6421 10.0101C18.1889 10.0915 18.5685 10.5983 18.4901 11.1451C18.4117 11.6919 17.9049 12.0715 17.3581 11.9931L13.8581 11.4931C13.482 11.4401 13.1684 11.1787 13.0486 10.8183C12.9288 10.4578 13.0235 10.0607 13.2931 9.79311L16.2931 6.79311ZM6.7346 6.52041C7.08423 6.42889 7.45603 6.53315 7.70711 6.79311L10.7071 9.79311C10.9717 10.058 11.0661 10.4486 10.9517 10.8052C10.8374 11.1617 10.5334 11.4245 10.1641 11.4861L7.16511 11.9861C7.11063 11.9957 7.05541 12.0004 7.00011 12.0001C6.47922 11.9997 6.04586 11.5996 6.00405 11.0804C5.96224 10.5612 6.32599 10.0968 6.84011 10.0131L7.44011 9.91311C7.53265 9.89808 7.6089 9.83235 7.63741 9.74303C7.66591 9.65372 7.64183 9.55596 7.57511 9.49011L6.29311 8.20711C6.03315 7.95603 5.92889 7.58423 6.02041 7.2346C6.11192 6.88497 6.38497 6.61192 6.7346 6.52041Z",
            fill: "#202125"
          }
        )
      ] }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_3983_28796", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
), J1 = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-Smileys_Root_ryuef9h",
  propsAsIs: !1
}), ev = () => /* @__PURE__ */ V(J1, {
  "aria-hidden": !0,
  children: [/* @__PURE__ */ h(Y1, {}), /* @__PURE__ */ h(X1, {}), /* @__PURE__ */ h(K1, {}), /* @__PURE__ */ h(Z1, {}), /* @__PURE__ */ h(Q1, {})]
}), tv = "cubic-bezier(0.1, 0.8, 0.2, 1)", Ba = [1, 2, 3, 4, 5], ns = 16, rs = 4, nv = 300, rv = 50, uu = (e) => vn`
    transform: translateX(${z(-e)});

    [dir='rtl'] & {
      transform: translateX(${z(e)});
    }
  `;
Ba.filter((e) => e > 1).map((e) => vn`
      .support-layer-csat-button-smiley${e} {
        ${uu(e * ns - ns)}
      }
    `).join(`
`);
Ba.map((e, t) => {
  const n = [];
  if (n.push(vn`
    z-index: ${Ba.length - e + 1};
  `), e > 1) {
    const r = nv + t * rv;
    n.push(vn`
      transition: transform ${r}ms ${tv};
      ${uu(e * rs - rs)}
    `);
  }
  return vn`
    .support-layer-csat-button-smiley${e} {
      ${n.join(`
`)}
    }
  `;
}).join(`
`);
const av = () => Un, iv = /* @__PURE__ */ M(av())({
  name: "TextButton",
  class: "support-layer-CsatButton_TextButton_tod9uex",
  propsAsIs: !0
}), ov = ({
  className: e,
  content: t,
  ...n
}) => /* @__PURE__ */ V(iv, {
  ...n,
  variant: "neutral",
  size: "medium",
  className: ze("csat_button", e),
  children: [/* @__PURE__ */ h("span", {
    children: t
  }), /* @__PURE__ */ h(ev, {})]
}), cu = {
  "animation/high-five-hands": ua.wide.highFiveHands,
  "animation/yuho-big-jump-with-hearts": ua.wide.bigJumpWithHearts
}, sv = (e) => e in cu, lv = "support-layer-EmbeddedAnimation_lottiePlayerStyles_lu88fha", uv = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-EmbeddedAnimation_Root_r1cq6zis",
  propsAsIs: !1
}), cv = ({
  assetId: e
}) => {
  if (!sv(e))
    return null;
  const t = cu[e];
  return /* @__PURE__ */ h(uv, {
    className: ze("embedded_animation"),
    children: /* @__PURE__ */ h(ti, {
      className: lv,
      src: t,
      aspectRatio: "3/2",
      autoplay: !0,
      loop: !0
    })
  });
}, at = (e) => `${sn.CDN_URL}/support-layer/images/${e}`, du = {
  "illustration/bag-items-different-colors": {
    src: at("bag_items_different_colors.png"),
    src2x: at("bag_items_different_colors@2x.png")
  },
  "illustration/flying-hero": {
    src: at("flying_hero.png"),
    src2x: at("flying_hero@2x.png")
  },
  "illustration/girl-gasp": {
    src: at("girl_gasp.png"),
    src2x: at("girl_gasp@2x.png")
  },
  "illustration/high-five-hands": {
    src: at("high_five_hands.png"),
    src2x: at("high_five_hands@2x.png")
  },
  "illustration/tokens-rotating": {
    src: at("tokens_rotating.png"),
    src2x: at("tokens_rotating@2x.png")
  },
  "illustration/yuho-big-jump-with-hearts": {
    src: at("yuho_big_jump_with_hearts.png"),
    src2x: at("yuho_big_jump_with_hearts@2x.png")
  }
}, dv = (e) => e in du, fv = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-EmbeddedImage_Root_r1vvb5lj",
  propsAsIs: !1
}), hv = ({
  assetId: e
}) => {
  if (!dv(e))
    return null;
  const {
    src: t,
    src2x: n
  } = du[e];
  return /* @__PURE__ */ h(fv, {
    className: ze("embedded_image"),
    children: /* @__PURE__ */ h("img", {
      srcSet: `${n} 2x`,
      src: t,
      loading: "lazy",
      alt: ""
    })
  });
}, pv = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-Image_Root_r1eend7c",
  propsAsIs: !1
}), mv = ({
  alt: e,
  url: t
}) => /* @__PURE__ */ h(pv, {
  className: ze("image"),
  children: /* @__PURE__ */ h(ni, {
    src: t,
    alt: e,
    loading: "lazy"
  })
}), gv = /* @__PURE__ */ M("header")({
  name: "Root",
  class: "support-layer-Heading_Root_ri51w59",
  propsAsIs: !1
}), bv = /* @__PURE__ */ M("p")({
  name: "EyebrowText",
  class: "support-layer-Heading_EyebrowText_ei5s7b3",
  propsAsIs: !1
}), vv = /* @__PURE__ */ M("h1")({
  name: "Title",
  class: "support-layer-Heading_Title_t1hb8nzf",
  propsAsIs: !1
}), yv = ({
  className: e,
  content: t,
  eyebrowText: n,
  ...r
}) => {
  const a = !!n;
  return /* @__PURE__ */ V(gv, {
    ...r,
    className: ze("heading", e),
    children: [a && /* @__PURE__ */ h(bv, {
      children: n
    }), /* @__PURE__ */ h(vv, {
      children: t
    })]
  });
}, _v = ({
  className: e,
  message: t,
  ...n
}) => /* @__PURE__ */ h(
  tc,
  {
    ...n,
    className: ze("notification_banner", e),
    onCloseButtonClick: void 0,
    children: t
  }
);
/*! @license DOMPurify 3.0.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.8/LICENSE */
const {
  entries: fu,
  setPrototypeOf: as,
  isFrozen: Ev,
  getPrototypeOf: Sv,
  getOwnPropertyDescriptor: bi
} = Object;
let {
  freeze: Fe,
  seal: gt,
  create: hu
} = Object, {
  apply: Ha,
  construct: Da
} = typeof Reflect < "u" && Reflect;
Fe || (Fe = function(t) {
  return t;
});
gt || (gt = function(t) {
  return t;
});
Ha || (Ha = function(t, n, r) {
  return t.apply(n, r);
});
Da || (Da = function(t, n) {
  return new t(...n);
});
const cr = st(Array.prototype.forEach), is = st(Array.prototype.pop), An = st(Array.prototype.push), gr = st(String.prototype.toLowerCase), ta = st(String.prototype.toString), Tv = st(String.prototype.match), Ln = st(String.prototype.replace), wv = st(String.prototype.indexOf), Cv = st(String.prototype.trim), Ke = st(RegExp.prototype.test), On = Iv(TypeError);
function st(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    return Ha(e, t, r);
  };
}
function Iv(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return Da(e, n);
  };
}
function Z(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gr;
  as && as(e, null);
  let r = t.length;
  for (; r--; ) {
    let a = t[r];
    if (typeof a == "string") {
      const i = n(a);
      i !== a && (Ev(t) || (t[r] = i), a = i);
    }
    e[a] = !0;
  }
  return e;
}
function Rv(e) {
  for (let t = 0; t < e.length; t++)
    bi(e, t) === void 0 && (e[t] = null);
  return e;
}
function Qt(e) {
  const t = hu(null);
  for (const [n, r] of fu(e))
    bi(e, n) !== void 0 && (Array.isArray(r) ? t[n] = Rv(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = Qt(r) : t[n] = r);
  return t;
}
function dr(e, t) {
  for (; e !== null; ) {
    const r = bi(e, t);
    if (r) {
      if (r.get)
        return st(r.get);
      if (typeof r.value == "function")
        return st(r.value);
    }
    e = Sv(e);
  }
  function n(r) {
    return console.warn("fallback value for", r), null;
  }
  return n;
}
const os = Fe(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), na = Fe(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ra = Fe(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), kv = Fe(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), aa = Fe(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Av = Fe(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ss = Fe(["#text"]), ls = Fe(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), ia = Fe(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), us = Fe(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), fr = Fe(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Lv = gt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Ov = gt(/<%[\w\W]*|[\w\W]*%>/gm), Mv = gt(/\${[\w\W]*}/gm), Pv = gt(/^data-[\-\w.\u00B7-\uFFFF]/), Nv = gt(/^aria-[\-\w]+$/), pu = gt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), xv = gt(/^(?:\w+script|data):/i), Bv = gt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), mu = gt(/^html$/i);
var cs = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: Lv,
  ERB_EXPR: Ov,
  TMPLIT_EXPR: Mv,
  DATA_ATTR: Pv,
  ARIA_ATTR: Nv,
  IS_ALLOWED_URI: pu,
  IS_SCRIPT_OR_DATA: xv,
  ATTR_WHITESPACE: Bv,
  DOCTYPE_NAME: mu
});
const Hv = function() {
  return typeof window > "u" ? null : window;
}, Dv = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const a = "data-tt-policy-suffix";
  n && n.hasAttribute(a) && (r = n.getAttribute(a));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(i, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
};
function gu() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Hv();
  const t = (U) => gu(U);
  if (t.version = "3.0.8", t.removed = [], !e || !e.document || e.document.nodeType !== 9)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, a = r.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: o,
    Node: s,
    Element: l,
    NodeFilter: u,
    NamedNodeMap: c = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: g
  } = e, v = l.prototype, C = dr(v, "cloneNode"), A = dr(v, "nextSibling"), k = dr(v, "childNodes"), R = dr(v, "parentNode");
  if (typeof o == "function") {
    const U = n.createElement("template");
    U.content && U.content.ownerDocument && (n = U.content.ownerDocument);
  }
  let y, w = "";
  const {
    implementation: p,
    createNodeIterator: B,
    createDocumentFragment: b,
    getElementsByTagName: S
  } = n, {
    importNode: O
  } = r;
  let I = {};
  t.isSupported = typeof fu == "function" && typeof R == "function" && p && p.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: P,
    ERB_EXPR: $,
    TMPLIT_EXPR: Q,
    DATA_ATTR: Y,
    ARIA_ATTR: he,
    IS_SCRIPT_OR_DATA: G,
    ATTR_WHITESPACE: we
  } = cs;
  let {
    IS_ALLOWED_URI: Ce
  } = cs, ie = null;
  const ct = Z({}, [...os, ...na, ...ra, ...aa, ...ss]);
  let be = null;
  const Ht = Z({}, [...ls, ...ia, ...us, ...fr]);
  let pe = Object.seal(hu(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Je = null, At = null, Dt = !0, bt = !0, dt = !1, Lt = !0, Me = !1, We = !1, H = !1, et = !1, Pe = !1, tt = !1, j = !1, J = !0, X = !1;
  const nt = "user-content-";
  let ft = !0, ht = !1, je = {}, Ye = null;
  const Vt = Z({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Xn = null;
  const Kn = Z({}, ["audio", "video", "img", "source", "image", "track"]);
  let wn = null;
  const Zn = Z({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), dn = "http://www.w3.org/1998/Math/MathML", fn = "http://www.w3.org/2000/svg", T = "http://www.w3.org/1999/xhtml";
  let _ = T, L = !1, K = null;
  const Le = Z({}, [dn, fn, T], ta);
  let pt = null;
  const Hr = ["application/xhtml+xml", "text/html"], Te = "text/html";
  let me = null, Xe = null;
  const Su = n.createElement("form"), Ei = function(m) {
    return m instanceof RegExp || m instanceof Function;
  }, Dr = function() {
    let m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Xe && Xe === m)) {
      if ((!m || typeof m != "object") && (m = {}), m = Qt(m), pt = // eslint-disable-next-line unicorn/prefer-includes
      Hr.indexOf(m.PARSER_MEDIA_TYPE) === -1 ? Te : m.PARSER_MEDIA_TYPE, me = pt === "application/xhtml+xml" ? ta : gr, ie = "ALLOWED_TAGS" in m ? Z({}, m.ALLOWED_TAGS, me) : ct, be = "ALLOWED_ATTR" in m ? Z({}, m.ALLOWED_ATTR, me) : Ht, K = "ALLOWED_NAMESPACES" in m ? Z({}, m.ALLOWED_NAMESPACES, ta) : Le, wn = "ADD_URI_SAFE_ATTR" in m ? Z(
        Qt(Zn),
        // eslint-disable-line indent
        m.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        me
        // eslint-disable-line indent
      ) : Zn, Xn = "ADD_DATA_URI_TAGS" in m ? Z(
        Qt(Kn),
        // eslint-disable-line indent
        m.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        me
        // eslint-disable-line indent
      ) : Kn, Ye = "FORBID_CONTENTS" in m ? Z({}, m.FORBID_CONTENTS, me) : Vt, Je = "FORBID_TAGS" in m ? Z({}, m.FORBID_TAGS, me) : {}, At = "FORBID_ATTR" in m ? Z({}, m.FORBID_ATTR, me) : {}, je = "USE_PROFILES" in m ? m.USE_PROFILES : !1, Dt = m.ALLOW_ARIA_ATTR !== !1, bt = m.ALLOW_DATA_ATTR !== !1, dt = m.ALLOW_UNKNOWN_PROTOCOLS || !1, Lt = m.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Me = m.SAFE_FOR_TEMPLATES || !1, We = m.WHOLE_DOCUMENT || !1, Pe = m.RETURN_DOM || !1, tt = m.RETURN_DOM_FRAGMENT || !1, j = m.RETURN_TRUSTED_TYPE || !1, et = m.FORCE_BODY || !1, J = m.SANITIZE_DOM !== !1, X = m.SANITIZE_NAMED_PROPS || !1, ft = m.KEEP_CONTENT !== !1, ht = m.IN_PLACE || !1, Ce = m.ALLOWED_URI_REGEXP || pu, _ = m.NAMESPACE || T, pe = m.CUSTOM_ELEMENT_HANDLING || {}, m.CUSTOM_ELEMENT_HANDLING && Ei(m.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (pe.tagNameCheck = m.CUSTOM_ELEMENT_HANDLING.tagNameCheck), m.CUSTOM_ELEMENT_HANDLING && Ei(m.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (pe.attributeNameCheck = m.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), m.CUSTOM_ELEMENT_HANDLING && typeof m.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (pe.allowCustomizedBuiltInElements = m.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Me && (bt = !1), tt && (Pe = !0), je && (ie = Z({}, ss), be = [], je.html === !0 && (Z(ie, os), Z(be, ls)), je.svg === !0 && (Z(ie, na), Z(be, ia), Z(be, fr)), je.svgFilters === !0 && (Z(ie, ra), Z(be, ia), Z(be, fr)), je.mathMl === !0 && (Z(ie, aa), Z(be, us), Z(be, fr))), m.ADD_TAGS && (ie === ct && (ie = Qt(ie)), Z(ie, m.ADD_TAGS, me)), m.ADD_ATTR && (be === Ht && (be = Qt(be)), Z(be, m.ADD_ATTR, me)), m.ADD_URI_SAFE_ATTR && Z(wn, m.ADD_URI_SAFE_ATTR, me), m.FORBID_CONTENTS && (Ye === Vt && (Ye = Qt(Ye)), Z(Ye, m.FORBID_CONTENTS, me)), ft && (ie["#text"] = !0), We && Z(ie, ["html", "head", "body"]), ie.table && (Z(ie, ["tbody"]), delete Je.tbody), m.TRUSTED_TYPES_POLICY) {
        if (typeof m.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw On('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof m.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw On('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        y = m.TRUSTED_TYPES_POLICY, w = y.createHTML("");
      } else
        y === void 0 && (y = Dv(g, a)), y !== null && typeof w == "string" && (w = y.createHTML(""));
      Fe && Fe(m), Xe = m;
    }
  }, Si = Z({}, ["mi", "mo", "mn", "ms", "mtext"]), Ti = Z({}, ["foreignobject", "desc", "title", "annotation-xml"]), Tu = Z({}, ["title", "style", "font", "a", "script"]), wi = Z({}, [...na, ...ra, ...kv]), Ci = Z({}, [...aa, ...Av]), wu = function(m) {
    let N = R(m);
    (!N || !N.tagName) && (N = {
      namespaceURI: _,
      tagName: "template"
    });
    const F = gr(m.tagName), ge = gr(N.tagName);
    return K[m.namespaceURI] ? m.namespaceURI === fn ? N.namespaceURI === T ? F === "svg" : N.namespaceURI === dn ? F === "svg" && (ge === "annotation-xml" || Si[ge]) : !!wi[F] : m.namespaceURI === dn ? N.namespaceURI === T ? F === "math" : N.namespaceURI === fn ? F === "math" && Ti[ge] : !!Ci[F] : m.namespaceURI === T ? N.namespaceURI === fn && !Ti[ge] || N.namespaceURI === dn && !Si[ge] ? !1 : !Ci[F] && (Tu[F] || !wi[F]) : !!(pt === "application/xhtml+xml" && K[m.namespaceURI]) : !1;
  }, Gt = function(m) {
    An(t.removed, {
      element: m
    });
    try {
      m.parentNode.removeChild(m);
    } catch {
      m.remove();
    }
  }, $r = function(m, N) {
    try {
      An(t.removed, {
        attribute: N.getAttributeNode(m),
        from: N
      });
    } catch {
      An(t.removed, {
        attribute: null,
        from: N
      });
    }
    if (N.removeAttribute(m), m === "is" && !be[m])
      if (Pe || tt)
        try {
          Gt(N);
        } catch {
        }
      else
        try {
          N.setAttribute(m, "");
        } catch {
        }
  }, Ii = function(m) {
    let N = null, F = null;
    if (et)
      m = "<remove></remove>" + m;
    else {
      const xe = Tv(m, /^[\r\n\t ]+/);
      F = xe && xe[0];
    }
    pt === "application/xhtml+xml" && _ === T && (m = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + m + "</body></html>");
    const ge = y ? y.createHTML(m) : m;
    if (_ === T)
      try {
        N = new f().parseFromString(ge, pt);
      } catch {
      }
    if (!N || !N.documentElement) {
      N = p.createDocument(_, "template", null);
      try {
        N.documentElement.innerHTML = L ? w : ge;
      } catch {
      }
    }
    const Ne = N.body || N.documentElement;
    return m && F && Ne.insertBefore(n.createTextNode(F), Ne.childNodes[0] || null), _ === T ? S.call(N, We ? "html" : "body")[0] : We ? N.documentElement : Ne;
  }, Ri = function(m) {
    return B.call(
      m.ownerDocument || m,
      m,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT,
      null
    );
  }, Cu = function(m) {
    return m instanceof d && (typeof m.nodeName != "string" || typeof m.textContent != "string" || typeof m.removeChild != "function" || !(m.attributes instanceof c) || typeof m.removeAttribute != "function" || typeof m.setAttribute != "function" || typeof m.namespaceURI != "string" || typeof m.insertBefore != "function" || typeof m.hasChildNodes != "function");
  }, ki = function(m) {
    return typeof s == "function" && m instanceof s;
  }, Ot = function(m, N, F) {
    I[m] && cr(I[m], (ge) => {
      ge.call(t, N, F, Xe);
    });
  }, Ai = function(m) {
    let N = null;
    if (Ot("beforeSanitizeElements", m, null), Cu(m))
      return Gt(m), !0;
    const F = me(m.nodeName);
    if (Ot("uponSanitizeElement", m, {
      tagName: F,
      allowedTags: ie
    }), m.hasChildNodes() && !ki(m.firstElementChild) && Ke(/<[/\w]/g, m.innerHTML) && Ke(/<[/\w]/g, m.textContent))
      return Gt(m), !0;
    if (!ie[F] || Je[F]) {
      if (!Je[F] && Oi(F) && (pe.tagNameCheck instanceof RegExp && Ke(pe.tagNameCheck, F) || pe.tagNameCheck instanceof Function && pe.tagNameCheck(F)))
        return !1;
      if (ft && !Ye[F]) {
        const ge = R(m) || m.parentNode, Ne = k(m) || m.childNodes;
        if (Ne && ge) {
          const xe = Ne.length;
          for (let qe = xe - 1; qe >= 0; --qe)
            ge.insertBefore(C(Ne[qe], !0), A(m));
        }
      }
      return Gt(m), !0;
    }
    return m instanceof l && !wu(m) || (F === "noscript" || F === "noembed" || F === "noframes") && Ke(/<\/no(script|embed|frames)/i, m.innerHTML) ? (Gt(m), !0) : (Me && m.nodeType === 3 && (N = m.textContent, cr([P, $, Q], (ge) => {
      N = Ln(N, ge, " ");
    }), m.textContent !== N && (An(t.removed, {
      element: m.cloneNode()
    }), m.textContent = N)), Ot("afterSanitizeElements", m, null), !1);
  }, Li = function(m, N, F) {
    if (J && (N === "id" || N === "name") && (F in n || F in Su))
      return !1;
    if (!(bt && !At[N] && Ke(Y, N))) {
      if (!(Dt && Ke(he, N))) {
        if (!be[N] || At[N]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Oi(m) && (pe.tagNameCheck instanceof RegExp && Ke(pe.tagNameCheck, m) || pe.tagNameCheck instanceof Function && pe.tagNameCheck(m)) && (pe.attributeNameCheck instanceof RegExp && Ke(pe.attributeNameCheck, N) || pe.attributeNameCheck instanceof Function && pe.attributeNameCheck(N)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            N === "is" && pe.allowCustomizedBuiltInElements && (pe.tagNameCheck instanceof RegExp && Ke(pe.tagNameCheck, F) || pe.tagNameCheck instanceof Function && pe.tagNameCheck(F)))
          )
            return !1;
        } else if (!wn[N]) {
          if (!Ke(Ce, Ln(F, we, ""))) {
            if (!((N === "src" || N === "xlink:href" || N === "href") && m !== "script" && wv(F, "data:") === 0 && Xn[m])) {
              if (!(dt && !Ke(G, Ln(F, we, "")))) {
                if (F)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Oi = function(m) {
    return m.indexOf("-") > 0;
  }, Mi = function(m) {
    Ot("beforeSanitizeAttributes", m, null);
    const {
      attributes: N
    } = m;
    if (!N)
      return;
    const F = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: be
    };
    let ge = N.length;
    for (; ge--; ) {
      const Ne = N[ge], {
        name: xe,
        namespaceURI: qe,
        value: Yt
      } = Ne, Cn = me(xe);
      let Ve = xe === "value" ? Yt : Cv(Yt);
      if (F.attrName = Cn, F.attrValue = Ve, F.keepAttr = !0, F.forceKeepAttr = void 0, Ot("uponSanitizeAttribute", m, F), Ve = F.attrValue, F.forceKeepAttr || ($r(xe, m), !F.keepAttr))
        continue;
      if (!Lt && Ke(/\/>/i, Ve)) {
        $r(xe, m);
        continue;
      }
      Me && cr([P, $, Q], (Ni) => {
        Ve = Ln(Ve, Ni, " ");
      });
      const Pi = me(m.nodeName);
      if (Li(Pi, Cn, Ve)) {
        if (X && (Cn === "id" || Cn === "name") && ($r(xe, m), Ve = nt + Ve), y && typeof g == "object" && typeof g.getAttributeType == "function" && !qe)
          switch (g.getAttributeType(Pi, Cn)) {
            case "TrustedHTML": {
              Ve = y.createHTML(Ve);
              break;
            }
            case "TrustedScriptURL": {
              Ve = y.createScriptURL(Ve);
              break;
            }
          }
        try {
          qe ? m.setAttributeNS(qe, xe, Ve) : m.setAttribute(xe, Ve), is(t.removed);
        } catch {
        }
      }
    }
    Ot("afterSanitizeAttributes", m, null);
  }, Iu = function U(m) {
    let N = null;
    const F = Ri(m);
    for (Ot("beforeSanitizeShadowDOM", m, null); N = F.nextNode(); )
      Ot("uponSanitizeShadowNode", N, null), !Ai(N) && (N.content instanceof i && U(N.content), Mi(N));
    Ot("afterSanitizeShadowDOM", m, null);
  };
  return t.sanitize = function(U) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, N = null, F = null, ge = null, Ne = null;
    if (L = !U, L && (U = "<!-->"), typeof U != "string" && !ki(U))
      if (typeof U.toString == "function") {
        if (U = U.toString(), typeof U != "string")
          throw On("dirty is not a string, aborting");
      } else
        throw On("toString is not a function");
    if (!t.isSupported)
      return U;
    if (H || Dr(m), t.removed = [], typeof U == "string" && (ht = !1), ht) {
      if (U.nodeName) {
        const Yt = me(U.nodeName);
        if (!ie[Yt] || Je[Yt])
          throw On("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (U instanceof s)
      N = Ii("<!---->"), F = N.ownerDocument.importNode(U, !0), F.nodeType === 1 && F.nodeName === "BODY" || F.nodeName === "HTML" ? N = F : N.appendChild(F);
    else {
      if (!Pe && !Me && !We && // eslint-disable-next-line unicorn/prefer-includes
      U.indexOf("<") === -1)
        return y && j ? y.createHTML(U) : U;
      if (N = Ii(U), !N)
        return Pe ? null : j ? w : "";
    }
    N && et && Gt(N.firstChild);
    const xe = Ri(ht ? U : N);
    for (; ge = xe.nextNode(); )
      Ai(ge) || (ge.content instanceof i && Iu(ge.content), Mi(ge));
    if (ht)
      return U;
    if (Pe) {
      if (tt)
        for (Ne = b.call(N.ownerDocument); N.firstChild; )
          Ne.appendChild(N.firstChild);
      else
        Ne = N;
      return (be.shadowroot || be.shadowrootmode) && (Ne = O.call(r, Ne, !0)), Ne;
    }
    let qe = We ? N.outerHTML : N.innerHTML;
    return We && ie["!doctype"] && N.ownerDocument && N.ownerDocument.doctype && N.ownerDocument.doctype.name && Ke(mu, N.ownerDocument.doctype.name) && (qe = "<!DOCTYPE " + N.ownerDocument.doctype.name + `>
` + qe), Me && cr([P, $, Q], (Yt) => {
      qe = Ln(qe, Yt, " ");
    }), y && j ? y.createHTML(qe) : qe;
  }, t.setConfig = function() {
    let U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Dr(U), H = !0;
  }, t.clearConfig = function() {
    Xe = null, H = !1;
  }, t.isValidAttribute = function(U, m, N) {
    Xe || Dr({});
    const F = me(U), ge = me(m);
    return Li(F, ge, N);
  }, t.addHook = function(U, m) {
    typeof m == "function" && (I[U] = I[U] || [], An(I[U], m));
  }, t.removeHook = function(U) {
    if (I[U])
      return is(I[U]);
  }, t.removeHooks = function(U) {
    I[U] && (I[U] = []);
  }, t.removeAllHooks = function() {
    I = {};
  }, t;
}
var $v = gu();
function vi() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let cn = vi();
function bu(e) {
  cn = e;
}
const vu = /[&<>"']/, Fv = new RegExp(vu.source, "g"), yu = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, Uv = new RegExp(yu.source, "g"), zv = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, ds = (e) => zv[e];
function Ze(e, t) {
  if (t) {
    if (vu.test(e))
      return e.replace(Fv, ds);
  } else if (yu.test(e))
    return e.replace(Uv, ds);
  return e;
}
const Wv = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function jv(e) {
  return e.replace(Wv, (t, n) => (n = n.toLowerCase(), n === "colon" ? ":" : n.charAt(0) === "#" ? n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : ""));
}
const qv = /(^|[^\[])\^/g;
function ue(e, t) {
  e = typeof e == "string" ? e : e.source, t = t || "";
  const n = {
    replace: (r, a) => (a = typeof a == "object" && "source" in a ? a.source : a, a = a.replace(qv, "$1"), e = e.replace(r, a), n),
    getRegex: () => new RegExp(e, t)
  };
  return n;
}
function fs(e) {
  try {
    e = encodeURI(e).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return e;
}
const Tr = { exec: () => null };
function hs(e, t) {
  const n = e.replace(/\|/g, (i, o, s) => {
    let l = !1, u = o;
    for (; --u >= 0 && s[u] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), r = n.split(/ \|/);
  let a = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), t)
    if (r.length > t)
      r.splice(t);
    else
      for (; r.length < t; )
        r.push("");
  for (; a < r.length; a++)
    r[a] = r[a].trim().replace(/\\\|/g, "|");
  return r;
}
function hr(e, t, n) {
  const r = e.length;
  if (r === 0)
    return "";
  let a = 0;
  for (; a < r; ) {
    const i = e.charAt(r - a - 1);
    if (i === t && !n)
      a++;
    else if (i !== t && n)
      a++;
    else
      break;
  }
  return e.slice(0, r - a);
}
function Vv(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  let n = 0;
  for (let r = 0; r < e.length; r++)
    if (e[r] === "\\")
      r++;
    else if (e[r] === t[0])
      n++;
    else if (e[r] === t[1] && (n--, n < 0))
      return r;
  return -1;
}
function ps(e, t, n, r) {
  const a = t.href, i = t.title ? Ze(t.title) : null, o = e[1].replace(/\\([\[\]])/g, "$1");
  if (e[0].charAt(0) !== "!") {
    r.state.inLink = !0;
    const s = {
      type: "link",
      raw: n,
      href: a,
      title: i,
      text: o,
      tokens: r.inlineTokens(o)
    };
    return r.state.inLink = !1, s;
  }
  return {
    type: "image",
    raw: n,
    href: a,
    title: i,
    text: Ze(o)
  };
}
function Gv(e, t) {
  const n = e.match(/^(\s+)(?:```)/);
  if (n === null)
    return t;
  const r = n[1];
  return t.split(`
`).map((a) => {
    const i = a.match(/^\s+/);
    if (i === null)
      return a;
    const [o] = i;
    return o.length >= r.length ? a.slice(r.length) : a;
  }).join(`
`);
}
class wr {
  constructor(t) {
    ve(this, "options");
    // TODO: Fix this rules type
    ve(this, "rules");
    ve(this, "lexer");
    this.options = t || cn;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const r = n[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? r : hr(r, `
`)
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const r = n[0], a = Gv(r, n[3] || "");
      return {
        type: "code",
        raw: r,
        lang: n[2] ? n[2].trim().replace(this.rules.inline._escapes, "$1") : n[2],
        text: a
      };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let r = n[2].trim();
      if (/#$/.test(r)) {
        const a = hr(r, "#");
        (this.options.pedantic || !a || / $/.test(a)) && (r = a.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n)
      return {
        type: "hr",
        raw: n[0]
      };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      const r = hr(n[0].replace(/^ *>[ \t]?/gm, ""), `
`), a = this.lexer.state.top;
      this.lexer.state.top = !0;
      const i = this.lexer.blockTokens(r);
      return this.lexer.state.top = a, {
        type: "blockquote",
        raw: n[0],
        tokens: i,
        text: r
      };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let r = n[1].trim();
      const a = r.length > 1, i = {
        type: "list",
        raw: "",
        ordered: a,
        start: a ? +r.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      r = a ? `\\d{1,9}\\${r.slice(-1)}` : `\\${r}`, this.options.pedantic && (r = a ? r : "[*+-]");
      const o = new RegExp(`^( {0,3}${r})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      let s = "", l = "", u = !1;
      for (; t; ) {
        let c = !1;
        if (!(n = o.exec(t)) || this.rules.block.hr.test(t))
          break;
        s = n[0], t = t.substring(s.length);
        let d = n[2].split(`
`, 1)[0].replace(/^\t+/, (k) => " ".repeat(3 * k.length)), f = t.split(`
`, 1)[0], g = 0;
        this.options.pedantic ? (g = 2, l = d.trimStart()) : (g = n[2].search(/[^ ]/), g = g > 4 ? 1 : g, l = d.slice(g), g += n[1].length);
        let v = !1;
        if (!d && /^ *$/.test(f) && (s += f + `
`, t = t.substring(f.length + 1), c = !0), !c) {
          const k = new RegExp(`^ {0,${Math.min(3, g - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), R = new RegExp(`^ {0,${Math.min(3, g - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), y = new RegExp(`^ {0,${Math.min(3, g - 1)}}(?:\`\`\`|~~~)`), w = new RegExp(`^ {0,${Math.min(3, g - 1)}}#`);
          for (; t; ) {
            const p = t.split(`
`, 1)[0];
            if (f = p, this.options.pedantic && (f = f.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), y.test(f) || w.test(f) || k.test(f) || R.test(t))
              break;
            if (f.search(/[^ ]/) >= g || !f.trim())
              l += `
` + f.slice(g);
            else {
              if (v || d.search(/[^ ]/) >= 4 || y.test(d) || w.test(d) || R.test(d))
                break;
              l += `
` + f;
            }
            !v && !f.trim() && (v = !0), s += p + `
`, t = t.substring(p.length + 1), d = f.slice(g);
          }
        }
        i.loose || (u ? i.loose = !0 : /\n *\n *$/.test(s) && (u = !0));
        let C = null, A;
        this.options.gfm && (C = /^\[[ xX]\] /.exec(l), C && (A = C[0] !== "[ ] ", l = l.replace(/^\[[ xX]\] +/, ""))), i.items.push({
          type: "list_item",
          raw: s,
          task: !!C,
          checked: A,
          loose: !1,
          text: l,
          tokens: []
        }), i.raw += s;
      }
      i.items[i.items.length - 1].raw = s.trimEnd(), i.items[i.items.length - 1].text = l.trimEnd(), i.raw = i.raw.trimEnd();
      for (let c = 0; c < i.items.length; c++)
        if (this.lexer.state.top = !1, i.items[c].tokens = this.lexer.blockTokens(i.items[c].text, []), !i.loose) {
          const d = i.items[c].tokens.filter((g) => g.type === "space"), f = d.length > 0 && d.some((g) => /\n.*\n/.test(g.raw));
          i.loose = f;
        }
      if (i.loose)
        for (let c = 0; c < i.items.length; c++)
          i.items[c].loose = !0;
      return i;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n)
      return {
        type: "html",
        block: !0,
        raw: n[0],
        pre: n[1] === "pre" || n[1] === "script" || n[1] === "style",
        text: n[0]
      };
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n) {
      const r = n[1].toLowerCase().replace(/\s+/g, " "), a = n[2] ? n[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline._escapes, "$1") : n[3];
      return {
        type: "def",
        tag: r,
        raw: n[0],
        href: a,
        title: i
      };
    }
  }
  table(t) {
    const n = this.rules.block.table.exec(t);
    if (n) {
      if (!/[:|]/.test(n[2]))
        return;
      const r = {
        type: "table",
        raw: n[0],
        header: hs(n[1]).map((a) => ({ text: a, tokens: [] })),
        align: n[2].replace(/^\||\| *$/g, "").split("|"),
        rows: n[3] && n[3].trim() ? n[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (r.header.length === r.align.length) {
        let a = r.align.length, i, o, s, l;
        for (i = 0; i < a; i++) {
          const u = r.align[i];
          u && (/^ *-+: *$/.test(u) ? r.align[i] = "right" : /^ *:-+: *$/.test(u) ? r.align[i] = "center" : /^ *:-+ *$/.test(u) ? r.align[i] = "left" : r.align[i] = null);
        }
        for (a = r.rows.length, i = 0; i < a; i++)
          r.rows[i] = hs(r.rows[i], r.header.length).map((u) => ({ text: u, tokens: [] }));
        for (a = r.header.length, o = 0; o < a; o++)
          r.header[o].tokens = this.lexer.inline(r.header[o].text);
        for (a = r.rows.length, o = 0; o < a; o++)
          for (l = r.rows[o], s = 0; s < l.length; s++)
            l[s].tokens = this.lexer.inline(l[s].text);
        return r;
      }
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const r = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: Ze(n[1])
      };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return !this.lexer.state.inLink && /^<a /i.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: n[0]
      };
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const r = n[2].trim();
      if (!this.options.pedantic && /^</.test(r)) {
        if (!/>$/.test(r))
          return;
        const o = hr(r.slice(0, -1), "\\");
        if ((r.length - o.length) % 2 === 0)
          return;
      } else {
        const o = Vv(n[2], "()");
        if (o > -1) {
          const l = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + o;
          n[2] = n[2].substring(0, o), n[0] = n[0].substring(0, l).trim(), n[3] = "";
        }
      }
      let a = n[2], i = "";
      if (this.options.pedantic) {
        const o = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(a);
        o && (a = o[1], i = o[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return a = a.trim(), /^</.test(a) && (this.options.pedantic && !/>$/.test(r) ? a = a.slice(1) : a = a.slice(1, -1)), ps(n, {
        href: a && a.replace(this.rules.inline._escapes, "$1"),
        title: i && i.replace(this.rules.inline._escapes, "$1")
      }, n[0], this.lexer);
    }
  }
  reflink(t, n) {
    let r;
    if ((r = this.rules.inline.reflink.exec(t)) || (r = this.rules.inline.nolink.exec(t))) {
      let a = (r[2] || r[1]).replace(/\s+/g, " ");
      if (a = n[a.toLowerCase()], !a) {
        const i = r[0].charAt(0);
        return {
          type: "text",
          raw: i,
          text: i
        };
      }
      return ps(r, a, r[0], this.lexer);
    }
  }
  emStrong(t, n, r = "") {
    let a = this.rules.inline.emStrong.lDelim.exec(t);
    if (!a || a[3] && r.match(/[\p{L}\p{N}]/u))
      return;
    if (!(a[1] || a[2] || "") || !r || this.rules.inline.punctuation.exec(r)) {
      const o = [...a[0]].length - 1;
      let s, l, u = o, c = 0;
      const d = a[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (d.lastIndex = 0, n = n.slice(-1 * t.length + o); (a = d.exec(n)) != null; ) {
        if (s = a[1] || a[2] || a[3] || a[4] || a[5] || a[6], !s)
          continue;
        if (l = [...s].length, a[3] || a[4]) {
          u += l;
          continue;
        } else if ((a[5] || a[6]) && o % 3 && !((o + l) % 3)) {
          c += l;
          continue;
        }
        if (u -= l, u > 0)
          continue;
        l = Math.min(l, l + u + c);
        const f = [...a[0]][0].length, g = t.slice(0, o + a.index + f + l);
        if (Math.min(o, l) % 2) {
          const C = g.slice(1, -1);
          return {
            type: "em",
            raw: g,
            text: C,
            tokens: this.lexer.inlineTokens(C)
          };
        }
        const v = g.slice(2, -2);
        return {
          type: "strong",
          raw: g,
          text: v,
          tokens: this.lexer.inlineTokens(v)
        };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let r = n[2].replace(/\n/g, " ");
      const a = /[^ ]/.test(r), i = /^ /.test(r) && / $/.test(r);
      return a && i && (r = r.substring(1, r.length - 1)), r = Ze(r, !0), {
        type: "codespan",
        raw: n[0],
        text: r
      };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(t) {
    const n = this.rules.inline.autolink.exec(t);
    if (n) {
      let r, a;
      return n[2] === "@" ? (r = Ze(n[1]), a = "mailto:" + r) : (r = Ze(n[1]), a = r), {
        type: "link",
        raw: n[0],
        text: r,
        href: a,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  url(t) {
    let n;
    if (n = this.rules.inline.url.exec(t)) {
      let r, a;
      if (n[2] === "@")
        r = Ze(n[0]), a = "mailto:" + r;
      else {
        let i;
        do
          i = n[0], n[0] = this.rules.inline._backpedal.exec(n[0])[0];
        while (i !== n[0]);
        r = Ze(n[0]), n[1] === "www." ? a = "http://" + n[0] : a = n[0];
      }
      return {
        type: "link",
        raw: n[0],
        text: r,
        href: a,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  inlineText(t) {
    const n = this.rules.inline.text.exec(t);
    if (n) {
      let r;
      return this.lexer.state.inRawBlock ? r = n[0] : r = Ze(n[0]), {
        type: "text",
        raw: n[0],
        text: r
      };
    }
  }
}
const W = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: Tr,
  lheading: /^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
W._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
W._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
W.def = ue(W.def).replace("label", W._label).replace("title", W._title).getRegex();
W.bullet = /(?:[*+-]|\d{1,9}[.)])/;
W.listItemStart = ue(/^( *)(bull) */).replace("bull", W.bullet).getRegex();
W.list = ue(W.list).replace(/bull/g, W.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + W.def.source + ")").getRegex();
W._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
W._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
W.html = ue(W.html, "i").replace("comment", W._comment).replace("tag", W._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
W.lheading = ue(W.lheading).replace(/bull/g, W.bullet).getRegex();
W.paragraph = ue(W._paragraph).replace("hr", W.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W._tag).getRegex();
W.blockquote = ue(W.blockquote).replace("paragraph", W.paragraph).getRegex();
W.normal = { ...W };
W.gfm = {
  ...W.normal,
  table: "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
W.gfm.table = ue(W.gfm.table).replace("hr", W.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W._tag).getRegex();
W.gfm.paragraph = ue(W._paragraph).replace("hr", W.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", W.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W._tag).getRegex();
W.pedantic = {
  ...W.normal,
  html: ue(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", W._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Tr,
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: ue(W.normal._paragraph).replace("hr", W.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", W.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const x = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: Tr,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
    //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
    rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: Tr,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^((?![*_])[\spunctuation])/
};
x._punctuation = "\\p{P}$+<=>`^|~";
x.punctuation = ue(x.punctuation, "u").replace(/punctuation/g, x._punctuation).getRegex();
x.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
x.anyPunctuation = /\\[punct]/g;
x._escapes = /\\([punct])/g;
x._comment = ue(W._comment).replace("(?:-->|$)", "-->").getRegex();
x.emStrong.lDelim = ue(x.emStrong.lDelim, "u").replace(/punct/g, x._punctuation).getRegex();
x.emStrong.rDelimAst = ue(x.emStrong.rDelimAst, "gu").replace(/punct/g, x._punctuation).getRegex();
x.emStrong.rDelimUnd = ue(x.emStrong.rDelimUnd, "gu").replace(/punct/g, x._punctuation).getRegex();
x.anyPunctuation = ue(x.anyPunctuation, "gu").replace(/punct/g, x._punctuation).getRegex();
x._escapes = ue(x._escapes, "gu").replace(/punct/g, x._punctuation).getRegex();
x._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
x._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
x.autolink = ue(x.autolink).replace("scheme", x._scheme).replace("email", x._email).getRegex();
x._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
x.tag = ue(x.tag).replace("comment", x._comment).replace("attribute", x._attribute).getRegex();
x._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
x._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
x._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
x.link = ue(x.link).replace("label", x._label).replace("href", x._href).replace("title", x._title).getRegex();
x.reflink = ue(x.reflink).replace("label", x._label).replace("ref", W._label).getRegex();
x.nolink = ue(x.nolink).replace("ref", W._label).getRegex();
x.reflinkSearch = ue(x.reflinkSearch, "g").replace("reflink", x.reflink).replace("nolink", x.nolink).getRegex();
x.normal = { ...x };
x.pedantic = {
  ...x.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: ue(/^!?\[(label)\]\((.*?)\)/).replace("label", x._label).getRegex(),
  reflink: ue(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", x._label).getRegex()
};
x.gfm = {
  ...x.normal,
  escape: ue(x.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
x.gfm.url = ue(x.gfm.url, "i").replace("email", x.gfm._extended_email).getRegex();
x.breaks = {
  ...x.gfm,
  br: ue(x.br).replace("{2,}", "*").getRegex(),
  text: ue(x.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
class wt {
  constructor(t) {
    ve(this, "tokens");
    ve(this, "options");
    ve(this, "state");
    ve(this, "tokenizer");
    ve(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || cn, this.options.tokenizer = this.options.tokenizer || new wr(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      block: W.normal,
      inline: x.normal
    };
    this.options.pedantic ? (n.block = W.pedantic, n.inline = x.pedantic) : this.options.gfm && (n.block = W.gfm, this.options.breaks ? n.inline = x.breaks : n.inline = x.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: W,
      inline: x
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new wt(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new wt(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(/\r\n|\r/g, `
`), this.blockTokens(t, this.tokens);
    let n;
    for (; n = this.inlineQueue.shift(); )
      this.inlineTokens(n.src, n.tokens);
    return this.tokens;
  }
  blockTokens(t, n = []) {
    this.options.pedantic ? t = t.replace(/\t/g, "    ").replace(/^ +$/gm, "") : t = t.replace(/^( *)(\t+)/gm, (s, l, u) => l + "    ".repeat(u.length));
    let r, a, i, o;
    for (; t; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((s) => (r = s.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.space(t)) {
          t = t.substring(r.raw.length), r.raw.length === 1 && n.length > 0 ? n[n.length - 1].raw += `
` : n.push(r);
          continue;
        }
        if (r = this.tokenizer.code(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.fences(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.heading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.hr(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.blockquote(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.list(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.html(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.def(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
            href: r.href,
            title: r.title
          });
          continue;
        }
        if (r = this.tokenizer.table(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.lheading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startBlock) {
          let s = 1 / 0;
          const l = t.slice(1);
          let u;
          this.options.extensions.startBlock.forEach((c) => {
            u = c.call({ lexer: this }, l), typeof u == "number" && u >= 0 && (s = Math.min(s, u));
          }), s < 1 / 0 && s >= 0 && (i = t.substring(0, s + 1));
        }
        if (this.state.top && (r = this.tokenizer.paragraph(i))) {
          a = n[n.length - 1], o && a.type === "paragraph" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r), o = i.length !== t.length, t = t.substring(r.raw.length);
          continue;
        }
        if (r = this.tokenizer.text(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && a.type === "text" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (t) {
          const s = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(s);
            break;
          } else
            throw new Error(s);
        }
      }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    let r, a, i, o = t, s, l, u;
    if (this.tokens.links) {
      const c = Object.keys(this.tokens.links);
      if (c.length > 0)
        for (; (s = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          c.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (s = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (s = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, s.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; t; )
      if (l || (u = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((c) => (r = c.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.escape(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.tag(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.link(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.reflink(t, this.tokens.links)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.emStrong(t, o, u)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.codespan(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.br(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.del(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.autolink(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (!this.state.inLink && (r = this.tokenizer.url(t))) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startInline) {
          let c = 1 / 0;
          const d = t.slice(1);
          let f;
          this.options.extensions.startInline.forEach((g) => {
            f = g.call({ lexer: this }, d), typeof f == "number" && f >= 0 && (c = Math.min(c, f));
          }), c < 1 / 0 && c >= 0 && (i = t.substring(0, c + 1));
        }
        if (r = this.tokenizer.inlineText(i)) {
          t = t.substring(r.raw.length), r.raw.slice(-1) !== "_" && (u = r.raw.slice(-1)), l = !0, a = n[n.length - 1], a && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (t) {
          const c = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(c);
            break;
          } else
            throw new Error(c);
        }
      }
    return n;
  }
}
class Cr {
  constructor(t) {
    ve(this, "options");
    this.options = t || cn;
  }
  code(t, n, r) {
    var i;
    const a = (i = (n || "").match(/^\S*/)) == null ? void 0 : i[0];
    return t = t.replace(/\n$/, "") + `
`, a ? '<pre><code class="language-' + Ze(a) + '">' + (r ? t : Ze(t, !0)) + `</code></pre>
` : "<pre><code>" + (r ? t : Ze(t, !0)) + `</code></pre>
`;
  }
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t, n) {
    return t;
  }
  heading(t, n, r) {
    return `<h${n}>${t}</h${n}>
`;
  }
  hr() {
    return `<hr>
`;
  }
  list(t, n, r) {
    const a = n ? "ol" : "ul", i = n && r !== 1 ? ' start="' + r + '"' : "";
    return "<" + a + i + `>
` + t + "</" + a + `>
`;
  }
  listitem(t, n, r) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  table(t, n) {
    return n && (n = `<tbody>${n}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + n + `</table>
`;
  }
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, n) {
    const r = n.header ? "th" : "td";
    return (n.align ? `<${r} align="${n.align}">` : `<${r}>`) + t + `</${r}>
`;
  }
  /**
   * span level renderer
   */
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  em(t) {
    return `<em>${t}</em>`;
  }
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return "<br>";
  }
  del(t) {
    return `<del>${t}</del>`;
  }
  link(t, n, r) {
    const a = fs(t);
    if (a === null)
      return r;
    t = a;
    let i = '<a href="' + t + '"';
    return n && (i += ' title="' + n + '"'), i += ">" + r + "</a>", i;
  }
  image(t, n, r) {
    const a = fs(t);
    if (a === null)
      return r;
    t = a;
    let i = `<img src="${t}" alt="${r}"`;
    return n && (i += ` title="${n}"`), i += ">", i;
  }
  text(t) {
    return t;
  }
}
class yi {
  // no need for block level renderers
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, n, r) {
    return "" + r;
  }
  image(t, n, r) {
    return "" + r;
  }
  br() {
    return "";
  }
}
class Ct {
  constructor(t) {
    ve(this, "options");
    ve(this, "renderer");
    ve(this, "textRenderer");
    this.options = t || cn, this.options.renderer = this.options.renderer || new Cr(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new yi();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new Ct(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new Ct(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    let r = "";
    for (let a = 0; a < t.length; a++) {
      const i = t[a];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const o = i, s = this.options.extensions.renderers[o.type].call({ parser: this }, o);
        if (s !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(o.type)) {
          r += s || "";
          continue;
        }
      }
      switch (i.type) {
        case "space":
          continue;
        case "hr": {
          r += this.renderer.hr();
          continue;
        }
        case "heading": {
          const o = i;
          r += this.renderer.heading(this.parseInline(o.tokens), o.depth, jv(this.parseInline(o.tokens, this.textRenderer)));
          continue;
        }
        case "code": {
          const o = i;
          r += this.renderer.code(o.text, o.lang, !!o.escaped);
          continue;
        }
        case "table": {
          const o = i;
          let s = "", l = "";
          for (let c = 0; c < o.header.length; c++)
            l += this.renderer.tablecell(this.parseInline(o.header[c].tokens), { header: !0, align: o.align[c] });
          s += this.renderer.tablerow(l);
          let u = "";
          for (let c = 0; c < o.rows.length; c++) {
            const d = o.rows[c];
            l = "";
            for (let f = 0; f < d.length; f++)
              l += this.renderer.tablecell(this.parseInline(d[f].tokens), { header: !1, align: o.align[f] });
            u += this.renderer.tablerow(l);
          }
          r += this.renderer.table(s, u);
          continue;
        }
        case "blockquote": {
          const o = i, s = this.parse(o.tokens);
          r += this.renderer.blockquote(s);
          continue;
        }
        case "list": {
          const o = i, s = o.ordered, l = o.start, u = o.loose;
          let c = "";
          for (let d = 0; d < o.items.length; d++) {
            const f = o.items[d], g = f.checked, v = f.task;
            let C = "";
            if (f.task) {
              const A = this.renderer.checkbox(!!g);
              u ? f.tokens.length > 0 && f.tokens[0].type === "paragraph" ? (f.tokens[0].text = A + " " + f.tokens[0].text, f.tokens[0].tokens && f.tokens[0].tokens.length > 0 && f.tokens[0].tokens[0].type === "text" && (f.tokens[0].tokens[0].text = A + " " + f.tokens[0].tokens[0].text)) : f.tokens.unshift({
                type: "text",
                text: A + " "
              }) : C += A + " ";
            }
            C += this.parse(f.tokens, u), c += this.renderer.listitem(C, v, !!g);
          }
          r += this.renderer.list(c, s, l);
          continue;
        }
        case "html": {
          const o = i;
          r += this.renderer.html(o.text, o.block);
          continue;
        }
        case "paragraph": {
          const o = i;
          r += this.renderer.paragraph(this.parseInline(o.tokens));
          continue;
        }
        case "text": {
          let o = i, s = o.tokens ? this.parseInline(o.tokens) : o.text;
          for (; a + 1 < t.length && t[a + 1].type === "text"; )
            o = t[++a], s += `
` + (o.tokens ? this.parseInline(o.tokens) : o.text);
          r += n ? this.renderer.paragraph(s) : s;
          continue;
        }
        default: {
          const o = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n) {
    n = n || this.renderer;
    let r = "";
    for (let a = 0; a < t.length; a++) {
      const i = t[a];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const o = this.options.extensions.renderers[i.type].call({ parser: this }, i);
        if (o !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type)) {
          r += o || "";
          continue;
        }
      }
      switch (i.type) {
        case "escape": {
          const o = i;
          r += n.text(o.text);
          break;
        }
        case "html": {
          const o = i;
          r += n.html(o.text);
          break;
        }
        case "link": {
          const o = i;
          r += n.link(o.href, o.title, this.parseInline(o.tokens, n));
          break;
        }
        case "image": {
          const o = i;
          r += n.image(o.href, o.title, o.text);
          break;
        }
        case "strong": {
          const o = i;
          r += n.strong(this.parseInline(o.tokens, n));
          break;
        }
        case "em": {
          const o = i;
          r += n.em(this.parseInline(o.tokens, n));
          break;
        }
        case "codespan": {
          const o = i;
          r += n.codespan(o.text);
          break;
        }
        case "br": {
          r += n.br();
          break;
        }
        case "del": {
          const o = i;
          r += n.del(this.parseInline(o.tokens, n));
          break;
        }
        case "text": {
          const o = i;
          r += n.text(o.text);
          break;
        }
        default: {
          const o = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return r;
  }
}
class Bn {
  constructor(t) {
    ve(this, "options");
    this.options = t || cn;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
}
ve(Bn, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
var $n, $a, Ir, _u;
class Yv {
  constructor(...t) {
    Fr(this, $n);
    Fr(this, Ir);
    ve(this, "defaults", vi());
    ve(this, "options", this.setOptions);
    ve(this, "parse", Qn(this, $n, $a).call(this, wt.lex, Ct.parse));
    ve(this, "parseInline", Qn(this, $n, $a).call(this, wt.lexInline, Ct.parseInline));
    ve(this, "Parser", Ct);
    ve(this, "Renderer", Cr);
    ve(this, "TextRenderer", yi);
    ve(this, "Lexer", wt);
    ve(this, "Tokenizer", wr);
    ve(this, "Hooks", Bn);
    this.use(...t);
  }
  /**
   * Run callback for every token
   */
  walkTokens(t, n) {
    var a, i;
    let r = [];
    for (const o of t)
      switch (r = r.concat(n.call(this, o)), o.type) {
        case "table": {
          const s = o;
          for (const l of s.header)
            r = r.concat(this.walkTokens(l.tokens, n));
          for (const l of s.rows)
            for (const u of l)
              r = r.concat(this.walkTokens(u.tokens, n));
          break;
        }
        case "list": {
          const s = o;
          r = r.concat(this.walkTokens(s.items, n));
          break;
        }
        default: {
          const s = o;
          (i = (a = this.defaults.extensions) == null ? void 0 : a.childTokens) != null && i[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((l) => {
            r = r.concat(this.walkTokens(s[l], n));
          }) : s.tokens && (r = r.concat(this.walkTokens(s.tokens, n)));
        }
      }
    return r;
  }
  use(...t) {
    const n = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((r) => {
      const a = { ...r };
      if (a.async = this.defaults.async || a.async || !1, r.extensions && (r.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const o = n.renderers[i.name];
          o ? n.renderers[i.name] = function(...s) {
            let l = i.renderer.apply(this, s);
            return l === !1 && (l = o.apply(this, s)), l;
          } : n.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const o = n[i.level];
          o ? o.unshift(i.tokenizer) : n[i.level] = [i.tokenizer], i.start && (i.level === "block" ? n.startBlock ? n.startBlock.push(i.start) : n.startBlock = [i.start] : i.level === "inline" && (n.startInline ? n.startInline.push(i.start) : n.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (n.childTokens[i.name] = i.childTokens);
      }), a.extensions = n), r.renderer) {
        const i = this.defaults.renderer || new Cr(this.defaults);
        for (const o in r.renderer) {
          const s = r.renderer[o], l = o, u = i[l];
          i[l] = (...c) => {
            let d = s.apply(i, c);
            return d === !1 && (d = u.apply(i, c)), d || "";
          };
        }
        a.renderer = i;
      }
      if (r.tokenizer) {
        const i = this.defaults.tokenizer || new wr(this.defaults);
        for (const o in r.tokenizer) {
          const s = r.tokenizer[o], l = o, u = i[l];
          i[l] = (...c) => {
            let d = s.apply(i, c);
            return d === !1 && (d = u.apply(i, c)), d;
          };
        }
        a.tokenizer = i;
      }
      if (r.hooks) {
        const i = this.defaults.hooks || new Bn();
        for (const o in r.hooks) {
          const s = r.hooks[o], l = o, u = i[l];
          Bn.passThroughHooks.has(o) ? i[l] = (c) => {
            if (this.defaults.async)
              return Promise.resolve(s.call(i, c)).then((f) => u.call(i, f));
            const d = s.call(i, c);
            return u.call(i, d);
          } : i[l] = (...c) => {
            let d = s.apply(i, c);
            return d === !1 && (d = u.apply(i, c)), d;
          };
        }
        a.hooks = i;
      }
      if (r.walkTokens) {
        const i = this.defaults.walkTokens, o = r.walkTokens;
        a.walkTokens = function(s) {
          let l = [];
          return l.push(o.call(this, s)), i && (l = l.concat(i.call(this, s))), l;
        };
      }
      this.defaults = { ...this.defaults, ...a };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
  lexer(t, n) {
    return wt.lex(t, n ?? this.defaults);
  }
  parser(t, n) {
    return Ct.parse(t, n ?? this.defaults);
  }
}
$n = new WeakSet(), $a = function(t, n) {
  return (r, a) => {
    const i = { ...a }, o = { ...this.defaults, ...i };
    this.defaults.async === !0 && i.async === !1 && (o.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), o.async = !0);
    const s = Qn(this, Ir, _u).call(this, !!o.silent, !!o.async);
    if (typeof r > "u" || r === null)
      return s(new Error("marked(): input parameter is undefined or null"));
    if (typeof r != "string")
      return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(r) + ", string expected"));
    if (o.hooks && (o.hooks.options = o), o.async)
      return Promise.resolve(o.hooks ? o.hooks.preprocess(r) : r).then((l) => t(l, o)).then((l) => o.walkTokens ? Promise.all(this.walkTokens(l, o.walkTokens)).then(() => l) : l).then((l) => n(l, o)).then((l) => o.hooks ? o.hooks.postprocess(l) : l).catch(s);
    try {
      o.hooks && (r = o.hooks.preprocess(r));
      const l = t(r, o);
      o.walkTokens && this.walkTokens(l, o.walkTokens);
      let u = n(l, o);
      return o.hooks && (u = o.hooks.postprocess(u)), u;
    } catch (l) {
      return s(l);
    }
  };
}, Ir = new WeakSet(), _u = function(t, n) {
  return (r) => {
    if (r.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
      const a = "<p>An error occurred:</p><pre>" + Ze(r.message + "", !0) + "</pre>";
      return n ? Promise.resolve(a) : a;
    }
    if (n)
      return Promise.reject(r);
    throw r;
  };
};
const on = new Yv();
function ce(e, t) {
  return on.parse(e, t);
}
ce.options = ce.setOptions = function(e) {
  return on.setOptions(e), ce.defaults = on.defaults, bu(ce.defaults), ce;
};
ce.getDefaults = vi;
ce.defaults = cn;
ce.use = function(...e) {
  return on.use(...e), ce.defaults = on.defaults, bu(ce.defaults), ce;
};
ce.walkTokens = function(e, t) {
  return on.walkTokens(e, t);
};
ce.parseInline = on.parseInline;
ce.Parser = Ct;
ce.parser = Ct.parse;
ce.Renderer = Cr;
ce.TextRenderer = yi;
ce.Lexer = wt;
ce.lexer = wt.lex;
ce.Tokenizer = wr;
ce.Hooks = Bn;
ce.parse = ce;
ce.options;
ce.setOptions;
ce.use;
ce.walkTokens;
ce.parseInline;
const Xv = ce;
Ct.parse;
wt.lex;
const Kv = () => () => "'kern', 'ss01', 'ss05', 'ss07'", Zv = () => () => "WoltHeading-Omnes", Qv = /* @__PURE__ */ M("article")({
  name: "Root",
  class: "support-layer-TextBlock_Root_r1cddlgc",
  propsAsIs: !1,
  vars: {
    "r1cddlgc-0": [Kv()],
    "r1cddlgc-1": [Zv()]
  }
}), Jv = ({
  className: e,
  content: t,
  ...n
}) => {
  const r = Xv(t, {
    breaks: !0
  }), a = $v.sanitize(r);
  return /* @__PURE__ */ h(Qv, {
    ...n,
    dangerouslySetInnerHTML: {
      __html: a
    },
    className: ze("text_block", e)
  });
}, ey = ({
  component: e,
  contextToken: t,
  state: n,
  ...r
}) => {
  const { formatMessage: a } = Bt(), { orderItems: i } = e.props, o = i.map(({ id: l, maxCount: u, name: c }) => ({
    id: l,
    label: c,
    maxQuantity: u,
    quantity: 0
  })), s = n == null ? void 0 : n.getState(t, "order_items_selection_input");
  return /* @__PURE__ */ h(
    S1,
    {
      items: (s == null ? void 0 : s.items) ?? o,
      commentInputLabel: e.props.comment.placeholder,
      commentDefaultValue: (s == null ? void 0 : s.comment) ?? void 0,
      onChange: (l) => {
        n == null || n.setState(t, "order_items_selection_input", l);
      },
      stepperLabels: {
        decrementAriaLabel: a({
          id: "order-items-selection-input.stepper.decrement-aria-label"
        }),
        incrementAriaLabel: a({
          id: "order-items-selection-input.stepper.increment-aria-label"
        }),
        label: a({
          id: "order-items-selection-input.stepper.label"
        })
      },
      quantityButtonAriaLabel: a({
        id: "order-items-selection-input.quantity-button-aria-label"
      }),
      quantityButtonAriaMarkerLabel: a({
        id: "order-items-selection-input.quantity-button-aria-marker-label"
      }),
      ...r
    }
  );
}, ty = ({
  component: e,
  handleAction: t,
  ...n
}) => {
  const { action: r, inputKey: a, props: i } = e, o = i.sections.map(({ orders: l, title: u }) => ({
    orders: l.map((c) => ({
      date: c.formattedDate,
      id: c.id,
      price: c.formattedPrice,
      venueName: c.venueName,
      ...c.image && {
        image: c.image
      }
    })),
    title: u
  }));
  return /* @__PURE__ */ h(W1, { sections: o, onOrderSelect: (l) => {
    t({
      action: r,
      inputs: {
        [a]: {
          orderId: l
        }
      }
    });
  }, ...n });
}, ny = ({
  component: e,
  contextToken: t,
  state: n
}) => {
  if (!(e.id === "request_refund_button"))
    return;
  const a = n == null ? void 0 : n.getState(t, "order_items_selection_input");
  if (!a)
    return {
      disabled: !0
    };
  const i = a.items.every(({ quantity: s }) => s === 0), o = a.comment.length > 0;
  return {
    disabled: i && !o
  };
}, ry = (e) => ny(e), ay = ({ contextToken: e, state: t }) => {
  const n = t == null ? void 0 : t.getState(e, "order_items_selection_input");
  if (n)
    return {
      comment: n.comment,
      order_items: n.items.filter(({ quantity: r }) => r > 0).map(({ id: r, quantity: a }) => ({ id: r, quantity: a }))
    };
}, iy = ({
  component: e,
  contextToken: t,
  state: n,
  telemetry: r
}) => {
  if (e.id !== "request_refund_button")
    return;
  const a = n == null ? void 0 : n.getState(t, "order_items_selection_input");
  if (!a)
    return;
  const i = new Set(
    a == null ? void 0 : a.items.filter((s) => s.quantity > 0).map((s) => s.id)
  ).size, o = Fu(
    a == null ? void 0 : a.items.map((s) => s.quantity)
  );
  r == null || r.sendMissingItemsAppliedEvent({
    missingItemCount: o,
    missingMenuItemCount: i
  });
}, oy = (e) => {
  const { component: t, index: n, telemetry: r } = e;
  t.type === "options_list_item" && (r == null || r.sendInteractionSupportLayerOptionEvent({
    supportLayerOptionListIndex: n,
    supportLayerOptionSlug: t.slug,
    title: t.props.content
  }));
}, sy = (e) => {
  const { component: t, telemetry: n } = e;
  t.type === "csat_button" && (n == null || n.increaseNodeStepCount());
}, ly = {
  order_items_selection_input: ay
}, oa = {
  button: ry
}, uy = {
  button: [iy],
  csat_button: [sy],
  options_list_item: [oy]
}, cy = ({ components: e, contextToken: t, state: n }) => {
  const r = {};
  return e.forEach((a) => {
    const i = ly[a.type];
    ot(a == null ? void 0 : a.inputKey) && Es(i) && (r[a.inputKey] = i({
      contextToken: t,
      state: n
    }));
  }), r;
}, dy = ({
  component: e,
  telemetry: t,
  ...n
}) => {
  const r = t == null ? void 0 : t.getPopulatedProperties(), a = uy[e.type];
  return () => {
    !a || !r || a.forEach((i) => {
      i({
        ...n,
        baseProperties: r,
        component: e,
        telemetry: t
      });
    });
  };
}, fy = (e) => {
  const t = xr(), n = fi(), r = Dn(), a = Nr(), i = a == null ? void 0 : a.getSessionId(), o = t == null ? void 0 : t.peek(), {
    component: s,
    contextToken: l,
    handleAction: u,
    meta: { components: c, index: d }
  } = e, { action: f, type: g } = s, v = oa == null ? void 0 : oa[g], C = dy({
    component: s,
    contextToken: l,
    index: d,
    state: n,
    telemetry: r
  }), A = cy({ components: c, contextToken: l, state: n });
  return {
    additionalComponentProps: {
      ...!Ut(f) && {
        onClick: () => {
          u({
            action: f,
            inputs: A
          }), C();
        }
      },
      ...v == null ? void 0 : v({ component: s, contextToken: l, state: n })
    },
    handleImpressionContactSupport: () => {
      !ot(i) || Ut(o) || r == null || r.sendImpressionContactSupportEvent({
        ...o.telemetry
      });
    },
    makeHandleImpressionSupportLayerOption: ({
      supportLayerOptionListIndex: w,
      title: p
    }) => () => {
      !ot(i) || s.type !== "options_list_item" || Ut(o) || r == null || r.sendImpressionSupportLayerOptionEvent({
        ...o.telemetry,
        supportLayerOptionListIndex: w,
        supportLayerOptionSlug: s.slug,
        title: p
      });
    },
    state: n
  };
}, Eu = (e) => {
  var d;
  const {
    additionalComponentProps: t,
    handleImpressionContactSupport: n,
    makeHandleImpressionSupportLayerOption: r,
    state: a
  } = fy(e), {
    component: i,
    contextToken: o,
    handleAction: s,
    meta: { index: l, prevComponent: u }
  } = e, { type: c } = i;
  if (c === "heading")
    return /* @__PURE__ */ h(yv, { ...i.props, ...t }, i.id);
  if (c === "text_block")
    return /* @__PURE__ */ h(Jv, { ...i.props, ...t }, i.id);
  if (c === "order_info_card") {
    const { order: f } = i.props;
    return /* @__PURE__ */ h(
      ou,
      {
        id: i.id,
        title: f.venueName,
        date: f.formattedDate,
        price: f.formattedPrice,
        ...t
      },
      i.id
    );
  }
  if (c === "image") {
    const { altText: f, ...g } = i.props;
    return /* @__PURE__ */ h(mv, { alt: f, ...g, ...t }, i.id);
  }
  if (c === "back_button")
    return /* @__PURE__ */ h(V1, { ...i.props, ...t }, i.id);
  if (c === "button")
    return /* @__PURE__ */ h(
      xn,
      {
        once: !0,
        onView: ((d = i.action) == null ? void 0 : d.actionId) === "go_to_chat__directive" ? n : void 0,
        children: /* @__PURE__ */ h(su, { ...i.props, ...t }, i.id)
      }
    );
  if (c === "chat_with_support_button")
    return /* @__PURE__ */ h(xn, { once: !0, onView: n, children: /* @__PURE__ */ h(
      lu,
      {
        ...i.props,
        ...t,
        borderPosition: (u == null ? void 0 : u.type) === "options_list" ? "bottom" : void 0
      },
      i.id
    ) });
  if (c === "csat_button")
    return /* @__PURE__ */ h(ov, { ...i.props, ...t }, i.id);
  if (c === "embedded_animation")
    return /* @__PURE__ */ h(cv, { ...i.props, ...t }, i.id);
  if (c === "embedded_image")
    return /* @__PURE__ */ h(hv, { ...i.props, ...t }, i.id);
  if (c === "notification_banner")
    return /* @__PURE__ */ h(_v, { ...i.props, ...t }, i.id);
  if (c === "options_list")
    return /* @__PURE__ */ h(
      iu,
      {
        items: i.children,
        renderItem: (f, g) => /* @__PURE__ */ h(
          Eu,
          {
            component: f,
            handleAction: s,
            meta: {
              ...e.meta,
              index: g
            },
            contextToken: o
          },
          f.id
        ),
        ...t
      },
      i.id
    );
  if (c === "options_list_item") {
    const { content: f } = i.props;
    return /* @__PURE__ */ h(
      xn,
      {
        once: !0,
        onView: r({
          supportLayerOptionListIndex: l,
          title: f
        }),
        children: /* @__PURE__ */ h(
          Br,
          {
            id: i.id,
            label: f,
            ...t
          },
          i.id
        )
      }
    );
  }
  return c === "order_selection_input" ? /* @__PURE__ */ h(
    ty,
    {
      component: i,
      contextToken: o,
      state: a,
      handleAction: s,
      ...t
    },
    i.id
  ) : c === "order_items_selection_input" ? /* @__PURE__ */ h(
    ey,
    {
      component: i,
      contextToken: o,
      state: a,
      ...t
    },
    i.id
  ) : null;
}, hy = ({ components: e, ...t }) => e.map((n, r) => {
  const a = e[r - 1], i = e[r + 1];
  return /* @__PURE__ */ h(
    Eu,
    {
      component: n,
      meta: {
        components: e,
        index: r,
        nextComponent: i,
        prevComponent: a
      },
      ...t
    },
    n.id
  );
}), py = (e) => {
  const t = [...e.main];
  let n = null, r = null, a = 0;
  return t.forEach((i) => {
    !n && i.type === "heading" && // TODO: This check should be removed once the
    // API does not return empty headings
    i.props.content !== "" && (n = i.props.content), !r && i.type === "text_block" && // TODO: This check should be removed once the
    // API does not return empty text blocks
    i.props.content !== "" && (r = i.props.content), !a && i.type === "options_list" && (a = i.children.length);
  }), {
    body: r,
    supportLayerOptionCount: a,
    title: n
  };
}, my = () => {
  const e = xr(), t = e == null ? void 0 : e.peek(), n = (e == null ? void 0 : e.size()) ?? 0, r = Tb(), a = Dn(), i = hi(), o = ({ handleAction: l, ...u }) => {
    const { contextToken: c, pageId: d, slSessionId: f, uiData: g } = u, { isLeafNode: v, main: C, slug: A } = g, k = {
      contextToken: c,
      handleAction: l
    }, R = {
      leafNode: v,
      nodeDepth: n,
      nodeId: d,
      nodeSlug: A,
      supportLayerSessionId: f
    }, y = () => {
      var $, Q;
      const w = Dn(), p = ae(0), B = Vu(), b = ae(!1), S = (($ = w == null ? void 0 : w.getPreviousProperties()) == null ? void 0 : $.nodeStepCount) || 1, O = ((Q = w == null ? void 0 : w.getProperties()) == null ? void 0 : Q.nodeStepCount) || 1, I = () => {
        p.current = Date.now();
      };
      Gu(() => {
        I();
      });
      const P = (Y) => {
        i != null && i.hasBeenShownBefore() && (i == null || i.resetHasBeenShownBefore(), Y -= 1), w == null || w.sendViewEvent({
          ...py(g),
          ...R,
          duration: Date.now() - p.current,
          nodeStepCount: Y,
          renderedAt: p.current,
          supportLayerSessionId: f
        });
      };
      return Yu(() => {
        const Y = B || b.current ? O : S;
        P(Y), b.current && (b.current = !1);
      }), ml(() => {
        P(O);
      }), Jf((Y) => {
        if (Y) {
          I();
          return;
        }
        b.current = !0, P(O);
      }), /* @__PURE__ */ h(hy, { components: C, ...k });
    };
    e == null || e.push({
      contextToken: c,
      page: y,
      pageId: d,
      telemetry: R,
      uiData: g
    });
  };
  return {
    processResponse: (l) => {
      const { contextToken: u, metadata: c, pageId: d, slSessionId: f, uiData: g } = l, { directive: v, isLeafNode: C, slug: A } = g, k = r({
        contextToken: u,
        metadata: c
      });
      o({
        ...l,
        handleAction: k
      }), a == null || a.registerView({
        leafNode: C,
        nodeDepth: n,
        nodeId: d,
        nodeSlug: A,
        supportLayerSessionId: f
      }), v && k({
        action: v
      });
    },
    ...t
  };
}, gy = () => {
  const e = Xl(), { locale: t } = Bt(), n = Fn(t);
  de(() => {
    n !== t && e();
  }, [t, n, e]);
}, by = Kl("start"), vy = Sr("start"), yy = (e) => {
  const { setSessionId: t } = Nr() ?? {}, { locale: n } = Bt(), r = vy(n), { data: a, error: i, isLoading: o } = za(
    r,
    () => by(),
    {
      ...Zl,
      onSuccess: (l) => {
        t == null || t(l.slSessionId), e(l);
      }
    }
  );
  return { data: a, error: i, isReady: !o };
}, _y = () => {
  gy();
  const { page: e, pageId: t, processResponse: n } = my(), { error: r, isReady: a } = yy(n), { error: i } = Eb(n), o = r ?? i;
  return vb(o), {
    error: o,
    isError: !!o,
    isReady: a,
    page: e,
    pageId: t
  };
}, ms = ({ direction: e, isRtl: t, values: [n, r] }) => t ? e === "forwards" ? r : n : e === "forwards" ? n : r, gs = {
  enterBase: [0.2, 0.6, 0.4, 1],
  exitBase: [0.5, 0, 0.7, 0.2]
}, Ey = {
  center: {
    opacity: 1,
    x: 0
  },
  enter: ({ direction: e, isRtl: t }) => ({
    opacity: 0,
    transition: {
      opacity: {
        delay: 0.3,
        duration: 0.2
      },
      x: {
        ease: gs.enterBase
      }
    },
    x: ms({ direction: e, isRtl: t, values: ["30%", "-30%"] })
  }),
  exit: ({ direction: e, isRtl: t }) => ({
    opacity: 0,
    transition: {
      opacity: {
        delay: 0.1,
        duration: 0.2
      },
      x: {
        ease: gs.exitBase
      }
    },
    x: ms({ direction: e, isRtl: t, values: ["-30%", "30%"] })
  })
}, Sy = {
  opacity: { ease: "linear" },
  x: { duration: 0.3 }
}, Ty = {
  animate: "center",
  exit: "exit",
  initial: "enter",
  transition: Sy,
  variants: Ey
}, wy = () => ({
  $maxWidth: e
}) => z(e), Cy = /* @__PURE__ */ M("div")({
  name: "Root",
  class: "support-layer-Layout_Root_r1v88s1s",
  propsAsIs: !1,
  vars: {
    "r1v88s1s-0": [wy()]
  }
}), Iy = ({
  children: e,
  maxWidth: t = 520,
  ...n
}) => {
  const r = kr() === "rtl", a = pi(), i = {
    ...Ty,
    custom: {
      direction: (a == null ? void 0 : a.direction) ?? "forwards",
      isRtl: r
    }
  };
  return /* @__PURE__ */ h(Cy, {
    $maxWidth: t,
    children: /* @__PURE__ */ h(Be.div, {
      className: "support-layer__main",
      ...i,
      ...n,
      "aria-live": "polite",
      children: e
    })
  });
}, Ry = /* @__PURE__ */ M("div")({
  name: "SupportLayerRoot",
  class: "support-layer-SupportLayer_SupportLayerRoot_s115mgqr",
  propsAsIs: !1
}), ky = ({
  className: e,
  loadingFallback: t,
  maxWidth: n,
  ...r
}) => {
  const {
    isReady: a,
    page: i,
    pageId: o
  } = _y(), s = hi();
  return !a || !Wt(s) || !i ? t ?? null : /* @__PURE__ */ V(Ry, {
    className: re(e, "support-layer"),
    ...r,
    children: [/* @__PURE__ */ h(mb, {
      ...s.csatModalProps
    }), /* @__PURE__ */ h(It, {
      mode: "wait",
      children: /* @__PURE__ */ h(Iy, {
        maxWidth: n,
        children: /* @__PURE__ */ h(i, {})
      }, o)
    })]
  });
}, Zy = (e) => /* @__PURE__ */ h(fb, { children: /* @__PURE__ */ h(ky, { ...e }) });
export {
  Zy as SupportLayerPage,
  Ky as SupportLayerProvider
};
//# sourceMappingURL=index.js.map
